var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDroneStationSpec1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 684,
    height: 296,
    viewBox: "0 0 684 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6840_18154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.182 186.434C173.182 186.434 173.182 186.515 173.182 186.568C173.182 187.346 173.182 188.15 173.262 188.901C173.262 188.901 173.262 188.901 173.262 188.928C173.584 194.533 175.06 199.601 177.234 203.409C179.006 206.01 181.18 207.539 183.515 207.539C186.762 207.539 189.688 204.562 191.701 199.842C193.043 196.115 193.875 191.422 193.875 186.327V186.381C193.875 181.285 193.069 176.593 191.701 172.865C189.688 168.146 186.762 165.169 183.515 165.169C181.18 165.169 179.006 166.697 177.234 169.299C175.034 173.107 173.584 178.175 173.262 183.779C173.262 183.779 173.262 183.779 173.262 183.806C173.208 184.584 173.208 185.362 173.182 186.139C173.182 186.193 173.182 186.22 173.182 186.273",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.182 186.434C173.182 186.434 173.182 186.515 173.182 186.568C173.182 187.346 173.182 188.15 173.262 188.901C173.262 188.901 173.262 188.901 173.262 188.928C173.584 194.533 175.06 199.601 177.234 203.409C179.006 206.01 181.18 207.539 183.515 207.539C186.762 207.539 189.688 204.562 191.701 199.842C193.043 196.115 193.875 191.422 193.875 186.327V186.381C193.875 181.285 193.069 176.593 191.701 172.865C189.688 168.146 186.762 165.169 183.515 165.169C181.18 165.169 179.006 166.697 177.234 169.299C175.034 173.107 173.584 178.175 173.262 183.779C173.262 183.779 173.262 183.779 173.262 183.806C173.208 184.584 173.208 185.362 173.182 186.139C173.182 186.193 173.182 186.22 173.182 186.273",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.662 169.701C186.306 170.291 187.862 171.9 188.533 174.26C188.533 174.26 188.855 175.226 188.372 175.923C188.372 175.923 187.889 176.754 187.245 176.62C187.245 176.62 184.83 176.245 183.488 171.766C183.488 171.766 183.38 171.471 183.568 171.257C183.568 171.257 183.729 170.265 184.078 169.701C184.132 169.621 184.212 169.567 184.32 169.514C184.561 169.433 185.205 169.38 185.688 169.728L185.662 169.701Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.219 176.62L187.836 176.727C187.836 176.727 189.097 177.934 189.097 179.114L189.017 179.543",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.788 173.804C190.976 174.796 190.171 175.681 190.171 175.681L188.292 177.209C188.292 177.209 187.702 177.263 186.387 176.271",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.407 171.632C183.407 171.632 181.394 170.908 179.73 172.276C179.73 172.276 178.496 173.59 178.066 174.367",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.221 171.74C179.221 171.74 180.616 170.962 181.824 170.962C181.824 170.962 182.898 170.828 183.542 171.23",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.615 169.46C184.615 169.46 185.367 168.736 185.608 167.958",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.318 173.724C188.318 173.724 189.714 174.448 190.573 173.375",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.855 186.515C192.855 191.074 192.211 195.257 191.11 198.609C189.473 202.819 187.111 205.474 184.481 205.474C182.576 205.474 180.831 204.106 179.382 201.773C177.61 198.368 176.429 193.836 176.161 188.821C176.161 188.821 176.161 188.821 176.161 188.794C176.134 188.097 176.107 187.4 176.107 186.703C176.107 186.676 176.107 186.622 176.107 186.595C176.107 186.569 176.107 186.515 176.107 186.488C176.107 185.791 176.107 185.094 176.161 184.396C176.161 184.396 176.161 184.396 176.161 184.37C176.429 179.355 177.61 174.823 179.382 171.417C180.831 169.084 182.576 167.717 184.481 167.717C187.111 167.717 189.5 170.372 191.11 174.582C192.211 177.934 192.855 182.117 192.855 186.676",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.945 191.262C184.879 191.262 185.636 189.173 185.636 186.596C185.636 184.019 184.879 181.93 183.945 181.93C183.011 181.93 182.254 184.019 182.254 186.596C182.254 189.173 183.011 191.262 183.945 191.262Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.621 186.595C187.621 187.104 187.621 187.426 187.621 187.426C187.702 188.982 187.89 191.207 188.561 192.387L189.017 193.621C189.017 193.621 190.359 193.862 190.359 192.548C190.359 192.548 190.654 190.108 190.761 187.399C190.761 187.399 190.788 186.836 190.761 186.568C190.761 186.3 190.761 185.737 190.761 185.737C190.654 183.028 190.359 180.588 190.359 180.588C190.359 179.274 189.017 179.515 189.017 179.515L188.561 180.749C187.917 181.929 187.702 184.181 187.621 185.71C187.621 185.71 187.594 186.032 187.621 186.541V186.595Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.662 203.49C186.306 202.9 187.862 201.291 188.533 198.931C188.533 198.931 188.855 197.966 188.372 197.268C188.372 197.268 187.889 196.437 187.245 196.571C187.245 196.571 184.83 196.947 183.488 201.425C183.488 201.425 183.38 201.72 183.568 201.935C183.568 201.935 183.729 202.927 184.078 203.49C184.132 203.57 184.212 203.624 184.32 203.678C184.561 203.758 185.205 203.812 185.688 203.463L185.662 203.49Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.219 196.571L187.836 196.464C187.836 196.464 189.097 195.257 189.097 194.078L189.017 193.648",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.788 199.387C190.976 198.394 190.171 197.51 190.171 197.51L188.292 195.981C188.292 195.981 187.702 195.927 186.387 196.92",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.407 201.559C183.407 201.559 181.394 202.283 179.73 200.915C179.73 200.915 178.496 199.601 178.066 198.823",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.221 201.451C179.221 201.451 180.616 202.229 181.824 202.229C181.824 202.229 182.898 202.363 183.542 201.961",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.615 203.731C184.615 203.731 185.367 204.455 185.608 205.233",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.318 199.467C188.318 199.467 189.714 198.743 190.573 199.816",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.998 54.5518V54.7663V54.9808L624.374 55.4099L625.152 59.4055L629.259 96.3582L630.627 133.499V133.526L629.259 170.612L625.125 207.565L624.374 211.614",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.232 45.3809C625.232 45.3809 623.809 47.3384 624.561 50.5564L625.581 54.7934V55.3029C625.581 55.3029 627.433 64.8226 628.56 73.8329C628.56 73.8329 632.13 99.6569 631.861 132.775V133.526V136.717L631.807 141.597L631.593 151.305L631.324 158.84L631.002 165.947L630.573 172.838L630.09 179.435L629.499 185.549L628.963 190.698L628.318 195.579L627.674 200.245L627.084 204.079L626.44 207.753L626.225 208.665L626.064 209.63L625.688 211.641",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.92 56.375L616.322 95.3121L617.771 134.491L616.322 173.642L611.92 212.579",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.002 56.4287L612.404 95.339L613.853 134.464V134.491L612.404 173.589L608.002 212.472",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.129 213.947L609.745 174.688L611.812 134.41L609.745 94.1052L605.129 54.873",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.668 229.313C100.234 222.1 95.2419 212.392 92.1554 202.604C86.4118 181.527 84.1305 155.971 85.0967 134.196C84.3721 111.054 86.2776 84.0499 93.7121 62.007C95.8592 56.161 98.8115 50.4224 102.542 45.4346C103.857 43.5842 105.79 41.573 107.373 39.9104L107.856 39.4814L109.145 38.3014C109.198 38.221 109.198 38.1942 109.198 38.0869H109.145",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8473 209.389C80.4805 185.898 80.1316 157.151 80.1316 134.545C80.1316 111.939 80.4805 83.1916 89.8473 59.7006C90.5451 58.2257 92.2896 54.4446 93.1753 53.1038C93.9 51.5484 92.7728 50.3149 91.0819 50.9585C88.1296 51.9507 82.6813 53.077 79.3264 54.3105C77.2598 55.0614 76.6425 55.705 75.4616 57.153C71.5967 63.5085 68.215 76.7557 67.5709 80.6977C64.5649 96.4924 64.4307 114.54 64.5918 134.545C64.4307 154.55 64.5381 172.57 67.5709 188.392C68.215 192.334 71.5967 205.608 75.4616 211.936C76.6425 213.384 77.2598 214.028 79.3264 214.779C82.6813 216.012 88.1296 217.139 91.0819 218.131C92.7459 218.774 93.8732 217.541 93.1753 215.985C92.3165 214.645 90.572 210.837 89.8473 209.389Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4459 134.517C81.4459 111.858 81.3654 72.5718 96.5026 48.5713L80.5065 52.9155C78.4936 53.4787 76.8027 54.2295 75.3534 55.5435C74.7898 56.053 74.3604 56.6698 74.0115 57.3402C63.0611 79.4904 63.1416 107.299 63.1416 134.544C63.1416 161.789 63.0343 189.598 74.0115 211.748C74.3335 212.418 74.7898 213.035 75.3534 213.545C76.8027 214.859 78.4936 215.609 80.5065 216.173L96.5026 220.517C81.3654 196.49 81.419 157.231 81.4459 134.571V134.517Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72032 135.242C4.33762 143.072 5.94797 170.291 6.69946 175.413C8.06825 182.09 10.94 189.035 15.7711 193.916V193.862L15.8247 193.808H15.8784C15.8784 193.808 16.0394 193.969 16.0931 194.023L16.2542 193.969C16.2542 193.969 16.3615 193.782 16.4152 193.755C16.5762 193.192 16.5225 192.387 16.4689 191.797C16.0931 188.258 15.0196 182.331 14.617 178.791C13.1408 168.199 12.2551 157.07 11.8526 146.397C11.7184 143.608 11.3158 134.491 11.3158 134.491C11.3158 134.491 11.7184 125.373 11.8526 122.585C12.2551 111.912 13.1677 100.783 14.617 90.1906C15.0196 86.6509 16.0663 80.7513 16.4689 77.1847C16.5225 76.6216 16.5494 75.8171 16.4152 75.2271C16.3615 75.2003 16.281 75.0663 16.2542 75.0126L16.0931 74.959C16.0931 74.959 15.9321 75.1199 15.8784 75.1735H15.8247L15.7711 75.1199V75.0663C10.9132 79.9468 8.04141 86.919 6.69946 93.5694C5.9748 98.6645 4.33762 125.883 3.72032 133.74C3.69349 134.223 3.69349 134.706 3.72032 135.215V135.242Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.453 95.6339C247.124 94.2394 247.205 92.4427 247.205 90.9142C247.312 87.9912 247.312 74.6368 247.205 71.7138C247.205 70.1853 247.097 68.3886 246.453 66.9941",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.691 66.1093C248.816 66.4579 243.689 66.6993 254.801 63.0791",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.773 99.6021C243.662 95.0969 248.788 95.4187 235.664 95.8478",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.625 94.963C233.679 85.8455 233.679 76.8353 233.625 67.7178",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.244 95.1237V67.5566",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 60.8262L214.38 65.3313C215.373 65.5995 221.412 67.9593 222.351 67.557C226.592 67.5034 231.127 67.7448 235.368 67.7179",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 101.828L214.38 97.3233C215.373 97.0551 221.412 94.6953 222.351 95.0975C226.592 95.1512 231.127 94.9098 235.368 94.9367",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.517 101.023C233.517 101.023 228.471 101.158 227.398 101.506L224.955 102.445C224.767 102.525 224.606 102.606 224.445 102.713C223.935 103.062 222.835 103.786 222.835 103.786C221.09 104.617 218.46 104.858 216.555 105.019C214.649 105.234 212.475 105.314 210.543 105.287C206.678 105.287 202.088 104.59 202.088 104.59C201.122 104.375 199.995 104 199.27 103.276C198.868 102.793 198.438 102.069 198.197 101.479C198.197 101.479 196.613 99.6827 196.613 97.0815V65.492C196.613 62.8908 198.197 61.0941 198.197 61.0941C198.465 60.531 198.895 59.807 199.27 59.2974C199.995 58.6002 201.122 58.2248 202.088 57.9834C202.088 57.9834 206.678 57.2594 210.543 57.2862C212.475 57.2594 214.676 57.3399 216.555 57.5544C218.487 57.7153 221.09 57.9566 222.835 58.7879C222.835 58.7879 223.935 59.512 224.445 59.8606C224.606 59.9679 224.767 60.0751 224.955 60.1287L227.398 61.0673C228.471 61.4159 233.517 61.55 233.517 61.55",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.418 59.8877L224.633 59.2977C224.821 58.9223 225.196 58.6005 225.599 58.6005C226.163 58.5469 231.396 58.2519 233.006 58.1982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.418 102.767L224.633 103.357C224.821 103.732 225.196 104.054 225.599 104.054C226.163 104.107 231.396 104.402 233.006 104.456",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.458 60.3167C251.392 58.0641 248.198 57.796 245.326 57.5278C242.938 57.2328 235.637 57.1792 234.403 57.4205C233.678 57.5814 233.088 57.8764 232.9 58.4932C232.47 59.834 233.705 61.6575 234.188 62.8374C234.859 63.9637 235.208 65.7604 235.315 67.0744C235.476 71.4186 235.449 76.4869 235.423 81.287C235.423 81.287 235.423 81.3138 235.423 81.3406C235.423 81.3406 235.423 81.3674 235.423 81.3942C235.423 86.2212 235.449 91.2626 235.315 95.6068C235.181 96.894 234.859 98.6907 234.188 99.8438C233.705 101.024 232.47 102.847 232.9 104.188C233.061 104.805 233.651 105.1 234.403 105.261C235.637 105.529 242.938 105.448 245.326 105.153C248.198 104.885 251.365 104.617 253.458 102.365C255.069 100.756 256.035 98.4762 256.008 96.1968V66.5381C256.008 64.2587 255.069 61.9793 253.458 60.3703V60.3167Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.453 146.505C247.124 145.111 247.205 143.314 247.205 141.785C247.312 138.862 247.312 125.508 247.205 122.585C247.205 121.056 247.097 119.26 246.453 117.865",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.691 116.98C248.816 117.329 243.689 117.57 254.801 113.95",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.773 150.447C243.662 145.942 248.788 146.263 235.664 146.693",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.625 145.808C233.679 136.69 233.679 127.68 233.625 118.562",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.244 145.968V118.401",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 111.697L214.38 116.202C215.373 116.471 221.412 118.83 222.351 118.428C226.592 118.374 231.127 118.616 235.368 118.589",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 152.7L214.38 148.194C215.373 147.926 221.412 145.566 222.351 145.969C226.592 146.022 231.127 145.781 235.368 145.808",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.517 151.868C233.517 151.868 228.471 152.002 227.398 152.351L224.955 153.289C224.767 153.37 224.606 153.45 224.445 153.558C223.935 153.906 222.835 154.63 222.835 154.63C221.09 155.462 218.46 155.703 216.555 155.864C214.649 156.078 212.475 156.159 210.543 156.132C206.678 156.132 202.088 155.435 202.088 155.435C201.122 155.22 199.995 154.845 199.27 154.121C198.868 153.638 198.438 152.914 198.197 152.324C198.197 152.324 196.613 150.527 196.613 147.926V116.337C196.613 113.736 198.197 111.939 198.197 111.939C198.465 111.376 198.895 110.652 199.27 110.142C199.995 109.445 201.122 109.07 202.088 108.828C202.088 108.828 206.678 108.104 210.543 108.131C212.475 108.104 214.676 108.185 216.555 108.399C218.487 108.56 221.09 108.801 222.835 109.633C222.835 109.633 223.935 110.357 224.445 110.705C224.606 110.813 224.767 110.92 224.955 110.973L227.398 111.912C228.471 112.261 233.517 112.395 233.517 112.395",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.418 110.759L224.633 110.169C224.821 109.793 225.196 109.472 225.599 109.472C226.163 109.418 231.396 109.123 233.006 109.069",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.418 153.638L224.633 154.228C224.821 154.603 225.196 154.925 225.599 154.925C226.163 154.979 231.396 155.273 233.006 155.327",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.458 111.188C251.392 108.935 248.198 108.667 245.326 108.399C242.938 108.104 235.637 108.05 234.403 108.292C233.678 108.453 233.088 108.748 232.9 109.364C232.47 110.705 233.705 112.529 234.188 113.709C234.859 114.835 235.208 116.631 235.315 117.945C235.476 122.29 235.449 127.358 235.423 132.158C235.423 132.158 235.423 132.185 235.423 132.212C235.423 132.212 235.423 132.239 235.423 132.265C235.423 137.092 235.449 142.134 235.315 146.478C235.181 147.765 234.859 149.562 234.188 150.715C233.705 151.895 232.47 153.718 232.9 155.059C233.061 155.676 233.651 155.971 234.403 156.132C235.637 156.4 242.938 156.319 245.326 156.024C248.198 155.756 251.365 155.488 253.458 153.236C255.069 151.627 256.035 149.347 256.008 147.068V117.409C256.008 115.13 255.069 112.85 253.458 111.241V111.188Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.668 54.9805V172.275",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.121 54.9004V163.318",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.037 50.6631H258.342V54.9269H271.037V50.6631Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.064 214.162H258.369V218.453H271.064V214.162Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.257 36.3975C112.257 36.3975 112.123 36.5315 112.15 36.612C133.916 37.9796 156.461 40.6076 178.013 43.8792C177.986 44.2546 178.442 45.0859 178.55 45.7295C178.711 46.5608 177.906 47.7944 177.745 48.5988",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.927 108.479V108.64C116.82 108.828 116.605 109.015 116.444 109.122C115.934 109.203 113.304 109.659 112.821 109.712C112.445 109.847 112.015 109.686 111.854 109.337C111.801 109.042 111.801 108.64 111.801 108.372L112.66 93.5691L114.807 78.9006L118.215 64.4735C118.269 64.2858 118.403 63.9372 118.591 63.8299C119.128 63.6422 120.819 63.5081 121.409 63.4008C121.57 63.374 121.812 63.4545 121.946 63.5081C121.973 63.5617 122.026 63.7226 122.053 63.7763C119.101 78.3643 117.786 93.6227 116.954 108.452L116.927 108.479Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1426 32.9643C62.0412 31.5162 65.4498 30.2559 68.4557 29.1296C70.3613 28.5665 75.8901 28.2715 75.8901 28.2715L75.9438 28.3251V28.5128",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6338 33.5282C56.7541 32.536 60.3773 31.1147 62.5513 30.2298C64.5106 29.6935 66.604 29.2644 68.6169 29.1035",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.112 40.8221C178.254 40.2322 147.335 36.612 142.853 35.6198C141.78 35.3516 140.599 34.8689 139.606 34.3862L138.693 33.8499C138.693 33.8499 138.398 33.7426 138.264 33.7158",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.226 33.581C124.712 32.6424 119.505 31.8916 109.172 38.0861",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.592 40.8223H263.416L263.577 40.8759L263.684 40.9832L263.738 41.0904V43.5843V41.0904V49.1085L263.684 49.2694L263.577 49.4303H263.416H260.866L257.645 49.3766",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.138 26.502L430.031 26.5824L429.977 26.7701L429.924 42.404L429.655 43.2353L263.736 43.5034L263.79 27.3601L263.629 27.0919",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.487 40.8223C200.53 41.0904 240.171 40.8491 257.59 40.8223L257.644 49.3766C242.211 49.2694 226.591 48.8671 211.185 47.9554C205.656 47.5531 199.993 47.1241 194.491 46.6146C189.607 46.0782 183.622 45.1933 178.764 44.3352C178.764 44.2547 178.764 44.0938 178.764 44.0134C179.945 42.7262 181.528 41.5463 183.112 40.8223H183.487Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8799 45.5414C47.8173 45.6219 91.4576 41.5994 101.227 41.1436",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4463 59.8348C33.5119 56.4291 40.7048 54.552 47.3877 52.8358C62.2834 49.1887 83.5936 45.5417 98.6771 42.4847C100.18 42.002 101.468 40.8489 102.837 40.1517C104.77 39.079 107.024 38.3818 109.171 38.0332",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7715 75.1197V74.8515L16.1472 72.304C16.1472 72.304 16.2546 71.9285 16.4156 71.4727",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.841 45.0586C30.5866 46.6139 28.4931 48.6251 26.5875 50.7436C26.4265 50.9581 26.2386 51.1727 26.0508 51.3872C24.7625 52.9425 23.7426 54.4711 22.9374 56.1069C20.6293 60.9338 18.2943 66.4579 16.4424 71.4994C17.5159 69.944 18.9116 68.4959 20.173 67.1015C22.6422 64.3394 26.185 61.4701 28.4663 58.6008C33.7536 52.299 38.2357 44.844 45.0528 40.0439C40.8659 41.3043 36.5985 42.7524 32.8679 45.0586H32.841Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0254 40.0433C45.0254 40.0433 45.0788 40.0433 45.1056 40.0433L45.2124 39.9365C45.2124 39.9365 45.1056 40.0166 45.0254 40.07V40.0433Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2139 39.91C47.9514 38.1938 51.0916 37.2016 54.2049 36.4507C71.5967 34.0909 120.578 31.4897 137.513 31.4629",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8262 32.2939C69.2884 30.819 73.1264 29.3441 76.7228 28.2714C79.0578 28.0569 81.5807 27.7887 83.9425 27.6815C91.6722 27.172 99.5629 26.7429 107.319 26.6088C115.72 26.3407 124.282 26.2334 132.682 26.2334C136.252 26.2334 140.063 26.3943 143.633 26.5016C145.243 26.6356 147.095 27.3329 148.705 27.8424",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.701 29.2373L108.822 29.9345L107.748 29.9882L64.2155 32.3748L54.3387 33.5547L46.3675 34.7346C38.0474 35.7536 29.3784 37.9258 23.1249 43.7717C19.3943 47.3383 16.5225 51.9238 14.2949 56.563C10.9132 63.2134 7.96087 70.5075 6.21633 77.7478C6.21633 77.7478 5.94794 77.9356 5.57219 79.2227C4.55231 82.3602 4.3376 88.7693 3.98869 92.0141C3.5861 97.6187 3.02248 103.625 2.59306 109.23C1.68053 117.221 1.3853 125.776 1.49266 134.518H1.46582",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.603 29.4787C183.972 29.6664 235.771 29.72 245.165 29.8809C245.97 29.8809 246.775 30.015 247.553 30.2831C249.54 30.9804 251.445 32.1335 252.492 34.0106C253.055 35.0028 253.512 36.1827 253.485 37.309C253.297 38.1135 252.304 38.4085 251.579 38.5425C250.103 38.9448 248.385 38.9716 246.856 39.0789C233.892 39.2129 211.858 39.0252 198.948 39.0789C191.326 39.2129 183.193 38.4621 175.652 37.3894C162.769 35.9145 149.162 34.4397 136.252 33.5547C136.413 33.1257 136.493 32.1871 137.164 32.5357C137.862 31.6239 137.218 30.2563 137.594 29.2909L137.701 29.2373C139.07 29.2909 142.666 29.3446 147.471 29.3982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.603 239.583C183.972 239.395 235.771 239.342 245.165 239.181C245.97 239.181 246.775 239.047 247.553 238.779C249.54 238.081 251.445 236.928 252.492 235.051C253.055 234.059 253.512 232.879 253.485 231.753C253.297 230.948 252.304 230.653 251.579 230.519C250.103 230.117 248.385 230.09 246.856 229.983C233.892 229.849 211.858 230.037 198.948 229.983C191.326 229.849 183.193 230.6 175.652 231.672C162.769 233.147 149.162 234.622 136.252 235.507C136.413 235.936 136.493 236.875 137.164 236.526C137.862 237.438 137.218 238.805 137.594 239.771L137.701 239.824C139.07 239.771 142.666 239.717 147.471 239.664",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.887 30.0957C146.45 30.6857 146.746 31.1684 147.39 31.3024L158.152 31.946L157.052 30.2566",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.887 30.0951C146.853 29.8806 147.819 29.2638 148.383 28.5666L148.597 28.1911C148.893 27.1989 148.946 26.0458 148.92 25",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.227 4.75359H159.28L159.656 4.53906H159.71L161.588 5.39718",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.883 22.2921C157.883 22.2921 157.883 22.2117 157.91 22.1849C158.984 17.8138 160.943 10.7075 161.855 6.36329C161.829 6.01468 161.99 5.53199 161.587 5.37109C158.715 6.81917 158.259 10.788 157.373 13.6841C156.702 16.3389 155.226 22.2385 154.663 24.786C154.663 25.0274 154.448 25.5369 154.824 25.4833L155.683 25.1615C155.683 25.1615 155.897 25.0542 156.005 24.9737L157.132 24.1424C157.132 24.1424 157.347 23.9279 157.4 23.7938L157.91 22.2653L157.883 22.2921Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.887 30.0957L144.545 30.2566L145.618 33.3941C145.699 33.6086 145.887 33.7695 146.128 33.7963C151.469 34.2254 157.857 34.869 163.171 35.3517C163.279 35.3517 163.332 35.2176 163.252 35.1372L158.448 30.498L157.025 30.2298C154.663 29.4521 154.287 27.6286 154.905 25.4297",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.717 25.51C152.945 25.9391 150.852 25.4296 149.107 25.0273",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.225 4.75387C159.359 4.51252 159.332 4.29799 159.225 4.08346C159.037 3.73485 156.863 1.72363 156.514 1.72363L155.494 1.77727C154.877 1.8309 154.582 2.25996 154.582 2.25996C153.052 3.97619 151.361 7.19414 150.18 9.25899C149.858 9.82213 149.67 10.4389 149.483 11.0557C149.241 11.7797 149.026 12.5306 148.838 13.2814C148.624 14.1127 148.409 14.9708 148.194 15.8021C147.631 18.1888 146.906 21.4335 146.718 23.8738C146.718 23.8738 146.691 24.0347 146.879 24.2493C147.121 24.5174 147.55 24.6515 147.792 24.7319C149.107 25.2146 150.637 25.161 151.683 24.2493C152.381 23.847 152.623 21.7553 152.864 21.0581C154.045 16.9284 155.253 10.7875 156.944 7.08688C156.944 7.08688 157.239 6.57737 157.373 6.33602C157.776 5.71925 158.876 4.4857 159.198 4.75387",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.887 238.967C146.45 238.377 146.746 237.894 147.39 237.76L158.152 237.116L157.052 238.806",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.887 238.967C146.853 239.181 147.819 239.798 148.383 240.495L148.597 240.871C148.893 241.863 148.946 243.016 148.92 244.062",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.227 264.308H159.28L159.656 264.522H159.71L161.588 263.664",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.883 246.77C157.883 246.77 157.883 246.851 157.91 246.878C158.984 251.249 160.943 258.355 161.855 262.699C161.829 263.048 161.99 263.53 161.587 263.691C158.715 262.243 158.259 258.274 157.373 255.378C156.702 252.723 155.226 246.824 154.663 244.276C154.663 244.035 154.448 243.525 154.824 243.579L155.683 243.901C155.683 243.901 155.897 244.008 156.005 244.089L157.132 244.92C157.132 244.92 157.347 245.134 157.4 245.269L157.91 246.797L157.883 246.77Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.887 238.967L144.545 238.806L145.618 235.669C145.699 235.454 145.887 235.293 146.128 235.266C151.469 234.837 157.857 234.194 163.171 233.711C163.279 233.711 163.332 233.845 163.252 233.925L158.448 238.565L157.025 238.833C154.663 239.61 154.287 241.434 154.905 243.633",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.717 243.553C152.945 243.123 150.852 243.633 149.107 244.035",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.225 264.309C159.359 264.55 159.332 264.764 159.225 264.979C159.037 265.328 156.863 267.339 156.514 267.339L155.494 267.285C154.877 267.232 154.582 266.802 154.582 266.802C153.052 265.086 151.361 261.868 150.18 259.803C149.858 259.24 149.67 258.624 149.483 258.007C149.241 257.283 149.026 256.532 148.838 255.781C148.624 254.95 148.409 254.092 148.194 253.26C147.631 250.874 146.906 247.629 146.718 245.189C146.718 245.189 146.691 245.028 146.879 244.813C147.121 244.545 147.55 244.411 147.792 244.331C149.107 243.848 150.637 243.901 151.683 244.813C152.381 245.215 152.623 247.307 152.864 248.004C154.045 252.134 155.253 258.275 156.944 261.976C156.944 261.976 157.239 262.485 157.373 262.726C157.776 263.343 158.876 264.577 159.198 264.309",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.511 44.7373C149.511 44.7373 150.504 48.4379 145.136 48.0893C145.136 48.0893 138.48 47.9016 131.582 46.534C131.582 46.534 123.074 44.8446 113.708 42.4043C113.708 42.4043 109.44 50.3151 106.998 57.9309C106.998 57.9309 106.89 58.1454 107.105 58.2259L107.508 58.3331C107.508 58.3331 103.133 70.6418 100.905 92.1752C100.905 92.1752 98.5435 111.966 98.7313 134.545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.741 44.1475H110.513C110.513 44.1475 106.863 52.0582 105.387 56.9924C105.387 56.9924 101.764 62.0339 101.12 64.7691C101.093 64.9032 101.066 65.0641 101.066 65.1982V71.5L98.3015 87.1607L98.8919 87.5897L97.9794 94.1865C97.9794 94.1865 97.4426 94.5351 97.3889 94.991C97.3889 94.991 95.8591 113.065 95.6712 118.509L95.4297 125.24C95.4297 125.24 95.6176 125.776 95.9396 125.991V130.576",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4238 134.517C92.558 64.8757 108.393 41.4651 108.393 41.4651L109.145 41.3311H109.467C136.359 42.5378 178.47 48.6251 178.47 48.6251",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3496 134.518V131.434L95.779 131.112L96.0743 131.059V134.518H95.3496Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3496 131.434L95.5912 130.951L95.9669 130.549L96.1548 130.844L95.8327 131.032L95.3496 131.434Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.707 109.82C138.881 109.606 146.96 109.257 148.141 109.552C149.053 110.035 150.798 114.084 151.2 114.915L151.227 115.022C151.227 115.237 151.173 115.425 151.012 115.559C150.69 115.773 141.109 115.907 139.311 115.612C138.962 115.612 136.895 111.295 136.546 110.732C136.466 110.598 136.358 110.356 136.385 110.196C136.385 110.196 136.358 109.874 136.707 109.82Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.539 109.874C118.539 109.874 138.99 107.863 147.444 107.809C151.873 107.755 156.409 107.675 160.783 108.345C162.501 110.571 164.138 113.253 165.078 115.881C165.078 115.881 165.614 117.49 165.668 117.677H165.641C165.722 117.972 165.239 117.811 165.239 117.811C162.877 116.873 129.355 117.731 118.109 117.463C118.109 117.463 118.217 112.314 118.539 109.874ZM118.539 109.874C118.485 110.33 118.485 109.874 118.485 109.874H118.539Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.509 109.123C155.173 109.15 157.051 109.176 158.716 109.391C158.716 109.391 159.011 109.391 159.36 109.927C159.843 110.624 160.541 111.644 160.943 112.421C161.534 113.44 162.151 114.701 162.473 115.827C162.5 115.961 162.419 115.934 162.419 115.934C160.809 115.854 159.011 115.854 157.374 115.773C157.213 115.773 157.051 115.693 156.944 115.585C156.568 115.156 156.3 114.245 156.085 113.869C155.387 112.368 154.072 110.705 153.214 109.31C153.214 109.31 153.026 109.042 153.536 109.096L153.509 109.123Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.729 108.05C160.112 92.4161 158.367 61.4433 157.32 45.7559",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.614 47.124C134.48 52.5141 130.132 94.1328 131.367 98.4234C131.877 102.07 133.836 105.503 136.627 107.89C137.272 107.863 138.184 107.755 138.855 107.675C136.064 105.315 133.97 102.044 133.38 98.4234C132.145 94.2669 136.037 52.5677 136.144 47.3922L134.614 47.124Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.908 117.892H145.163L153.832 117.838H156.22C156.22 117.838 158.099 125.025 158.099 134.518",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.809 108.372L161.346 108.453C161.346 108.453 165.103 112.797 166.445 118.053L165.801 118.428L165.72 118.16C165.72 118.16 159.655 117.382 157.293 117.758C157.293 117.758 159.118 126.446 159.118 134.491",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.857 121.217L158.126 120.573C158.126 120.573 162.42 120.654 163.279 120.815L163.574 121.351V121.726C163.574 121.726 164.648 126.768 164.648 134.544",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.628 134.518L159.145 124.649C159.145 124.649 159.145 124.328 159.493 124.328H162.983C162.983 124.328 163.439 124.167 163.492 125.186C163.492 125.186 164.029 128.806 164.029 134.491",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.062 134.518C167.062 73.7791 179.167 51.1731 179.167 51.1731C178.603 50.7172 179.113 50.1004 179.113 50.1004C179.489 49.135 178.791 48.7864 178.791 48.7864C178.442 48.7864 178.469 48.411 178.469 48.411L179.194 46.3193L181.26 46.6411C181.26 46.6411 183.166 47.0434 181.851 49.1887L181.314 50.6904C181.314 50.6904 168.941 70.7757 168.941 134.545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.006 48.9199L181.878 49.1613",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.221 49.4033L181.69 49.6178",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.689 49.5906C181.689 49.5906 182.924 49.671 183.273 46.3995C183.273 46.3995 183.273 45.8899 184.239 46.1045C184.239 46.1045 195.27 48.7325 218.03 49.1883L258.369 50.6632",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.26 50.6904L194.679 52.4603L258.341 54.9006",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.257 232.665C112.257 232.665 112.123 232.531 112.15 232.451C133.916 231.083 156.461 228.455 178.013 225.184C177.986 224.808 178.442 223.977 178.55 223.333C178.711 222.502 177.906 221.268 177.745 220.464",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.927 160.583V160.422C116.82 160.235 116.605 160.047 116.444 159.94C115.934 159.859 113.304 159.403 112.821 159.35C112.445 159.216 112.015 159.377 111.854 159.725C111.801 160.02 111.801 160.422 111.801 160.691L112.66 175.493L114.807 190.162L118.215 204.589C118.269 204.776 118.403 205.125 118.591 205.232C119.128 205.42 120.819 205.554 121.409 205.661C121.57 205.688 121.812 205.608 121.946 205.554C121.973 205.5 122.026 205.34 122.053 205.286C119.101 190.698 117.786 175.44 116.954 160.61L116.927 160.583Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1426 236.098C62.0412 237.546 65.4498 238.806 68.4557 239.932C70.3613 240.496 75.8901 240.79 75.8901 240.79L75.9438 240.737V240.549",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6338 235.534C56.7541 236.526 60.3773 237.948 62.5513 238.833C64.5106 239.369 66.604 239.798 68.6169 239.959",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.112 228.24C178.254 228.83 147.335 232.45 142.853 233.443C141.78 233.711 140.599 234.193 139.606 234.676L138.693 235.212C138.693 235.212 138.398 235.32 138.264 235.347",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.226 235.481C124.712 236.419 119.505 237.17 109.172 230.976",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.592 228.24H263.416L263.577 228.186L263.684 228.079L263.738 227.972V225.478V227.972V219.954L263.684 219.793L263.577 219.632H263.416H260.866L257.645 219.685",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.138 242.56L430.031 242.48L429.977 242.292L429.924 226.658L429.655 225.827L263.736 225.559L263.79 241.702L263.629 241.97",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.487 228.24C200.53 227.972 240.171 228.213 257.59 228.24L257.644 219.686C242.211 219.793 226.591 220.195 211.185 221.107C205.656 221.509 199.993 221.938 194.491 222.448C189.607 222.984 183.622 223.869 178.764 224.727C178.764 224.807 178.764 224.968 178.764 225.049C179.945 226.336 181.528 227.516 183.112 228.24H183.487Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8799 223.521C47.8173 223.44 91.4576 227.463 101.227 227.919",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4463 209.228C33.5119 212.633 40.7048 214.51 47.3877 216.227C62.2834 219.874 83.5936 223.521 98.6771 226.578C100.18 227.06 101.468 228.213 102.837 228.911C104.77 229.983 107.024 230.681 109.171 231.029",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7715 193.942V194.211L16.1472 196.758C16.1472 196.758 16.2546 197.134 16.4156 197.589",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.841 224.003C30.5866 222.448 28.4931 220.437 26.5875 218.318C26.4265 218.104 26.2386 217.889 26.0508 217.675C24.7625 216.119 23.7426 214.591 22.9374 212.955C20.6293 208.128 18.2943 202.604 16.4424 197.562C17.5159 199.118 18.9116 200.566 20.173 201.96C22.6422 204.722 26.185 207.592 28.4663 210.461C33.7536 216.763 38.2357 224.218 45.0528 229.018C40.8659 227.758 36.5985 226.309 32.8679 224.003H32.841Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0254 229.018C45.0254 229.018 45.0788 229.018 45.1056 229.018L45.2124 229.125C45.2124 229.125 45.1056 229.045 45.0254 228.991V229.018Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2139 229.152C47.9514 230.869 51.0916 231.861 54.2049 232.612C71.5967 234.971 120.578 237.573 137.513 237.599",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8262 236.768C69.2884 238.242 73.1264 239.717 76.7228 240.79C79.0578 241.005 81.5807 241.273 83.9425 241.38C91.6722 241.889 99.5628 242.319 107.319 242.453C115.72 242.721 124.282 242.828 132.682 242.828C136.252 242.828 140.063 242.667 143.633 242.56C145.458 242.399 146.934 241.729 148.678 241.246",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.701 239.825L108.822 239.128L107.748 239.075L64.2155 236.688L54.3387 235.508L46.3675 234.328C38.0474 233.309 29.3784 231.137 23.1249 225.291C19.3943 221.724 16.5225 217.139 14.2949 212.5C10.9132 205.849 7.96087 198.555 6.21633 191.315C6.21633 191.315 5.94794 191.127 5.57219 189.84C4.55231 186.702 4.3376 180.293 3.98869 177.049C3.5861 171.444 3.02248 165.437 2.59306 159.833C1.68053 151.841 1.3853 143.287 1.49266 134.545H1.46582",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.511 224.325C149.511 224.325 150.504 220.624 145.136 220.973C145.136 220.973 138.48 221.161 131.582 222.528C131.582 222.528 123.074 224.218 113.708 226.658C113.708 226.658 109.44 218.747 106.998 211.132C106.998 211.132 106.89 210.917 107.105 210.837L107.508 210.729C107.508 210.729 103.133 198.421 100.905 176.887C100.905 176.887 98.5435 157.097 98.7313 134.518",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.741 224.915H110.513C110.513 224.915 106.863 217.004 105.387 212.07C105.387 212.07 101.764 207.029 101.12 204.293C101.093 204.159 101.066 203.998 101.066 203.864V197.562L98.3015 181.902L98.8919 181.473L97.9794 174.876C97.9794 174.876 97.4426 174.527 97.3889 174.071C97.3889 174.071 95.8591 155.997 95.6712 150.554L95.4297 143.823C95.4297 143.823 95.6176 143.286 95.9396 143.072V138.486",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4238 134.545C92.558 204.187 108.393 227.597 108.393 227.597L109.145 227.731H109.467C136.359 226.525 178.47 220.437 178.47 220.437",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3496 134.545V137.629L95.779 137.951L96.0743 138.004V134.545H95.3496Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3496 137.628L95.5912 138.111L95.9669 138.513L96.1548 138.218L95.8327 138.03L95.3496 137.628Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.707 159.242C138.881 159.457 146.96 159.805 148.141 159.51C149.053 159.028 150.798 154.978 151.2 154.147L151.227 154.04C151.227 153.825 151.173 153.637 151.012 153.503C150.69 153.289 141.109 153.155 139.311 153.45C138.962 153.45 136.895 157.767 136.546 158.33C136.466 158.464 136.358 158.706 136.385 158.867C136.385 158.867 136.358 159.188 136.707 159.242Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.539 159.188C118.539 159.188 138.99 161.2 147.444 161.253C151.873 161.307 156.409 161.387 160.783 160.717C162.501 158.491 164.138 155.81 165.078 153.182C165.078 153.182 165.614 151.573 165.668 151.385H165.641C165.722 151.09 165.239 151.251 165.239 151.251C162.877 152.189 129.355 151.331 118.109 151.599C118.109 151.599 118.217 156.748 118.539 159.188ZM118.539 159.188C118.485 158.733 118.485 159.188 118.485 159.188H118.539Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.509 159.939C155.173 159.913 157.051 159.886 158.716 159.671C158.716 159.671 159.011 159.671 159.36 159.135C159.843 158.438 160.541 157.419 160.943 156.641C161.534 155.622 162.151 154.362 162.473 153.235C162.5 153.101 162.419 153.128 162.419 153.128C160.809 153.209 159.011 153.209 157.374 153.289C157.213 153.289 157.051 153.37 156.944 153.477C156.568 153.906 156.3 154.818 156.085 155.193C155.387 156.695 154.072 158.357 153.214 159.752C153.214 159.752 153.026 160.02 153.536 159.966L153.509 159.939Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.729 161.012C160.112 176.646 158.367 207.618 157.32 223.306",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.614 221.938C134.48 216.548 130.132 174.93 131.367 170.639C131.877 166.992 133.836 163.559 136.627 161.173C137.272 161.2 138.184 161.307 138.855 161.387C136.064 163.747 133.97 167.019 133.38 170.639C132.145 174.795 136.037 216.495 136.144 221.67L134.614 221.938Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.908 151.171H145.163L153.832 151.225H156.22C156.22 151.225 158.099 144.038 158.099 134.545",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.809 160.69L161.346 160.61C161.346 160.61 165.103 156.266 166.445 151.01L165.801 150.634L165.72 150.902C165.72 150.902 159.655 151.68 157.293 151.305C157.293 151.305 159.118 142.616 159.118 134.571",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.857 147.845L158.126 148.489C158.126 148.489 162.42 148.408 163.279 148.247L163.574 147.711V147.336C163.574 147.336 164.648 142.294 164.648 134.518",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.628 134.545L159.145 144.413C159.145 144.413 159.145 144.735 159.493 144.735H162.983C162.983 144.735 163.439 144.896 163.492 143.877C163.492 143.877 164.029 140.257 164.029 134.572",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.062 134.544C167.062 195.283 179.167 217.889 179.167 217.889C178.603 218.345 179.113 218.962 179.113 218.962C179.489 219.927 178.791 220.276 178.791 220.276C178.442 220.276 178.469 220.651 178.469 220.651L179.194 222.743L181.26 222.421C181.26 222.421 183.166 222.019 181.851 219.874L181.314 218.372C181.314 218.372 168.941 198.287 168.941 134.518",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.006 220.142L181.878 219.9",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.221 219.659L181.69 219.444",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.689 219.471C181.689 219.471 182.924 219.391 183.273 222.662C183.273 222.662 183.273 223.172 184.239 222.957C184.239 222.957 195.27 220.329 218.03 219.873L258.369 218.398",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.26 218.372L194.679 216.602L258.341 214.162",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.615 199.923V214.109",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.121 211.829V214.216",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.18 208.181C236.362 207.806 233.678 207.94 230.86 208.101C227.102 208.449 222.996 209.442 219.158 209.763C219.158 209.763 218.353 209.844 218.058 209.871C214.22 210.246 210.221 210.353 206.41 210.058C204.477 209.817 202.437 209.71 200.666 208.879",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.282 165.142C255.175 165.758 254.907 168.413 254.799 169.083C254.638 169.808 254.585 170.076 254.289 170.344C254.021 170.612 253.672 170.773 253.269 170.827C250.773 171.202 247.633 171.202 245.137 171.282C244.171 171.229 243.473 170.344 242.91 169.754C241.299 167.984 240.091 166 239.555 163.747",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.646 209.951C253.538 209.335 253.27 206.68 253.163 206.009C253.002 205.285 252.948 205.017 252.653 204.749C252.384 204.481 252.035 204.32 251.633 204.266C249.137 203.891 245.997 203.891 243.5 203.811C242.534 203.864 241.836 204.749 241.273 205.339C239.663 207.109 238.455 209.093 237.918 211.346",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.505 171.712L254.183 187.641L253.432 203.489",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43 203.489C253.135 203.355 245.566 202.711 245.029 202.685",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.694 171.336L246.104 171.819",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.977 203.865L245.567 187.802L246.104 171.819",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.787 160.717L199.056 160.985L199.109 161.039C202.652 164.981 205.577 167.367 210.355 169.164C210.704 169.298 211.455 169.486 211.455 169.486C212.985 170.049 214.864 170.424 216.501 170.639C223.855 171.041 238.831 171.551 246.104 171.819",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.199 202.255L209.736 187.185L209.79 185.683L210.38 169.164",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.859 160.234C201.47 161.977 203.187 163.935 205.174 165.276C205.254 165.329 205.335 165.383 205.335 165.383C209.226 167.957 213.843 169.513 218.513 169.701C218.647 169.701 218.781 169.701 218.861 169.701C226.913 169.995 235.663 170.264 243.714 170.612",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.738 162.192C202.06 161.924 203.698 161.442 204.02 161.442C205.013 161.254 207.536 161.12 207.536 161.12C213.145 160.959 218.969 161.951 224.444 163.077C226.913 163.614 229.758 164.472 232.254 164.928C233.972 165.089 235.716 165.41 237.434 165.464C237.542 165.464 237.622 165.464 237.622 165.464C238.427 165.518 239.313 165.518 240.118 165.518",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.693 162.729C198.841 163.694 197.875 165.249 197.499 165.92C196.399 167.609 195.513 174.474 195.057 176.485L194.305 182.921L193.983 186.166L193.769 189.357C193.608 192.977 193.554 195.123 194.547 201.827C195.459 204.75 196.587 207.056 199.485 208.262",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.556 163.801C238.053 163.748 236.496 163.506 234.993 163.319C228.847 162.058 221.654 160.02 215.428 159.269C211.509 158.921 206.678 158.84 202.733 159.403C202.652 159.403 201.471 159.698 200.988 159.886C200.102 160.208 199.056 160.556 198.331 161.012C197.472 161.522 196.318 162.595 196.318 162.595C193.983 164.82 193.5 168.601 192.963 171.632L192.212 175.734L191.568 179.864C191.407 181.232 191.004 184.772 190.87 186.086L190.655 190.269C190.628 195.418 191.299 200.861 193.312 205.661C194.09 207.431 195.379 209.013 197.096 209.952C197.096 209.952 197.472 210.166 197.902 210.408C198.009 210.461 198.116 210.515 198.251 210.569C199.056 210.864 199.888 211.212 200.747 211.427C205.202 212.5 212.073 212.741 217.36 212.178C222.996 211.668 229.625 210.113 235.315 209.818H236.362C237.06 209.791 237.758 209.791 238.402 209.791",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.436 201.826L233.972 186.594L234.563 171.39",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.031 202.256C236.684 202.095 222.325 201.156 213.925 201.29C211.992 201.532 210.838 201.746 208.798 202.309C207.966 202.631 207.081 202.873 206.249 203.221C205.712 203.57 205.121 203.892 204.558 204.187C202.142 205.903 199.539 207.914 197.66 210.193",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.732 210.649C203.51 206.251 204.503 204.294 211.213 202.846C212.796 202.524 214.38 202.283 215.99 202.256C224.578 202.524 234.026 202.98 242.614 203.221L243.634 203.275L245.003 203.329",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.104 172.489L247.714 172.409C247.714 172.409 254.424 171.899 254.504 171.712C254.504 171.712 255.605 170.88 255.792 165.49",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.387 171.685C267.441 166.885 266.85 166.67 266.85 166.67C263.066 163.318 249.405 161.495 249.405 161.495L244.01 161.119C238.777 161.387 239.475 163.72 239.475 163.72C239.475 163.72 240.065 161.119 249.137 163.345L254.585 164.793C254.585 164.793 260.248 166.616 259.926 171.712L259.872 188.391C259.872 188.391 259.684 206.17 257.323 207.672L253.646 209.898C253.646 209.898 242.507 214.108 237.918 211.4",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.426 161.307L253.458 162.969C253.458 162.969 258.315 164.203 260.006 166.697C260.006 166.697 261.241 167.93 261.241 171.819",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.766 166.429C259.766 166.429 261.054 165.839 266.851 166.697",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.918 211.426C237.918 211.426 237.677 213.303 240.844 213.545C240.844 213.545 245.97 214.51 255.256 210.89L257.726 209.174C257.726 209.174 259.228 208.315 259.658 206.17C259.658 206.17 260.356 203.059 260.356 201.665",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.35 203.516C253.35 203.516 254.101 203.677 254.101 205.286V209.683",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.262 208.745C258.262 208.745 262.449 209.442 265.508 208.879",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.863 213.679C241.863 213.679 249.056 214.323 257.188 212.338L262.717 210.863C262.717 210.863 266.045 209.925 266.045 207.243L266.475 202.175",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.797 191.797C270.501 198.689 269.508 200.137 269.508 200.137C268.676 202.175 266.771 202.148 266.771 202.148H261.43C260.544 202.095 259.873 201.29 259.927 200.325L260.839 187.024L260.786 185.361V173.213C260.786 172.329 261.51 171.604 262.396 171.604L267.764 171.712C267.764 171.712 269.696 171.739 270.421 173.616C270.421 173.616 271.629 175.359 271.172 184.235C271.172 184.235 270.85 190.805 270.823 191.797H270.797Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.898 200.164C259.898 200.164 261.697 200.056 262.743 195.498C262.743 195.498 263.388 193.272 263.629 189.115C263.656 188.525 263.897 184.262 263.871 183.779C263.763 180.695 263.361 177.879 263.361 177.879C262.582 173.133 260.757 173.374 260.757 173.374",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.255 39.4272C447.96 39.3467 446.859 39.2395 446.457 38.9445C446.054 38.7031 445.92 38.2205 445.839 37.7109C445.759 37.2014 445.652 35.9143 445.652 35.6997C445.625 34.7075 445.705 33.6885 445.893 32.7499C446.027 32.16 446.376 31.57 446.376 31.57C446.376 31.57 446.564 31.1678 446.859 31.0337C448.335 30.7387 449.946 30.7387 451.502 30.7119L608.028 32.589C606.793 33.9835 605.21 35.512 603.841 36.7724C603.036 37.5232 601.989 38.6495 601.023 39.159C599.01 40.044 596.675 40.2049 594.528 40.3926L584.436 40.4998L448.523 39.454H448.201L448.255 39.4272Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.63 28.5939C513.5 26.1805 371.629 26.2609 268.379 27.0922C266.742 27.0922 261.589 27.0922 260.462 27.0654C240.037 26.7704 179.649 28.9426 154.877 28.3258",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.201 39.4544L429.924 39.3203",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.894 50.6367H271.037V54.9273H607.894V50.6367Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.39 43.0472L610.229 42.7254L610.067 42.6718L606.981 42.5645L602.043 42.4036L597.051 42.2963L592.059 42.1891L587.093 42.1354L577.163 42.0282L567.796 41.9209L429.924 40.9287",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.875 133.981V134.464V134.518L633.929 134.652L634.09 134.679H635.002H635.754L635.861 134.732L635.968 134.813V135.081",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.133 133.981V134.518V134.679L643.187 134.813L643.321 135.054",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.184 62.3281L628.774 65.8947L629.579 70.9361L630.223 75.763L630.894 80.7509L631.216 84.0493L631.538 87.4013L632.129 94.1322L632.397 97.8596L632.666 101.641L633.041 108.854L633.256 114.861L633.364 119.098L633.471 123.362L633.578 129.449L633.605 133.606V133.713L633.632 133.874L633.712 133.981H633.766H644.153",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.324 56.4824L635.378 56.5892",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.848 48.4375L635.378 56.5896",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.014 133.981C641.095 131.997 640.289 112.072 641.175 110.812C641.202 108.452 641.148 106.012 641.068 103.652C640.504 92.1746 639.511 80.3218 637.928 68.9249C637.525 66.0288 637.042 62.8913 636.398 60.0487C636.102 58.9225 635.968 57.5817 635.378 56.5895L635.324 56.4822C635.324 56.4822 635.083 56.3481 635.002 56.3213C634.063 57.1794 633.043 58.3057 632.13 59.1906C631.486 59.9147 630.493 60.6923 630.439 61.7382",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.836 60.5851L627.514 58.708V58.5471L627.406 56.375",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.836 60.585L628.185 62.328",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.121 41.3584C639.51 46.6144 640.771 52.9698 641.523 58.7889C641.603 59.3521 641.63 59.8884 641.684 60.3443C643.16 79.6788 644.368 115.693 644.18 133.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.953 30.0957L615.168 30.1493C620.16 30.4711 625.769 31.4365 630.573 32.7773L631.728 33.0455L633.767 32.1337",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.526 30.5509C625.258 29.3174 618.817 28.7543 614.335 28.3252C614.147 28.3252 614.013 28.4593 613.852 28.5397",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.401 30.9L630.144 30.5246C630.144 30.5246 630.493 30.471 630.627 31.0878L630.976 32.7504L624.454 31.0609C624.454 31.0609 624.32 31.0073 624.401 30.9269V30.9Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.547 30.9268C630.547 30.9268 632.13 31.4363 632.238 31.4631C632.238 31.4631 633.445 31.7849 633.768 32.1603L634.063 32.4285V32.5089L631.835 33.3938",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.658 28.5938L614.765 28.7815L615.007 30.5781L613.799 34.2252L609.961 42.6723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.701 33.0723L631.809 33.4209L631.97 34.5203",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.271 34.1176L624.132 45.3268C624.132 45.3268 622.736 47.2843 623.192 50.6364L624.212 55.5169H611.249L610.363 50.0732L609.316 49.8587C609.853 43.7982 610.444 42.8597 610.444 42.8597L614.389 34.3857L615.543 30.7119L618.281 30.9801L622.709 31.5968L625.983 32.2941L630.385 33.6885C630.385 33.6885 631.915 33.8762 632.881 36.0215C632.881 36.0215 634.116 38.5959 634.652 41.1702C634.652 41.1702 634.706 41.4652 634.572 41.6529L632.371 44.2541",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.316 49.8857C609.316 49.8857 609.316 50.3148 609.074 50.288V51.0657",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.922 51.0928H609.183C609.183 51.0928 609.237 55.7052 608.861 56.4024",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.499 39.4814L625.231 46.4C625.365 45.7028 623.272 44.9251 621.688 44.4424C620.803 44.1743 619.89 43.9598 618.951 43.7989L616.616 43.3966L610.523 42.8067",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.224 38.4353C631.754 40.527 632.372 44.2008 632.372 44.2008C632.372 44.7372 631.513 44.8176 631.513 44.8176C630.681 41.1438 629.312 39.0789 629.312 39.0789L629.178 37.6577C629.178 37.6577 629.553 37.4431 630.117 38.2744L630.251 38.4353H630.224Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.426 35.1904L630.252 38.4084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.486 44.8173L631.567 45.0854L627.514 50.9046L627.219 52.6476L627.541 51.8968L628.051 51.2532L631.969 45.6486L634.787 42.2965C634.787 42.2965 635.029 42.1088 635.083 42.6183L635.351 43.6642L636.559 43.3424C636.559 43.3424 637.444 43.1547 637.283 42.2161C636.505 37.3356 634.653 33.5276 634.653 33.5276L634.197 32.5623L634.063 32.4014",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.512 46.3188C631.512 46.3188 631.753 46.2115 631.834 46.5065L632.397 48.759C632.397 48.759 632.478 49.1345 632.585 49.0808L633.203 48.2763C633.203 48.2763 633.283 48.1691 633.176 47.8473L632.585 45.2729C632.585 45.2729 632.585 45.1388 632.371 45.1657",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.854 43.208L636.693 44.4416C636.693 44.4416 636.585 44.817 636.129 45.3801L629.929 53.72C629.929 53.72 629.258 54.2563 629.741 58.0374",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.318 50.9316L630.492 61.8727L632.827 81.3412L634.867 98.6913L635.887 133.981",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.01 45.0859L626.895 46.5072",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.406 47.5527L628.104 49.9394V50.0466",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.219 52.6748L627.407 56.3754",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.407 56.375L608.002 56.4018",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.255 229.635C447.96 229.716 446.859 229.823 446.457 230.118C446.054 230.359 445.92 230.842 445.839 231.351C445.759 231.861 445.652 233.148 445.652 233.363C445.625 234.355 445.705 235.374 445.893 236.312C446.027 236.902 446.376 237.492 446.376 237.492C446.376 237.492 446.564 237.895 446.859 238.029C448.335 238.324 449.946 238.324 451.502 238.35L608.028 236.473C606.793 235.079 605.21 233.55 603.841 232.29C603.036 231.539 601.989 230.413 601.023 229.903C599.01 229.018 596.675 228.857 594.528 228.67L584.436 228.562L448.523 229.608H448.201L448.255 229.635Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.63 240.469C513.5 242.882 371.629 242.802 268.379 241.97C266.742 241.97 261.589 241.97 260.462 241.997C240.037 242.292 179.649 240.12 154.877 240.737",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.201 229.608L429.924 229.742",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.894 214.135H271.037V218.425H607.894V214.135Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.39 226.015L610.229 226.336L610.067 226.39L606.981 226.497L602.043 226.658L597.051 226.765L592.059 226.873L587.093 226.926L577.163 227.034L567.796 227.141L429.924 228.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.184 206.734L628.774 203.167L629.579 198.126L630.223 193.299L630.894 188.311L631.216 185.013L631.538 181.661L632.129 174.93L632.397 171.202L632.666 167.421L633.041 160.208L633.256 154.201L633.364 149.964L633.471 145.7L633.578 139.613L633.605 135.456V135.349L633.632 135.188L633.712 135.081H633.766H644.153",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.324 212.579L635.378 212.473",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.848 220.625L635.378 212.473",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.014 135.081C641.095 137.065 640.289 156.99 641.175 158.25C641.202 160.61 641.148 163.05 641.068 165.41C640.504 176.888 639.511 188.74 637.928 200.137C637.525 203.033 637.042 206.171 636.398 209.013C636.102 210.14 635.968 211.48 635.378 212.473L635.324 212.58C635.324 212.58 635.083 212.714 635.002 212.741C634.063 211.883 633.043 210.756 632.13 209.871C631.486 209.147 630.493 208.37 630.439 207.324",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.836 208.477L627.514 210.354V210.515L627.406 212.687",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.836 208.476L628.185 206.733",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.121 227.704C639.51 222.448 640.771 216.093 641.523 210.274C641.603 209.711 641.63 209.174 641.684 208.718C643.16 189.384 644.368 153.37 644.18 135.081",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.953 238.94L615.168 238.886C620.16 238.565 625.769 237.599 630.573 236.258L631.728 235.99L633.767 236.902",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.526 238.511C625.258 239.744 618.817 240.307 614.335 240.736C614.147 240.736 614.013 240.602 613.852 240.522",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.401 238.162L630.144 238.537C630.144 238.537 630.493 238.591 630.627 237.974L630.976 236.312L624.454 238.001C624.454 238.001 624.32 238.055 624.401 238.135V238.162Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.547 238.135C630.547 238.135 632.13 237.626 632.238 237.599C632.238 237.599 633.445 237.277 633.768 236.902L634.063 236.633V236.553L631.835 235.668",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.658 240.468L614.765 240.28L615.007 238.484L613.799 234.837L609.961 226.39",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.701 235.99L631.809 235.641L631.97 234.542",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.271 234.944L624.132 223.735C624.132 223.735 622.736 221.778 623.192 218.425L624.212 213.545H611.249L610.363 218.989L609.316 219.203C609.853 225.264 610.444 226.202 610.444 226.202L614.389 234.676L615.543 238.35L618.281 238.082L622.709 237.465L625.983 236.768L630.385 235.373C630.385 235.373 631.915 235.186 632.881 233.04C632.881 233.04 634.116 230.466 634.652 227.892C634.652 227.892 634.706 227.597 634.572 227.409L632.371 224.808",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.316 219.176C609.316 219.176 609.316 218.747 609.074 218.774V217.996",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.922 217.97H609.183C609.183 217.97 609.237 213.357 608.861 212.66",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.499 229.581L625.231 222.662C625.365 223.359 623.272 224.137 621.688 224.62C620.803 224.888 619.89 225.102 618.951 225.263L616.616 225.666L610.523 226.255",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.224 230.627C631.754 228.536 632.372 224.862 632.372 224.862C632.372 224.326 631.513 224.245 631.513 224.245C630.681 227.919 629.312 229.984 629.312 229.984L629.178 231.405C629.178 231.405 629.553 231.62 630.117 230.788L630.251 230.627H630.224Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.426 233.871L630.252 230.653",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.486 224.244L631.567 223.976L627.514 218.157L627.219 216.414L627.541 217.165L628.051 217.808L631.969 223.413L634.787 226.765C634.787 226.765 635.029 226.953 635.083 226.443L635.351 225.397L636.559 225.719C636.559 225.719 637.444 225.907 637.283 226.846C636.505 231.726 634.653 235.534 634.653 235.534L634.197 236.499L634.063 236.66",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.512 222.743C631.512 222.743 631.753 222.85 631.834 222.555L632.397 220.303C632.397 220.303 632.478 219.927 632.585 219.981L633.203 220.785C633.203 220.785 633.283 220.893 633.176 221.214L632.585 223.789C632.585 223.789 632.585 223.923 632.371 223.896",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.854 225.854L636.693 224.62C636.693 224.62 636.585 224.245 636.129 223.682L629.929 215.342C629.929 215.342 629.258 214.806 629.741 211.024",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.318 218.131L630.492 207.19L632.827 187.721L634.867 170.371L635.887 135.081",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.01 223.977L626.895 222.556",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.406 221.51L628.104 219.123V219.016",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.219 216.387L627.407 212.687",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.407 212.687L608.002 212.66",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4566 239.933C70.3621 240.496 75.891 240.791 75.891 240.791L75.9446 240.737L76.6961 240.791C79.0311 241.005 81.554 241.273 83.9158 241.381C91.6455 241.89 99.5362 242.319 107.293 242.453C115.693 242.721 124.255 242.829 132.656 242.829C136.225 242.829 140.036 242.668 143.606 242.561C145.002 242.426 147.39 241.649 148.652 241.247L148.92 244.035C148.544 244.089 148.142 244.169 147.766 244.304C147.524 244.384 147.068 244.545 146.853 244.786C146.666 245.001 146.692 245.162 146.692 245.162C146.853 247.602 147.578 250.847 148.169 253.233C148.383 254.091 148.571 254.923 148.813 255.754C149.027 256.505 149.215 257.256 149.457 257.98C149.645 258.597 149.859 259.213 150.155 259.777C151.336 261.841 153.026 265.059 154.556 266.776C154.556 266.776 154.878 267.205 155.469 267.258L156.489 267.312C156.811 267.312 159.011 265.274 159.199 264.952C159.307 264.738 159.36 264.523 159.199 264.282H159.253L159.629 264.496H159.682L161.561 263.638C161.561 263.638 161.561 263.638 161.588 263.638C161.991 263.477 161.83 262.968 161.856 262.646C160.944 258.302 158.985 251.195 157.911 246.824C157.911 246.797 157.911 246.744 157.884 246.717L157.374 245.188C157.321 245.054 157.24 244.92 157.106 244.84L155.979 244.009C155.979 244.009 155.764 243.874 155.657 243.821L154.905 243.553C154.664 242.668 154.583 241.836 154.717 241.139H155.308L200.183 241.032C223.908 241.488 272.916 241.971 272.916 241.971C314.463 242.292 361.968 242.48 410.386 242.453L430.113 242.534C430.113 242.534 557.571 241.756 610.793 240.522C611.92 240.522 613.853 240.496 613.853 240.496C614.014 240.576 614.148 240.71 614.336 240.71C618.818 240.308 625.259 239.718 629.527 238.484H630.117C630.117 238.484 630.386 238.538 630.547 238.109C630.547 238.109 632.13 237.6 632.211 237.573C632.211 237.573 633.418 237.251 633.741 236.875L634.036 236.607L634.17 236.446L634.626 235.481C634.626 235.481 636.263 232.075 637.122 227.597C639.484 222.368 640.746 216.039 641.497 210.247C641.578 209.684 641.604 209.147 641.658 208.692C643.107 189.679 644.315 154.523 644.154 135.966C644.154 135.644 644.154 132.936 644.154 132.426C644.261 113.735 643.08 79.1425 641.658 60.3175C641.631 59.8348 641.578 59.3253 641.497 58.7622C640.746 52.9699 639.484 46.6412 637.122 41.4121C636.29 36.9338 634.626 33.5281 634.626 33.5281L634.17 32.5627L634.036 32.4018L633.741 32.1337C633.418 31.7582 632.211 31.4364 632.211 31.4364C632.103 31.4096 630.547 30.9001 630.547 30.9001C630.386 30.4711 630.117 30.5247 630.117 30.5247H629.527C625.259 29.2911 618.818 28.728 614.336 28.299C614.148 28.299 614.014 28.433 613.853 28.5135C613.853 28.5135 611.947 28.5135 610.793 28.4867C557.598 27.2531 430.113 26.4754 430.113 26.4754L410.386 26.5559C361.968 26.5291 314.463 26.7168 272.916 27.0386C272.916 27.0386 223.908 27.5213 200.183 27.9772L155.308 27.8699H154.717C154.583 27.1459 154.664 26.3414 154.905 25.4564L155.657 25.1883C155.764 25.1346 155.871 25.081 155.979 25.0006L157.106 24.1693C157.106 24.1693 157.321 23.9547 157.374 23.8206L157.884 22.2921C157.884 22.2921 157.884 22.2117 157.911 22.1849C158.985 17.8138 160.944 10.7075 161.856 6.36329C161.83 6.01468 161.991 5.53198 161.588 5.37109C161.588 5.37109 161.588 5.37109 161.561 5.37109L159.682 4.51297H159.629L159.253 4.7275H159.199C159.334 4.48615 159.307 4.27162 159.199 4.05709C159.011 3.70848 156.838 1.69727 156.489 1.69727L155.469 1.7509C154.851 1.80453 154.556 2.23359 154.556 2.23359C153.026 3.94983 151.336 7.16777 150.155 9.23262C149.833 9.79576 149.645 10.4125 149.457 11.0293C149.215 11.7533 149.001 12.5042 148.813 13.2551C148.598 14.0864 148.383 14.9445 148.169 15.7758C147.605 18.1624 146.88 21.4072 146.692 23.8475C146.692 23.8475 146.666 24.0084 146.853 24.2229C147.095 24.491 147.524 24.6251 147.766 24.7056C148.142 24.8397 148.517 24.9201 148.92 24.9737L148.678 27.7626C147.39 27.3604 145.002 26.5559 143.606 26.4218C140.036 26.3145 136.225 26.1268 132.656 26.1537C124.255 26.1537 115.693 26.2609 107.293 26.5291C99.5362 26.69 91.6723 27.0922 83.9158 27.6017C81.5808 27.709 79.058 28.004 76.6961 28.1917L75.9446 28.2453L75.891 28.1917C75.891 28.1917 70.389 28.5135 68.4566 29.0498M68.6176 28.9962C66.6047 29.1571 64.5112 29.6129 62.552 30.1224C60.378 31.0074 56.7547 32.4286 54.6344 33.4208L54.3124 33.4745L46.3412 34.6544C38.0211 35.6734 29.3521 37.8455 23.0986 43.6915C19.3679 47.258 16.4962 51.8436 14.2685 56.4828C10.8868 63.1332 7.93451 70.4272 6.18997 77.6676C6.18997 77.6676 5.92158 77.8553 5.54583 79.1425C4.52595 82.28 4.31124 88.6891 3.96233 91.9338C3.55975 97.5384 2.99613 103.545 2.5667 109.15C1.65417 117.141 1.35894 125.695 1.4663 134.438C1.35894 143.18 1.65417 151.761 2.5667 159.725C3.02296 165.33 3.55975 171.363 3.96233 176.941C4.2844 180.186 4.49911 186.568 5.54583 189.733C5.92158 190.993 6.18997 191.207 6.18997 191.207C7.93451 198.448 10.8868 205.742 14.2685 212.392C16.4962 217.031 19.3948 221.617 23.0986 225.184C29.3789 231.056 38.0479 233.228 46.3412 234.221L54.3124 235.401L54.6344 235.454C56.7547 236.446 60.378 237.868 62.552 238.753C64.5112 239.289 66.6047 239.718 68.6176 239.879",
    stroke: "#808184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.627 98.1816H366.45C367.658 98.1816 368.624 99.147 368.624 100.354C368.624 101.56 367.658 102.526 366.45 102.526H356.627",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.812 97.1895V103.518",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.841 97.7001C368.841 97.7001 368.841 97.6719 368.812 97.6719",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.812 103.063C368.812 103.063 368.813 103.063 368.841 103.035",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 97.1895H364.465V98.1817",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 103.519H364.465V102.526",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.429 100.354C369.429 99.4423 369.241 98.5305 368.865 97.6992",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.838 103.008C369.214 102.177 369.401 101.265 369.401 100.354",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.951 96.8682H320.072",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.951 103.652H320.072",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.969 121.593V119.099",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.969 81.5287V79.1152",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.68 119.581V121.592",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.68 79.1152V81.0728",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 72.1973L342.859 76.8901",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.522 73.5375C348.898 72.4112 348.28 71.1777 347.126 70.8022C345.972 70.4268 344.764 71.0436 344.389 72.1967",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.522 73.5381L347.395 76.9706",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 69.5957V72.1969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 69.918V70.0515",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.764 69.5957V75.9243",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.792 70.1064C348.792 70.1064 348.792 70.0781 348.764 70.0781",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.791 75.0933V70.1055",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.764 75.4697C348.764 75.4697 348.764 75.4697 348.792 75.4414",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.791 75.0928V75.4146",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.361 72.3044V70.1055",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.39 70.0518C344.39 70.0518 344.39 70.0518 344.361 70.08",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 69.5957H348.763",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.744 75.9248H348.764",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.355 72.7603C349.355 71.8485 349.167 70.9368 348.791 70.1055",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.791 75.4146C349.167 74.5833 349.355 73.6715 349.355 72.7598",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.362 70.1055C343.987 70.9368 343.799 71.8485 343.799 72.7603",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.799 72.7598C343.799 73.1084 343.826 73.457 343.879 73.7788",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.112 76.9697H318.838C318.542 76.9697 318.301 77.2111 318.301 77.5061V78.6055C318.301 78.9005 318.542 79.1418 318.838 79.1418H349.112C349.407 79.1418 349.649 78.9005 349.649 78.6055V77.5061C349.649 77.2111 349.407 76.9697 349.112 76.9697Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 128.538L342.832 123.765",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.522 127.197C348.898 128.324 348.28 129.557 347.126 129.933C345.972 130.308 344.764 129.691 344.389 128.538",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.522 127.197L347.395 123.765",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 131.113V128.512",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 130.79V130.656",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.764 131.113V124.784",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.792 130.63C348.792 130.63 348.792 130.658 348.764 130.658",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.789 125.615V130.63",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.764 125.24C348.764 125.24 348.764 125.24 348.792 125.268",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.789 125.615V125.293",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.361 128.431V130.63",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.39 130.658C344.39 130.658 344.39 130.658 344.361 130.63",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 131.112H348.763",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.744 124.784H348.764",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.353 127.948C349.353 128.86 349.165 129.772 348.789 130.603",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.789 125.293C349.165 126.124 349.353 127.036 349.353 127.948",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.362 130.629C343.987 129.798 343.799 128.886 343.799 127.975",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.799 127.949C343.799 127.6 343.826 127.251 343.879 126.93",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.112 121.593H318.838C318.542 121.593 318.301 121.834 318.301 122.129V123.229C318.301 123.524 318.542 123.765 318.838 123.765H349.112C349.407 123.765 349.649 123.524 349.649 123.229V122.129C349.649 121.834 349.407 121.593 349.112 121.593Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.073 114.298C320.073 114.593 319.885 116.041 319.858 116.149C319.59 118.455 318.892 119.903 318.14 119.474L311.94 115.961C311.43 115.666 311.055 114.164 311.055 112.394V87.9647C311.055 86.1948 311.43 84.6931 311.967 84.3981L318.167 80.9388C318.167 80.9388 318.328 80.8584 318.435 80.8584C319.294 80.8584 320.099 83.2182 320.099 86.1144",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14 119.474C318.14 119.849 318.006 120.224 317.818 120.573C317.174 121.726 315.779 122.155 314.705 121.538",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.705 78.8736C315.027 78.6859 315.376 78.6055 315.752 78.6055C317.013 78.6055 318.087 79.6513 318.14 80.9385",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.072 86.1411V114.405V114.942V115.478L320.019 116.014L319.965 116.524L319.884 117.033L319.831 117.436L319.75 117.811L319.67 118.186L319.589 118.508L319.482 118.884L319.374 119.179L319.267 119.447L319.16 119.688L319.026 119.93L318.891 120.171L318.784 120.332L318.65 120.52L318.516 120.68L318.381 120.841L318.247 120.975L318.113 121.109L317.952 121.244L317.764 121.378L317.576 121.485L317.415 121.565L317.227 121.646L317.093 121.699L316.905 121.753L316.717 121.807H316.53L316.342 121.86H316.154H315.966H315.805L315.644 121.807L315.456 121.753L315.268 121.699L315.08 121.619L314.892 121.539L314.785 121.485L308.585 117.972H308.532L308.344 117.811L308.156 117.677L307.995 117.543L307.861 117.382L307.726 117.221L307.592 117.033L307.458 116.846L307.351 116.658C306.867 115.8 306.572 114.137 306.572 112.341V87.911C306.572 86.1143 306.867 84.4517 307.351 83.5936L307.458 83.4059L307.592 83.2182L307.726 83.0304L307.861 82.8695L307.995 82.7355L308.156 82.6014L308.344 82.4673L308.478 82.3868L308.612 82.3064L314.812 78.8471L315 78.7398L315.188 78.6594L315.375 78.5789L315.563 78.5253H315.751L315.912 78.4717H316.046H316.234H316.422L316.61 78.4985H316.798L316.986 78.6058L317.174 78.6862L317.308 78.7398L317.469 78.8203L317.657 78.9276L317.845 79.0616L317.979 79.1689L318.14 79.303L318.301 79.4639L318.462 79.6248L318.596 79.7857L318.73 79.9466L318.865 80.1879L318.999 80.4293L319.106 80.617L319.213 80.8583L319.321 81.1265L319.428 81.4483L319.536 81.7969L319.616 82.0919L319.697 82.4673L319.777 82.8427L319.858 83.245L319.938 83.7545L319.992 84.264L320.045 84.8003V85.3366L320.099 85.873V86.0875L320.072 86.1411Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.627 114.432V86.2754",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.623 122.022C353.568 121.7 356.601 118.401 356.601 114.433",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.627 86.2755C356.627 82.3067 353.594 79.0083 349.648 78.6865",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.943 118.428L345.704 121.592",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.543 79.1152L326.971 82.1991",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.951 112.528C321.951 115.451 324.071 117.945 326.943 118.428",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.971 82.1992C324.072 82.6819 321.979 85.1758 321.979 88.0988",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.951 88.0986V112.528",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.627 169.46H366.45C367.658 169.46 368.624 170.425 368.624 171.632C368.624 172.839 367.658 173.804 366.45 173.804H356.627",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.812 168.44V174.769",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.841 168.951C368.841 168.951 368.841 168.923 368.812 168.923",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.812 174.314C368.812 174.314 368.813 174.314 368.841 174.286",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 168.44H364.465V169.459",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 174.77H364.465V173.777",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.429 171.605C369.429 170.693 369.241 169.781 368.865 168.95",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.838 174.287C369.214 173.455 369.401 172.544 369.401 171.632",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.951 168.146H320.072",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.951 174.903H320.072",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.969 192.87V190.376",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.969 152.806V150.366",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.68 190.832V192.87",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.68 150.366V152.351",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 143.448L342.859 148.168",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.522 144.788C348.898 143.662 348.28 142.429 347.126 142.053C345.972 141.678 344.764 142.295 344.389 143.448",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.522 144.789L347.395 148.222",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 140.847V143.475",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 141.195V141.329",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.764 140.847V147.175",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.792 141.357C348.792 141.357 348.792 141.329 348.764 141.329",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.791 146.344V141.356",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.764 146.721C348.764 146.721 348.764 146.721 348.792 146.692",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.791 146.344V146.692",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.361 143.555V141.356",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.39 141.329C344.39 141.329 344.39 141.329 344.361 141.357",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 140.847H348.763",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.744 147.176H348.764",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.355 144.011C349.355 143.1 349.167 142.188 348.791 141.356",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.791 146.693C349.167 145.862 349.355 144.95 349.355 144.038",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.362 141.356C343.987 142.188 343.799 143.1 343.799 144.011",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.799 144.011C343.799 144.359 343.826 144.708 343.879 145.03",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.112 148.221H318.838C318.542 148.221 318.301 148.462 318.301 148.757V149.856C318.301 150.151 318.542 150.393 318.838 150.393H349.112C349.407 150.393 349.649 150.151 349.649 149.856V148.757C349.649 148.462 349.407 148.221 349.112 148.221Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 199.789L342.832 195.016",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.522 198.448C348.898 199.575 348.28 200.808 347.126 201.184C345.972 201.559 344.764 200.942 344.389 199.789",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.522 198.448L347.395 195.016",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 202.39V199.762",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 202.041V201.907",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.764 202.39V196.062",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.792 201.88C348.792 201.88 348.792 201.908 348.764 201.908",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.789 196.866V201.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.764 196.518C348.764 196.518 348.764 196.518 348.792 196.546",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.789 196.866V196.544",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.361 199.682V201.881",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.39 201.908C344.39 201.908 344.39 201.908 344.361 201.88",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.389 202.39H348.763",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.744 196.062H348.764",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.353 199.226C349.353 200.137 349.165 201.049 348.789 201.88",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.789 196.544C349.165 197.375 349.353 198.287 349.353 199.199",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.362 201.88C343.987 201.049 343.799 200.137 343.799 199.226",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.799 199.226C343.799 198.877 343.826 198.529 343.879 198.207",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.112 192.87H318.838C318.542 192.87 318.301 193.111 318.301 193.406V194.506C318.301 194.801 318.542 195.042 318.838 195.042H349.112C349.407 195.042 349.649 194.801 349.649 194.506V193.406C349.649 193.111 349.407 192.87 349.112 192.87Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.073 185.576C320.073 185.871 319.885 187.319 319.858 187.426C319.59 189.732 318.892 191.18 318.14 190.751L311.94 187.238C311.43 186.943 311.055 185.441 311.055 183.672V159.242C311.055 157.472 311.43 155.97 311.967 155.675L318.167 152.216C318.167 152.216 318.328 152.136 318.435 152.136C319.294 152.136 320.099 154.496 320.099 157.392",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14 190.725C318.14 191.1 318.006 191.475 317.818 191.824C317.174 192.977 315.779 193.406 314.705 192.789",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.705 150.152C315.027 149.964 315.376 149.884 315.752 149.884C317.013 149.884 318.087 150.93 318.14 152.217",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.072 157.392V185.656V186.193V186.729L320.019 187.265L319.965 187.775L319.884 188.284L319.831 188.687L319.75 189.062L319.67 189.437L319.589 189.759L319.482 190.135L319.374 190.43L319.267 190.698L319.16 190.939L319.026 191.181L318.891 191.422L318.784 191.583L318.65 191.77L318.516 191.931L318.381 192.092L318.247 192.226L318.113 192.36L317.952 192.495L317.764 192.629L317.576 192.736L317.415 192.816L317.227 192.897L317.093 192.95L316.905 193.004L316.717 193.058H316.53L316.342 193.111H316.154H315.966H315.805L315.644 193.058L315.456 193.004L315.268 192.95L315.08 192.87L314.892 192.789L314.785 192.736L308.585 189.223H308.532L308.344 189.062L308.156 188.928L307.995 188.794L307.861 188.633L307.726 188.472L307.592 188.284L307.458 188.097L307.351 187.909C306.867 187.051 306.572 185.388 306.572 183.592V159.162C306.572 157.365 306.867 155.703 307.351 154.845L307.458 154.657L307.592 154.469L307.726 154.281L307.861 154.121L307.995 153.986L308.156 153.852L308.344 153.718L308.478 153.638L308.612 153.557L314.812 150.098L315 149.991L315.188 149.91L315.375 149.83L315.563 149.776H315.751L315.912 149.723H316.046H316.234H316.422L316.61 149.749H316.798L316.986 149.857L317.174 149.937L317.308 149.991L317.469 150.071L317.657 150.179L317.845 150.313L317.979 150.42L318.14 150.554L318.301 150.715L318.462 150.876L318.596 151.037L318.73 151.198L318.865 151.439L318.999 151.68L319.106 151.868L319.213 152.109L319.321 152.377L319.428 152.699L319.536 153.048L319.616 153.343L319.697 153.718L319.777 154.094L319.858 154.496L319.938 155.005L319.992 155.515L320.045 156.051V156.588L320.099 157.124V157.338L320.072 157.392Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.627 185.683V157.526",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.623 193.273C353.568 192.951 356.601 189.652 356.601 185.684",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.627 157.526C356.627 153.558 353.594 150.259 349.648 149.938",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.943 189.706L345.704 192.87",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.543 150.366L326.971 153.45",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.951 183.779C321.951 186.702 324.071 189.196 326.943 189.679",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.971 153.45C324.072 153.933 321.979 156.427 321.979 159.35",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.951 159.377V183.78",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.026 54.7129H373.08C372.902 54.7129 372.758 54.857 372.758 55.0347V213.706C372.758 213.884 372.902 214.028 373.08 214.028H427.026C427.204 214.028 427.348 213.884 427.348 213.706V55.0347C427.348 54.857 427.204 54.7129 427.026 54.7129Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.133 209.657V54.7129",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.758 209.657V54.7129",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.758 209.657H377.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.758 54.7129H377.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.001 136.556H377.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.001 132.185H377.133",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.133 136.556V132.185",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 136.556V132.185",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.879 132.185V59.084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.227 132.185V59.084",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.879 59.084H402.227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.879 132.185H402.227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.879 209.657V136.556",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.227 209.657V136.556",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.879 136.556H402.227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.879 209.657H402.227",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.348 214.028V54.7129",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 214.028V54.7129",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 214.028H427.348",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 54.7129H427.348",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.133 54.7129H423.001",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.133 59.084H423.001",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 59.0839V54.7129",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.133 59.0839V54.7129",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.133 214.028H423.001",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.133 209.657H423.001",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 209.657V214.028",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.133 209.657V214.028",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.363 142.16H434.434",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.363 142.16C421.068 142.16 420.826 142.401 420.826 142.696",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 142.696V150.875",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.971 142.696V150.875",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.97 142.696C434.97 142.401 434.729 142.16 434.434 142.16",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 150.876H434.97",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.483 144.279C423.75 144.279 423.966 144.063 423.966 143.796C423.966 143.53 423.75 143.313 423.483 143.313C423.216 143.313 423 143.53 423 143.796C423 144.063 423.216 144.279 423.483 144.279Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.483 149.722C423.75 149.722 423.966 149.506 423.966 149.24C423.966 148.973 423.75 148.757 423.483 148.757C423.216 148.757 423 148.973 423 149.24C423 149.506 423.216 149.722 423.483 149.722Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 144.279C432.58 144.279 432.796 144.063 432.796 143.796C432.796 143.53 432.58 143.313 432.313 143.313C432.046 143.313 431.83 143.53 431.83 143.796C431.83 144.063 432.046 144.279 432.313 144.279Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 149.722C432.58 149.722 432.796 149.506 432.796 149.24C432.796 148.973 432.58 148.757 432.313 148.757C432.046 148.757 431.83 148.973 431.83 149.24C431.83 149.506 432.046 149.722 432.313 149.722Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.363 126.901H434.434",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.363 126.902C421.068 126.902 420.826 126.66 420.826 126.365",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 126.365V118.187",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.971 126.365V118.187",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.97 126.365C434.97 126.66 434.729 126.902 434.434 126.902",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 118.187H434.97",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.483 125.749C423.75 125.749 423.966 125.532 423.966 125.266C423.966 124.999 423.75 124.783 423.483 124.783C423.216 124.783 423 124.999 423 125.266C423 125.532 423.216 125.749 423.483 125.749Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.483 120.305C423.75 120.305 423.966 120.089 423.966 119.823C423.966 119.556 423.75 119.34 423.483 119.34C423.216 119.34 423 119.556 423 119.823C423 120.089 423.216 120.305 423.483 120.305Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 125.749C432.58 125.749 432.796 125.532 432.796 125.266C432.796 124.999 432.58 124.783 432.313 124.783C432.046 124.783 431.83 124.999 431.83 125.266C431.83 125.532 432.046 125.749 432.313 125.749Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 120.305C432.58 120.305 432.796 120.089 432.796 119.823C432.796 119.556 432.58 119.34 432.313 119.34C432.046 119.34 431.83 119.556 431.83 119.823C431.83 120.089 432.046 120.305 432.313 120.305Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 165.034H421.363",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 165.034C434.729 165.034 434.97 164.793 434.97 164.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.971 164.471V159.591",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 164.471V159.591",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 164.472C420.826 164.767 421.068 165.008 421.363 165.008",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.97 159.591H420.826",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 163.318C432.58 163.318 432.796 163.102 432.796 162.835C432.796 162.569 432.58 162.353 432.313 162.353C432.046 162.353 431.83 162.569 431.83 162.835C431.83 163.102 432.046 163.318 432.313 163.318Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.483 163.318C423.75 163.318 423.966 163.102 423.966 162.835C423.966 162.569 423.75 162.353 423.483 162.353C423.216 162.353 423 162.569 423 162.835C423 163.102 423.216 163.318 423.483 163.318Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 104.055H421.363",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 104.055C434.729 104.055 434.97 104.296 434.97 104.591",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.971 104.591V109.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 104.591V109.498",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 104.591C420.826 104.296 421.068 104.055 421.363 104.055",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.97 109.498H420.826",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 106.71C432.58 106.71 432.796 106.493 432.796 106.227C432.796 105.96 432.58 105.744 432.313 105.744C432.046 105.744 431.83 105.96 431.83 106.227C431.83 106.493 432.046 106.71 432.313 106.71Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.483 106.71C423.75 106.71 423.966 106.493 423.966 106.227C423.966 105.96 423.75 105.744 423.483 105.744C423.216 105.744 423 105.96 423 106.227C423 106.493 423.216 106.71 423.483 106.71Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 64.8486H421.363",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 64.8486C434.729 64.8486 434.97 65.09 434.97 65.385",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.971 65.3857V70.2931",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 65.3857V70.2931",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 65.385C420.826 65.09 421.068 64.8486 421.363 64.8486",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.97 70.293H420.826",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 67.5035C432.58 67.5035 432.796 67.2874 432.796 67.0208C432.796 66.7542 432.58 66.5381 432.313 66.5381C432.046 66.5381 431.83 66.7542 431.83 67.0208C431.83 67.2874 432.046 67.5035 432.313 67.5035Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.483 67.5035C423.75 67.5035 423.966 67.2874 423.966 67.0208C423.966 66.7542 423.75 66.5381 423.483 66.5381C423.216 66.5381 423 66.7542 423 67.0208C423 67.2874 423.216 67.5035 423.483 67.5035Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 204.213H421.363",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 204.213C434.729 204.213 434.97 203.972 434.97 203.677",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.971 203.677V198.77",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 203.677V198.77",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.826 203.677C420.826 203.972 421.068 204.213 421.363 204.213",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.97 198.77H420.826",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 202.524C432.58 202.524 432.796 202.308 432.796 202.041C432.796 201.775 432.58 201.559 432.313 201.559C432.046 201.559 431.83 201.775 431.83 202.041C431.83 202.308 432.046 202.524 432.313 202.524Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.483 202.524C423.75 202.524 423.966 202.308 423.966 202.041C423.966 201.775 423.75 201.559 423.483 201.559C423.216 201.559 423 201.775 423 202.041C423 202.308 423.216 202.524 423.483 202.524Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.305 130.71V138.353",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.304 130.71C441.304 130.415 441.063 130.174 440.768 130.174",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.13 135.188C439.486 135.188 439.775 134.899 439.775 134.544C439.775 134.189 439.486 133.9 439.13 133.9C438.775 133.9 438.486 134.189 438.486 134.544C438.486 134.899 438.775 135.188 439.13 135.188Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.321 137.092C435.529 137.092 435.697 136.924 435.697 136.716C435.697 136.509 435.529 136.341 435.321 136.341C435.114 136.341 434.945 136.509 434.945 136.716C434.945 136.924 435.114 137.092 435.321 137.092Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.321 132.721C435.529 132.721 435.697 132.553 435.697 132.345C435.697 132.138 435.529 131.97 435.321 131.97C435.114 131.97 434.945 132.138 434.945 132.345C434.945 132.553 435.114 132.721 435.321 132.721Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.537 188.981V180.266",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.189 188.445V180.803",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.538 188.981H419.727",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.189 188.445C419.189 188.74 419.431 188.982 419.726 188.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.538 180.266H419.727",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.726 180.266C419.431 180.266 419.189 180.507 419.189 180.802",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.215 188.981V180.266",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.264 181.955C419.996 181.955 419.781 182.17 419.781 182.438C419.781 182.706 419.996 182.92 420.264 182.92",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.363 182.948C421.632 182.948 421.846 182.733 421.846 182.465C421.846 182.197 421.632 181.982 421.363 181.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.364 182.947H420.264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.364 181.955H420.264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.264 186.3C419.996 186.3 419.781 186.514 419.781 186.782C419.781 187.051 419.996 187.265 420.264 187.265",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.363 187.292C421.632 187.292 421.846 187.077 421.846 186.809C421.846 186.541 421.632 186.326 421.363 186.326",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.364 187.292H420.264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.364 186.3H420.264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 188.981V180.266",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.607 188.445V180.803",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 188.981H436.071",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.609 188.445C436.609 188.74 436.367 188.982 436.072 188.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 180.266H436.071",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.072 180.266C436.367 180.266 436.609 180.507 436.609 180.802",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.582 188.981V180.266",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.535 181.955C435.804 181.955 436.018 182.17 436.018 182.438C436.018 182.706 435.804 182.92 435.535 182.92",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 182.948C434.166 182.948 433.951 182.733 433.951 182.465C433.951 182.197 434.166 181.982 434.434 181.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 182.947H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 181.955H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.535 186.3C435.804 186.3 436.018 186.514 436.018 186.782C436.018 187.051 435.804 187.265 435.535 187.265",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 187.292C434.166 187.292 433.951 187.077 433.951 186.809C433.951 186.541 434.166 186.326 434.434 186.326",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 187.292H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 186.3H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.537 88.7963V80.0811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.189 88.2598V80.6172",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.538 88.7959H419.727",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.189 88.2598C419.189 88.5547 419.431 88.7961 419.726 88.7961",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.538 80.0811H419.727",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.726 80.0811C419.431 80.0811 419.189 80.3224 419.189 80.6174",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.215 88.7963V80.0811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.264 81.7705C419.996 81.7705 419.781 81.985 419.781 82.2532C419.781 82.5214 419.996 82.7359 420.264 82.7359",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.363 82.7623C421.632 82.7623 421.846 82.5477 421.846 82.2796C421.846 82.0114 421.632 81.7969 421.363 81.7969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.364 82.7627H420.264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.364 81.7705H420.264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.264 86.1143C419.996 86.1143 419.781 86.3288 419.781 86.597C419.781 86.8651 419.996 87.0796 420.264 87.0796",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.363 87.107C421.632 87.107 421.846 86.8925 421.846 86.6243C421.846 86.3561 421.632 86.1416 421.363 86.1416",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.364 87.1064H420.264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.364 86.1143H420.264",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 88.7963V80.0811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.607 88.2598V80.6172",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 88.7959H436.071",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.609 88.2598C436.609 88.5547 436.367 88.7961 436.072 88.7961",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 80.0811H436.071",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.072 80.0811C436.367 80.0811 436.609 80.3224 436.609 80.6174",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.582 88.7963V80.0811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.535 81.7705C435.804 81.7705 436.018 81.985 436.018 82.2532C436.018 82.5214 435.804 82.7359 435.535 82.7359",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 82.7623C434.166 82.7623 433.951 82.5477 433.951 82.2796C433.951 82.0114 434.166 81.7969 434.434 81.7969",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 82.7627H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 81.7705H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.535 86.1143C435.804 86.1143 436.018 86.3288 436.018 86.597C436.018 86.8651 435.804 87.0796 435.535 87.0796",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 87.107C434.166 87.107 433.951 86.8925 433.951 86.6243C433.951 86.3561 434.166 86.1416 434.434 86.1416",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 87.1064H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 86.1143H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.701 188.981H440.769",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.768 188.982C441.063 188.982 441.304 188.74 441.304 188.445",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.137 180.803V188.445",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.137 188.445C415.137 188.74 415.378 188.982 415.673 188.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.305 180.803V188.445",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.304 180.802C441.304 180.507 441.063 180.266 440.768 180.266",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.701 180.266H440.769",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.701 180.266C415.406 180.266 415.164 180.507 415.164 180.802",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.13 185.28C439.486 185.28 439.775 184.992 439.775 184.637C439.775 184.281 439.486 183.993 439.13 183.993C438.775 183.993 438.486 184.281 438.486 184.637C438.486 184.992 438.775 185.28 439.13 185.28Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.321 187.184C435.529 187.184 435.697 187.016 435.697 186.809C435.697 186.602 435.529 186.434 435.321 186.434C435.114 186.434 434.945 186.602 434.945 186.809C434.945 187.016 435.114 187.184 435.321 187.184Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.321 182.813C435.529 182.813 435.697 182.645 435.697 182.438C435.697 182.231 435.529 182.062 435.321 182.062C435.114 182.062 434.945 182.231 434.945 182.438C434.945 182.645 435.114 182.813 435.321 182.813Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.149 182.813C421.357 182.813 421.525 182.645 421.525 182.438C421.525 182.231 421.357 182.062 421.149 182.062C420.942 182.062 420.773 182.231 420.773 182.438C420.773 182.645 420.942 182.813 421.149 182.813Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.149 187.184C421.357 187.184 421.525 187.016 421.525 186.809C421.525 186.602 421.357 186.434 421.149 186.434C420.942 186.434 420.773 186.602 420.773 186.809C420.773 187.016 420.942 187.184 421.149 187.184Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.337 185.28C417.693 185.28 417.982 184.992 417.982 184.637C417.982 184.281 417.693 183.993 417.337 183.993C416.982 183.993 416.693 184.281 416.693 184.637C416.693 184.992 416.982 185.28 417.337 185.28Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.701 88.7959H440.769",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.768 88.7961C441.063 88.7961 441.304 88.5547 441.304 88.2598",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.137 80.6172V88.2598",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.137 88.2598C415.137 88.5547 415.378 88.7961 415.673 88.7961",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.305 80.6172V88.2598",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.304 80.6174C441.304 80.3224 441.063 80.0811 440.768 80.0811",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.701 80.0811H440.769",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.701 80.0811C415.406 80.0811 415.164 80.3224 415.164 80.6174",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.13 85.0958C439.486 85.0958 439.775 84.8076 439.775 84.4522C439.775 84.0967 439.486 83.8086 439.13 83.8086C438.775 83.8086 438.486 84.0967 438.486 84.4522C438.486 84.8076 438.775 85.0958 439.13 85.0958Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.321 86.9989C435.529 86.9989 435.697 86.8308 435.697 86.6235C435.697 86.4161 435.529 86.248 435.321 86.248C435.114 86.248 434.945 86.4161 434.945 86.6235C434.945 86.8308 435.114 86.9989 435.321 86.9989Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.321 82.6278C435.529 82.6278 435.697 82.4597 435.697 82.2524C435.697 82.045 435.529 81.877 435.321 81.877C435.114 81.877 434.945 82.045 434.945 82.2524C434.945 82.4597 435.114 82.6278 435.321 82.6278Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.149 82.6278C421.357 82.6278 421.525 82.4597 421.525 82.2524C421.525 82.045 421.357 81.877 421.149 81.877C420.942 81.877 420.773 82.045 420.773 82.2524C420.773 82.4597 420.942 82.6278 421.149 82.6278Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.149 86.9989C421.357 86.9989 421.525 86.8308 421.525 86.6235C421.525 86.4161 421.357 86.248 421.149 86.248C420.942 86.248 420.773 86.4161 420.773 86.6235C420.773 86.8308 420.942 86.9989 421.149 86.9989Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.337 85.0958C417.693 85.0958 417.982 84.8076 417.982 84.4522C417.982 84.0967 417.693 83.8086 417.337 83.8086C416.982 83.8086 416.693 84.0967 416.693 84.4522C416.693 84.8076 416.982 85.0958 417.337 85.0958Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 138.889V130.174",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.607 138.353V130.71",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 138.889H436.071",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.609 138.353C436.609 138.648 436.367 138.889 436.072 138.889",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.26 130.174H436.071",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.072 130.174C436.367 130.174 436.609 130.415 436.609 130.71",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.582 138.889V130.174",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.535 131.863C435.804 131.863 436.018 132.078 436.018 132.346C436.018 132.614 435.804 132.829 435.535 132.829",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 132.855C434.166 132.855 433.951 132.641 433.951 132.372C433.951 132.104 434.166 131.89 434.434 131.89",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 132.855H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 131.863H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.535 136.207C435.804 136.207 436.018 136.422 436.018 136.69C436.018 136.958 435.804 137.172 435.535 137.172",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 137.199C434.166 137.199 433.951 136.984 433.951 136.716C433.951 136.448 434.166 136.233 434.434 136.233",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 137.199H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.434 136.207H435.534",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.304 130.71C441.304 130.415 441.063 130.174 440.768 130.174",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.13 135.188C439.486 135.188 439.775 134.899 439.775 134.544C439.775 134.189 439.486 133.9 439.13 133.9C438.775 133.9 438.486 134.189 438.486 134.544C438.486 134.899 438.775 135.188 439.13 135.188Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.321 137.092C435.529 137.092 435.697 136.924 435.697 136.716C435.697 136.509 435.529 136.341 435.321 136.341C435.114 136.341 434.945 136.509 434.945 136.716C434.945 136.924 435.114 137.092 435.321 137.092Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.321 132.721C435.529 132.721 435.697 132.553 435.697 132.345C435.697 132.138 435.529 131.97 435.321 131.97C435.114 131.97 434.945 132.138 434.945 132.345C434.945 132.553 435.114 132.721 435.321 132.721Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.636 205.742C432.888 205.742 433.092 205.538 433.092 205.286C433.092 205.034 432.888 204.83 432.636 204.83C432.384 204.83 432.18 205.034 432.18 205.286C432.18 205.538 432.384 205.742 432.636 205.742Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.636 208.155C432.888 208.155 433.092 207.951 433.092 207.699C433.092 207.447 432.888 207.243 432.636 207.243C432.384 207.243 432.18 207.447 432.18 207.699C432.18 207.951 432.384 208.155 432.636 208.155Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.821 205.742C441.073 205.742 441.278 205.538 441.278 205.286C441.278 205.034 441.073 204.83 440.821 204.83C440.57 204.83 440.365 205.034 440.365 205.286C440.365 205.538 440.57 205.742 440.821 205.742Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.821 208.155C441.073 208.155 441.278 207.951 441.278 207.699C441.278 207.447 441.073 207.243 440.821 207.243C440.57 207.243 440.365 207.447 440.365 207.699C440.365 207.951 440.57 208.155 440.821 208.155Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.429 205.742C454.681 205.742 454.885 205.538 454.885 205.286C454.885 205.034 454.681 204.83 454.429 204.83C454.177 204.83 453.973 205.034 453.973 205.286C453.973 205.538 454.177 205.742 454.429 205.742Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.429 208.155C454.681 208.155 454.885 207.951 454.885 207.699C454.885 207.447 454.681 207.243 454.429 207.243C454.177 207.243 453.973 207.447 453.973 207.699C453.973 207.951 454.177 208.155 454.429 208.155Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.614 205.742C462.866 205.742 463.071 205.538 463.071 205.286C463.071 205.034 462.866 204.83 462.614 204.83C462.362 204.83 462.158 205.034 462.158 205.286C462.158 205.538 462.362 205.742 462.614 205.742Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.614 208.155C462.866 208.155 463.071 207.951 463.071 207.699C463.071 207.447 462.866 207.243 462.614 207.243C462.362 207.243 462.158 207.447 462.158 207.699C462.158 207.951 462.362 208.155 462.614 208.155Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.636 63.3209C432.888 63.3209 433.092 63.1168 433.092 62.8651C433.092 62.6133 432.888 62.4092 432.636 62.4092C432.384 62.4092 432.18 62.6133 432.18 62.8651C432.18 63.1168 432.384 63.3209 432.636 63.3209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.636 60.9069C432.888 60.9069 433.092 60.7028 433.092 60.451C433.092 60.1992 432.888 59.9951 432.636 59.9951C432.384 59.9951 432.18 60.1992 432.18 60.451C432.18 60.7028 432.384 60.9069 432.636 60.9069Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.821 63.3209C441.073 63.3209 441.278 63.1168 441.278 62.8651C441.278 62.6133 441.073 62.4092 440.821 62.4092C440.57 62.4092 440.365 62.6133 440.365 62.8651C440.365 63.1168 440.57 63.3209 440.821 63.3209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.821 60.9069C441.073 60.9069 441.278 60.7028 441.278 60.451C441.278 60.1992 441.073 59.9951 440.821 59.9951C440.57 59.9951 440.365 60.1992 440.365 60.451C440.365 60.7028 440.57 60.9069 440.821 60.9069Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.429 63.3209C454.681 63.3209 454.885 63.1168 454.885 62.8651C454.885 62.6133 454.681 62.4092 454.429 62.4092C454.177 62.4092 453.973 62.6133 453.973 62.8651C453.973 63.1168 454.177 63.3209 454.429 63.3209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.429 60.9069C454.681 60.9069 454.885 60.7028 454.885 60.451C454.885 60.1992 454.681 59.9951 454.429 59.9951C454.177 59.9951 453.973 60.1992 453.973 60.451C453.973 60.7028 454.177 60.9069 454.429 60.9069Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.614 63.3209C462.866 63.3209 463.071 63.1168 463.071 62.8651C463.071 62.6133 462.866 62.4092 462.614 62.4092C462.362 62.4092 462.158 62.6133 462.158 62.8651C462.158 63.1168 462.362 63.3209 462.614 63.3209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.614 60.9069C462.866 60.9069 463.071 60.7028 463.071 60.451C463.071 60.1992 462.866 59.9951 462.614 59.9951C462.362 59.9951 462.158 60.1992 462.158 60.451C462.158 60.7028 462.362 60.9069 462.614 60.9069Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.751 201.853C404.899 201.853 405.019 201.733 405.019 201.585C405.019 201.436 404.899 201.316 404.751 201.316C404.603 201.316 404.482 201.436 404.482 201.585C404.482 201.733 404.603 201.853 404.751 201.853Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.095 201.853C421.243 201.853 421.363 201.733 421.363 201.585C421.363 201.436 421.243 201.316 421.095 201.316C420.946 201.316 420.826 201.436 420.826 201.585C420.826 201.733 420.946 201.853 421.095 201.853Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.206 201.853C598.354 201.853 598.474 201.733 598.474 201.585C598.474 201.436 598.354 201.316 598.206 201.316C598.058 201.316 597.938 201.436 597.938 201.585C597.938 201.733 598.058 201.853 598.206 201.853Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.454 201.853C601.602 201.853 601.722 201.733 601.722 201.585C601.722 201.436 601.602 201.316 601.454 201.316C601.306 201.316 601.186 201.436 601.186 201.585C601.186 201.733 601.306 201.853 601.454 201.853Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.751 184.423C404.899 184.423 405.019 184.303 405.019 184.155C405.019 184.007 404.899 183.887 404.751 183.887C404.603 183.887 404.482 184.007 404.482 184.155C404.482 184.303 404.603 184.423 404.751 184.423Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.546 184.423C414.694 184.423 414.814 184.303 414.814 184.155C414.814 184.007 414.694 183.887 414.546 183.887C414.398 183.887 414.277 184.007 414.277 184.155C414.277 184.303 414.398 184.423 414.546 184.423Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.206 184.423C598.354 184.423 598.474 184.303 598.474 184.155C598.474 184.007 598.354 183.887 598.206 183.887C598.058 183.887 597.938 184.007 597.938 184.155C597.938 184.303 598.058 184.423 598.206 184.423Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.751 159.376C404.899 159.376 405.019 159.256 405.019 159.108C405.019 158.96 404.899 158.84 404.751 158.84C404.603 158.84 404.482 158.96 404.482 159.108C404.482 159.256 404.603 159.376 404.751 159.376Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.095 159.376C421.243 159.376 421.363 159.256 421.363 159.108C421.363 158.96 421.243 158.84 421.095 158.84C420.946 158.84 420.826 158.96 420.826 159.108C420.826 159.256 420.946 159.376 421.095 159.376Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.454 159.376C601.602 159.376 601.722 159.256 601.722 159.108C601.722 158.96 601.602 158.84 601.454 158.84C601.306 158.84 601.186 158.96 601.186 159.108C601.186 159.256 601.306 159.376 601.454 159.376Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.206 134.33C598.354 134.33 598.474 134.21 598.474 134.062C598.474 133.914 598.354 133.794 598.206 133.794C598.058 133.794 597.938 133.914 597.938 134.062C597.938 134.21 598.058 134.33 598.206 134.33Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.454 134.33C601.602 134.33 601.722 134.21 601.722 134.062C601.722 133.914 601.602 133.794 601.454 133.794C601.306 133.794 601.186 133.914 601.186 134.062C601.186 134.21 601.306 134.33 601.454 134.33Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.751 66.8332C404.899 66.8332 405.019 66.7131 405.019 66.565C405.019 66.4169 404.899 66.2969 404.751 66.2969C404.603 66.2969 404.482 66.4169 404.482 66.565C404.482 66.7131 404.603 66.8332 404.751 66.8332Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.095 66.8332C421.243 66.8332 421.363 66.7131 421.363 66.565C421.363 66.4169 421.243 66.2969 421.095 66.2969C420.946 66.2969 420.826 66.4169 420.826 66.565C420.826 66.7131 420.946 66.8332 421.095 66.8332Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.206 66.8332C598.354 66.8332 598.474 66.7131 598.474 66.565C598.474 66.4169 598.354 66.2969 598.206 66.2969C598.058 66.2969 597.938 66.4169 597.938 66.565C597.938 66.7131 598.058 66.8332 598.206 66.8332Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.454 66.8332C601.602 66.8332 601.722 66.7131 601.722 66.565C601.722 66.4169 601.602 66.2969 601.454 66.2969C601.306 66.2969 601.186 66.4169 601.186 66.565C601.186 66.7131 601.306 66.8332 601.454 66.8332Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.751 84.2375C404.899 84.2375 405.019 84.1174 405.019 83.9693C405.019 83.8212 404.899 83.7012 404.751 83.7012C404.603 83.7012 404.482 83.8212 404.482 83.9693C404.482 84.1174 404.603 84.2375 404.751 84.2375Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.546 84.2375C414.694 84.2375 414.814 84.1174 414.814 83.9693C414.814 83.8212 414.694 83.7012 414.546 83.7012C414.398 83.7012 414.277 83.8212 414.277 83.9693C414.277 84.1174 414.398 84.2375 414.546 84.2375Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.206 84.2375C598.354 84.2375 598.474 84.1174 598.474 83.9693C598.474 83.8212 598.354 83.7012 598.206 83.7012C598.058 83.7012 597.938 83.8212 597.938 83.9693C597.938 84.1174 598.058 84.2375 598.206 84.2375Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.751 109.283C404.899 109.283 405.019 109.163 405.019 109.015C405.019 108.867 404.899 108.747 404.751 108.747C404.603 108.747 404.482 108.867 404.482 109.015C404.482 109.163 404.603 109.283 404.751 109.283Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.095 109.283C421.243 109.283 421.363 109.163 421.363 109.015C421.363 108.867 421.243 108.747 421.095 108.747C420.946 108.747 420.826 108.867 420.826 109.015C420.826 109.163 420.946 109.283 421.095 109.283Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.454 109.283C601.602 109.283 601.722 109.163 601.722 109.015C601.722 108.867 601.602 108.747 601.454 108.747C601.306 108.747 601.186 108.867 601.186 109.015C601.186 109.163 601.306 109.283 601.454 109.283Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.198 66.8332C410.346 66.8332 410.466 66.7131 410.466 66.565C410.466 66.4169 410.346 66.2969 410.198 66.2969C410.05 66.2969 409.93 66.4169 409.93 66.565C409.93 66.7131 410.05 66.8332 410.198 66.8332Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.198 201.853C410.346 201.853 410.466 201.733 410.466 201.585C410.466 201.436 410.346 201.316 410.198 201.316C410.05 201.316 409.93 201.436 409.93 201.585C409.93 201.733 410.05 201.853 410.198 201.853Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 149.159L426.544 148.998",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.543 148.998V150.741",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.544 150.741L425.658 150.58",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.041 149.428V150.286",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 149.159V150.58",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 149.159C425.417 149.186 425.202 149.293 425.041 149.427",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.041 150.285C425.229 150.419 425.444 150.526 425.658 150.553",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.04 149.428C424.799 148.865 424.155 148.623 423.618 148.865C423.081 149.106 422.813 149.75 423.054 150.286C423.296 150.822 423.94 151.09 424.477 150.849C424.718 150.742 424.933 150.527 425.04 150.286",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.657 149.159C425.255 148.248 424.208 147.845 423.322 148.248C422.437 148.65 422.007 149.696 422.41 150.581C422.812 151.466 423.859 151.895 424.745 151.492C425.147 151.305 425.496 150.983 425.657 150.581",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 141.516L426.544 141.355",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.543 141.355V143.099",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.544 143.098L425.658 142.938",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.041 141.812V142.67",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 141.517V142.938",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 141.517C425.417 141.543 425.202 141.651 425.041 141.785",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.041 142.67C425.229 142.804 425.444 142.911 425.658 142.938",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.04 141.812C424.799 141.248 424.155 141.007 423.618 141.248C423.081 141.49 422.813 142.133 423.054 142.67C423.296 143.206 423.94 143.474 424.477 143.233C424.718 143.126 424.933 142.911 425.04 142.67",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.657 141.517C425.255 140.605 424.208 140.203 423.322 140.605C422.437 141.007 422.007 142.053 422.41 142.938C422.812 143.823 423.859 144.252 424.745 143.85C425.147 143.662 425.496 143.34 425.657 142.938",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 125.185L426.544 125.024",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.543 125.024V126.767",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.544 126.767L425.658 126.606",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.041 125.48V126.339",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 125.186V126.607",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 125.186C425.417 125.212 425.202 125.32 425.041 125.454",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.041 126.339C425.229 126.473 425.444 126.58 425.658 126.607",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.04 125.481C424.799 124.917 424.155 124.676 423.618 124.917C423.081 125.159 422.813 125.802 423.054 126.339C423.296 126.875 423.94 127.143 424.477 126.902C424.718 126.795 424.933 126.58 425.04 126.339",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.657 125.186C425.255 124.274 424.208 123.872 423.322 124.274C422.437 124.676 422.007 125.722 422.41 126.607C422.812 127.492 423.859 127.921 424.745 127.519C425.147 127.331 425.496 127.009 425.657 126.607",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 117.57L426.544 117.409",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.543 117.409V119.152",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.544 119.152L425.658 118.991",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.041 117.838V118.723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 117.569V118.991",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.658 117.569C425.417 117.596 425.202 117.703 425.041 117.838",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.041 118.723C425.229 118.857 425.444 118.964 425.658 118.991",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.04 117.838C424.799 117.275 424.155 117.033 423.618 117.275C423.081 117.516 422.813 118.16 423.054 118.696C423.296 119.232 423.94 119.501 424.477 119.259C424.718 119.152 424.933 118.937 425.04 118.696",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.657 117.57C425.255 116.658 424.208 116.256 423.322 116.658C422.437 117.06 422.007 118.106 422.41 118.991C422.812 119.876 423.859 120.305 424.745 119.903C425.147 119.715 425.496 119.393 425.657 118.991",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.199 202.121C410.495 202.121 410.736 201.881 410.736 201.585C410.736 201.289 410.495 201.049 410.199 201.049C409.902 201.049 409.662 201.289 409.662 201.585C409.662 201.881 409.902 202.121 410.199 202.121Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.095 202.121C421.392 202.121 421.632 201.881 421.632 201.585C421.632 201.289 421.392 201.049 421.095 201.049C420.799 201.049 420.559 201.289 420.559 201.585C420.559 201.881 420.799 202.121 421.095 202.121Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.547 184.691C414.843 184.691 415.083 184.451 415.083 184.154C415.083 183.858 414.843 183.618 414.547 183.618C414.25 183.618 414.01 183.858 414.01 184.154C414.01 184.451 414.25 184.691 414.547 184.691Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.095 159.644C421.392 159.644 421.632 159.404 421.632 159.108C421.632 158.811 421.392 158.571 421.095 158.571C420.799 158.571 420.559 158.811 420.559 159.108C420.559 159.404 420.799 159.644 421.095 159.644Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.095 109.552C421.392 109.552 421.632 109.312 421.632 109.016C421.632 108.72 421.392 108.479 421.095 108.479C420.799 108.479 420.559 108.72 420.559 109.016C420.559 109.312 420.799 109.552 421.095 109.552Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.547 84.5053C414.843 84.5053 415.083 84.2651 415.083 83.9689C415.083 83.6727 414.843 83.4326 414.547 83.4326C414.25 83.4326 414.01 83.6727 414.01 83.9689C414.01 84.2651 414.25 84.5053 414.547 84.5053Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.199 67.1019C410.495 67.1019 410.736 66.8618 410.736 66.5656C410.736 66.2694 410.495 66.0293 410.199 66.0293C409.902 66.0293 409.662 66.2694 409.662 66.5656C409.662 66.8618 409.902 67.1019 410.199 67.1019Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.095 67.1019C421.392 67.1019 421.632 66.8618 421.632 66.5656C421.632 66.2694 421.392 66.0293 421.095 66.0293C420.799 66.0293 420.559 66.2694 420.559 66.5656C420.559 66.8618 420.799 67.1019 421.095 67.1019Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.207 67.1019C598.503 67.1019 598.743 66.8618 598.743 66.5656C598.743 66.2694 598.503 66.0293 598.207 66.0293C597.91 66.0293 597.67 66.2694 597.67 66.5656C597.67 66.8618 597.91 67.1019 598.207 67.1019Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.455 67.1019C601.751 67.1019 601.992 66.8618 601.992 66.5656C601.992 66.2694 601.751 66.0293 601.455 66.0293C601.158 66.0293 600.918 66.2694 600.918 66.5656C600.918 66.8618 601.158 67.1019 601.455 67.1019Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.207 84.5053C598.503 84.5053 598.743 84.2651 598.743 83.9689C598.743 83.6727 598.503 83.4326 598.207 83.4326C597.91 83.4326 597.67 83.6727 597.67 83.9689C597.67 84.2651 597.91 84.5053 598.207 84.5053Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.455 109.552C601.751 109.552 601.992 109.312 601.992 109.016C601.992 108.72 601.751 108.479 601.455 108.479C601.158 108.479 600.918 108.72 600.918 109.016C600.918 109.312 601.158 109.552 601.455 109.552Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.455 134.598C601.751 134.598 601.992 134.358 601.992 134.062C601.992 133.766 601.751 133.525 601.455 133.525C601.158 133.525 600.918 133.766 600.918 134.062C600.918 134.358 601.158 134.598 601.455 134.598Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.207 134.598C598.503 134.598 598.743 134.358 598.743 134.062C598.743 133.766 598.503 133.525 598.207 133.525C597.91 133.525 597.67 133.766 597.67 134.062C597.67 134.358 597.91 134.598 598.207 134.598Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.455 159.644C601.751 159.644 601.992 159.404 601.992 159.108C601.992 158.811 601.751 158.571 601.455 158.571C601.158 158.571 600.918 158.811 600.918 159.108C600.918 159.404 601.158 159.644 601.455 159.644Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.207 184.691C598.503 184.691 598.743 184.451 598.743 184.154C598.743 183.858 598.503 183.618 598.207 183.618C597.91 183.618 597.67 183.858 597.67 184.154C597.67 184.451 597.91 184.691 598.207 184.691Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.455 202.121C601.751 202.121 601.992 201.881 601.992 201.585C601.992 201.289 601.751 201.049 601.455 201.049C601.158 201.049 600.918 201.289 600.918 201.585C600.918 201.881 601.158 202.121 601.455 202.121Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.207 202.121C598.503 202.121 598.743 201.881 598.743 201.585C598.743 201.289 598.503 201.049 598.207 201.049C597.91 201.049 597.67 201.289 597.67 201.585C597.67 201.881 597.91 202.121 598.207 202.121Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.279 208.209C599.516 208.209 599.708 208.017 599.708 207.78C599.708 207.543 599.516 207.351 599.279 207.351C599.042 207.351 598.85 207.543 598.85 207.78C598.85 208.017 599.042 208.209 599.279 208.209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.955 208.209C553.192 208.209 553.384 208.017 553.384 207.78C553.384 207.543 553.192 207.351 552.955 207.351C552.718 207.351 552.525 207.543 552.525 207.78C552.525 208.017 552.718 208.209 552.955 208.209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.631 208.209C506.868 208.209 507.06 208.017 507.06 207.78C507.06 207.543 506.868 207.351 506.631 207.351C506.393 207.351 506.201 207.543 506.201 207.78C506.201 208.017 506.393 208.209 506.631 208.209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.334 208.209C460.571 208.209 460.763 208.017 460.763 207.78C460.763 207.543 460.571 207.351 460.334 207.351C460.097 207.351 459.904 207.543 459.904 207.78C459.904 208.017 460.097 208.209 460.334 208.209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.01 208.209C414.247 208.209 414.439 208.017 414.439 207.78C414.439 207.543 414.247 207.351 414.01 207.351C413.772 207.351 413.58 207.543 413.58 207.78C413.58 208.017 413.772 208.209 414.01 208.209Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.279 60.7995C599.516 60.7995 599.708 60.6074 599.708 60.3705C599.708 60.1335 599.516 59.9414 599.279 59.9414C599.042 59.9414 598.85 60.1335 598.85 60.3705C598.85 60.6074 599.042 60.7995 599.279 60.7995Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.955 60.7995C553.192 60.7995 553.384 60.6074 553.384 60.3705C553.384 60.1335 553.192 59.9414 552.955 59.9414C552.718 59.9414 552.525 60.1335 552.525 60.3705C552.525 60.6074 552.718 60.7995 552.955 60.7995Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.631 60.7995C506.868 60.7995 507.06 60.6074 507.06 60.3705C507.06 60.1335 506.868 59.9414 506.631 59.9414C506.393 59.9414 506.201 60.1335 506.201 60.3705C506.201 60.6074 506.393 60.7995 506.631 60.7995Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.334 60.7995C460.571 60.7995 460.763 60.6074 460.763 60.3705C460.763 60.1335 460.571 59.9414 460.334 59.9414C460.097 59.9414 459.904 60.1335 459.904 60.3705C459.904 60.6074 460.097 60.7995 460.334 60.7995Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.01 60.7995C414.247 60.7995 414.439 60.6074 414.439 60.3705C414.439 60.1335 414.247 59.9414 414.01 59.9414C413.772 59.9414 413.58 60.1335 413.58 60.3705C413.58 60.6074 413.772 60.7995 414.01 60.7995Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.502 138.138V137.896",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.957 137.896V138.138",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.717 137.763C432.717 137.548 432.529 137.36 432.315 137.36C432.1 137.36 431.912 137.548 431.912 137.763",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.912 137.763C431.912 137.977 432.1 138.165 432.315 138.165C432.529 138.165 432.717 137.977 432.717 137.763",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.717 130.361C432.717 130.147 432.529 129.959 432.315 129.959C432.1 129.959 431.912 130.147 431.912 130.361",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.912 130.361C431.912 130.576 432.1 130.764 432.315 130.764C432.529 130.764 432.717 130.576 432.717 130.361",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.547 137.763C441.547 137.548 441.359 137.36 441.145 137.36C440.93 137.36 440.742 137.548 440.742 137.763",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.547 130.361C441.547 130.147 441.359 129.959 441.145 129.959C440.93 129.959 440.742 130.147 440.742 130.361",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.742 130.361C440.742 130.576 440.93 130.764 441.145 130.764C441.359 130.764 441.547 130.576 441.547 130.361",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.502 137.896H432.1",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.938 137.896H432.098",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.143 130.843C441.41 130.843 441.626 130.627 441.626 130.361C441.626 130.094 441.41 129.878 441.143 129.878C440.876 129.878 440.66 130.094 440.66 130.361C440.66 130.627 440.876 130.843 441.143 130.843Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 138.245C432.58 138.245 432.796 138.029 432.796 137.762C432.796 137.495 432.58 137.279 432.313 137.279C432.046 137.279 431.83 137.495 431.83 137.762C431.83 138.029 432.046 138.245 432.313 138.245Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 130.843C432.58 130.843 432.796 130.627 432.796 130.361C432.796 130.094 432.58 129.878 432.313 129.878C432.046 129.878 431.83 130.094 431.83 130.361C431.83 130.627 432.046 130.843 432.313 130.843Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 119.849C432.58 119.849 432.796 119.633 432.796 119.366C432.796 119.1 432.58 118.884 432.313 118.884C432.046 118.884 431.83 119.1 431.83 119.366C431.83 119.633 432.046 119.849 432.313 119.849Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.143 119.849C441.41 119.849 441.626 119.633 441.626 119.366C441.626 119.1 441.41 118.884 441.143 118.884C440.876 118.884 440.66 119.1 440.66 119.366C440.66 119.633 440.876 119.849 441.143 119.849Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.143 125.293C441.41 125.293 441.626 125.076 441.626 124.81C441.626 124.543 441.41 124.327 441.143 124.327C440.876 124.327 440.66 124.543 440.66 124.81C440.66 125.076 440.876 125.293 441.143 125.293Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 125.293C432.58 125.293 432.796 125.076 432.796 124.81C432.796 124.543 432.58 124.327 432.313 124.327C432.046 124.327 431.83 124.543 431.83 124.81C431.83 125.076 432.046 125.293 432.313 125.293Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 143.823C432.58 143.823 432.796 143.607 432.796 143.34C432.796 143.074 432.58 142.857 432.313 142.857C432.046 142.857 431.83 143.074 431.83 143.34C431.83 143.607 432.046 143.823 432.313 143.823Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.143 143.823C441.41 143.823 441.626 143.607 441.626 143.34C441.626 143.074 441.41 142.857 441.143 142.857C440.876 142.857 440.66 143.074 440.66 143.34C440.66 143.607 440.876 143.823 441.143 143.823Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.143 149.266C441.41 149.266 441.626 149.05 441.626 148.783C441.626 148.517 441.41 148.301 441.143 148.301C440.876 148.301 440.66 148.517 440.66 148.783C440.66 149.05 440.876 149.266 441.143 149.266Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.313 149.266C432.58 149.266 432.796 149.05 432.796 148.783C432.796 148.517 432.58 148.301 432.313 148.301C432.046 148.301 431.83 148.517 431.83 148.783C431.83 149.05 432.046 149.266 432.313 149.266Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.543 117.194V126.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.543 141.142V150.956",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 117.194V126.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 141.142V150.956",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.906 116.658H442.888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.906 117.194H442.888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 117.195V116.658",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 116.658H424.907",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.907 117.194H423.807",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.889 116.658H443.962",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 116.658V117.195",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.962 117.194H442.889",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.906 126.982H442.888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.906 127.545H442.888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 127.546V126.982",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 126.982H424.907",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.907 127.545H423.807",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.889 126.982H443.962",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 126.982V127.546",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.962 127.545H442.889",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.906 151.492H442.888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.906 150.956H442.888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 151.492H424.907",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 150.956V151.492",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.907 150.956H423.807",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 151.492V150.956",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.889 151.492H443.962",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.962 150.956H442.889",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 141.141V140.604",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.889 141.142H443.962",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.962 140.604H442.889",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.906 141.142H442.888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.906 140.604H442.888",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 140.604V141.141",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 141.142H424.907",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.907 140.604H423.807",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.823 205.875C441.149 205.875 441.413 205.611 441.413 205.285C441.413 204.959 441.149 204.695 440.823 204.695C440.497 204.695 440.232 204.959 440.232 205.285C440.232 205.611 440.497 205.875 440.823 205.875Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.823 208.289C441.149 208.289 441.413 208.025 441.413 207.699C441.413 207.374 441.149 207.109 440.823 207.109C440.497 207.109 440.232 207.374 440.232 207.699C440.232 208.025 440.497 208.289 440.823 208.289Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.635 208.289C432.961 208.289 433.226 208.025 433.226 207.699C433.226 207.374 432.961 207.109 432.635 207.109C432.309 207.109 432.045 207.374 432.045 207.699C432.045 208.025 432.309 208.289 432.635 208.289Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.635 205.875C432.961 205.875 433.226 205.611 433.226 205.285C433.226 204.959 432.961 204.695 432.635 204.695C432.309 204.695 432.045 204.959 432.045 205.285C432.045 205.611 432.309 205.875 432.635 205.875Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.616 205.875C462.942 205.875 463.206 205.611 463.206 205.285C463.206 204.959 462.942 204.695 462.616 204.695C462.29 204.695 462.025 204.959 462.025 205.285C462.025 205.611 462.29 205.875 462.616 205.875Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.616 208.289C462.942 208.289 463.206 208.025 463.206 207.699C463.206 207.374 462.942 207.109 462.616 207.109C462.29 207.109 462.025 207.374 462.025 207.699C462.025 208.025 462.29 208.289 462.616 208.289Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.43 208.289C454.756 208.289 455.021 208.025 455.021 207.699C455.021 207.374 454.756 207.109 454.43 207.109C454.104 207.109 453.84 207.374 453.84 207.699C453.84 208.025 454.104 208.289 454.43 208.289Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.43 205.875C454.756 205.875 455.021 205.611 455.021 205.285C455.021 204.959 454.756 204.695 454.43 204.695C454.104 204.695 453.84 204.959 453.84 205.285C453.84 205.611 454.104 205.875 454.43 205.875Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.823 63.4543C441.149 63.4543 441.413 63.1902 441.413 62.8644C441.413 62.5385 441.149 62.2744 440.823 62.2744C440.497 62.2744 440.232 62.5385 440.232 62.8644C440.232 63.1902 440.497 63.4543 440.823 63.4543Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.823 61.0412C441.149 61.0412 441.413 60.7771 441.413 60.4513C441.413 60.1255 441.149 59.8613 440.823 59.8613C440.497 59.8613 440.232 60.1255 440.232 60.4513C440.232 60.7771 440.497 61.0412 440.823 61.0412Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.635 61.0412C432.961 61.0412 433.226 60.7771 433.226 60.4513C433.226 60.1255 432.961 59.8613 432.635 59.8613C432.309 59.8613 432.045 60.1255 432.045 60.4513C432.045 60.7771 432.309 61.0412 432.635 61.0412Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.635 63.4543C432.961 63.4543 433.226 63.1902 433.226 62.8644C433.226 62.5385 432.961 62.2744 432.635 62.2744C432.309 62.2744 432.045 62.5385 432.045 62.8644C432.045 63.1902 432.309 63.4543 432.635 63.4543Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.616 63.4543C462.942 63.4543 463.206 63.1902 463.206 62.8644C463.206 62.5385 462.942 62.2744 462.616 62.2744C462.29 62.2744 462.025 62.5385 462.025 62.8644C462.025 63.1902 462.29 63.4543 462.616 63.4543Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.616 61.0412C462.942 61.0412 463.206 60.7771 463.206 60.4513C463.206 60.1255 462.942 59.8613 462.616 59.8613C462.29 59.8613 462.025 60.1255 462.025 60.4513C462.025 60.7771 462.29 61.0412 462.616 61.0412Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.43 61.0412C454.756 61.0412 455.021 60.7771 455.021 60.4513C455.021 60.1255 454.756 59.8613 454.43 59.8613C454.104 59.8613 453.84 60.1255 453.84 60.4513C453.84 60.7771 454.104 61.0412 454.43 61.0412Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.43 63.4543C454.756 63.4543 455.021 63.1902 455.021 62.8644C455.021 62.5385 454.756 62.2744 454.43 62.2744C454.104 62.2744 453.84 62.5385 453.84 62.8644C453.84 63.1902 454.104 63.4543 454.43 63.4543Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.313 57.6357H411.327C409.681 57.6357 408.348 58.9684 408.348 60.6123V207.538C408.348 209.182 409.681 210.515 411.327 210.515H602.313C603.959 210.515 605.293 209.182 605.293 207.538V60.6123C605.293 58.9684 603.959 57.6357 602.313 57.6357Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.943 205.313C604.943 206.573 603.923 207.566 602.688 207.566H405.368C404.106 207.566 403.113 206.547 403.113 205.313V62.8385C403.113 61.5781 404.133 60.5859 405.368 60.5859H602.688C603.95 60.5859 604.943 61.605 604.943 62.8385",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.703 64.9297H596.005V203.221H432.18",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.266 203.757H429.576V209.201H462.266V203.757Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.266 58.9229H429.576V64.3665H462.266V58.9229Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.801 202.685V195.739H440.446C439.882 195.739 439.426 195.284 439.426 194.72V192.387C439.426 191.824 439.882 191.368 440.446 191.368H443.801V76.4073H442.781H440.446C439.882 76.4073 439.426 75.9514 439.426 75.3882V73.0552C439.426 72.4921 439.882 72.0362 440.446 72.0362H443.801V65.0908",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.008 129.449V130.817H407.944V130.71H398.148V131.514H393.559C393.559 131.514 393.451 131.568 393.451 131.621V136.529C393.451 136.529 393.505 136.636 393.559 136.636H398.148V137.44H407.944V137.333H422.008V138.701H423.323V129.449H422.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.83 54.6055H423.43V214.564H431.83V54.6055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.073 54.1494H423.592V214.564H432.073V54.1494Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.115 55.0342V214.028",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.578 55.0342V214.028",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.073 214.027H423.592V214.564H432.073V214.027Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.073 54.1494H423.592V55.0343H432.073V54.1494Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.661 129.933H443.963V138.165H444.661V129.933Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.66 129.959H446.136C446.136 129.959 446.324 130.039 446.324 130.147V137.977C446.324 137.977 446.244 138.165 446.136 138.165H444.66V129.959Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.544 116.658H425.443V151.492H426.544V116.658Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 116.658V151.492",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 127.546H442.889H424.907H423.807V126.982H424.907H442.889H443.963",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.963 140.605H424.907H423.807V141.142H424.907H443.963",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.323 129.449H422.008V138.701H423.323",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.322 129.449V138.701",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.656 137.441H407.3H407.945V130.71H407.3H406.656",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.945 131.193H409.582V130.817H407.945",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.945 136.958H409.582V137.333H407.945",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.418 137.333H421.955V136.957V131.192V130.816H421.418",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.822 130.816V137.333",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.582 131.192C409.582 131.192 410.145 131.541 410.333 132.104H421.391V130.79H409.555V131.165L409.582 131.192Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.582 136.958C409.582 136.958 410.145 136.609 410.333 136.046H421.391V137.36H409.555V136.984L409.582 136.958Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.656 137.44H398.148V136.635H393.559C393.559 136.635 393.451 136.582 393.451 136.528V131.621C393.451 131.621 393.505 131.513 393.559 131.513H398.148V130.709H406.656V137.467V137.44Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.751 134.329C404.899 134.329 405.019 134.209 405.019 134.061C405.019 133.913 404.899 133.793 404.751 133.793C404.603 133.793 404.482 133.913 404.482 134.061C404.482 134.209 404.603 134.329 404.751 134.329Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.148 137.44V136.26V135.402V130.683",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.656 132.721H400.967H398.47H398.148",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.656 135.429H400.967H398.47H398.148",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.967 135.429V132.721",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.148 136.261H393.451H398.148Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.451 131.89H398.148",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.406 63.5352H452.576V205.473H600.406V63.5352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.176 74.3952H462.48V67.8252",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.57 74.3955H554.189",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.189 194.532H588.57V196.919",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.48 194.532H498.176",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.262 202.711H554.539",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.658 200.78V67.959",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.48 67.959V200.78",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.381 67.959V200.78",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.529 200.753V67.959",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.367 200.753V67.959",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.454 63.2666H452.309V67.9594H462.454V63.2666Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.454 200.753H452.309V205.446H462.454V200.753Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.084 200.78V67.959",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.262 67.959V125.238V200.78",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.32 200.753V67.959",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.973 200.753V67.959",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.261 67.9854H600.406V63.2925H590.261V67.9854Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.261 205.473H600.406V200.78H590.261V205.473Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.785 72.7328C585.081 72.7328 585.322 72.4927 585.322 72.1965C585.322 71.9003 585.081 71.6602 584.785 71.6602C584.488 71.6602 584.248 71.9003 584.248 72.1965C584.248 72.4927 584.488 72.7328 584.785 72.7328Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.939 72.7328C563.236 72.7328 563.476 72.4927 563.476 72.1965C563.476 71.9003 563.236 71.6602 562.939 71.6602C562.643 71.6602 562.402 71.9003 562.402 72.1965C562.402 72.4927 562.643 72.7328 562.939 72.7328Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.613 72.7328C493.909 72.7328 494.15 72.4927 494.15 72.1965C494.15 71.9003 493.909 71.6602 493.613 71.6602C493.316 71.6602 493.076 71.9003 493.076 72.1965C493.076 72.4927 493.316 72.7328 493.613 72.7328Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.785 197.455C585.081 197.455 585.322 197.215 585.322 196.919C585.322 196.623 585.081 196.383 584.785 196.383C584.488 196.383 584.248 196.623 584.248 196.919C584.248 197.215 584.488 197.455 584.785 197.455Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.939 197.455C563.236 197.455 563.476 197.215 563.476 196.919C563.476 196.623 563.236 196.383 562.939 196.383C562.643 196.383 562.402 196.623 562.402 196.919C562.402 197.215 562.643 197.455 562.939 197.455Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.613 197.455C493.909 197.455 494.15 197.215 494.15 196.919C494.15 196.623 493.909 196.383 493.613 196.383C493.316 196.383 493.076 196.623 493.076 196.919C493.076 197.215 493.316 197.455 493.613 197.455Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.176 202.711H462.48",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.176 66.4043H462.48",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.262 66.3232H554.539",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.176 67.959H462.48",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.176 201.102H462.48",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.48 63.6152H599.896C599.896 63.6152 600.084 63.6957 600.084 63.8029V205.285H462.48",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.787 135.107C585.083 135.107 585.324 134.867 585.324 134.571C585.324 134.274 585.083 134.034 584.787 134.034C584.49 134.034 584.25 134.274 584.25 134.571C584.25 134.867 584.49 135.107 584.787 135.107Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.941 135.107C563.238 135.107 563.478 134.867 563.478 134.571C563.478 134.274 563.238 134.034 562.941 134.034C562.645 134.034 562.404 134.274 562.404 134.571C562.404 134.867 562.645 135.107 562.941 135.107Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.482 135.107C539.779 135.107 540.019 134.867 540.019 134.571C540.019 134.274 539.779 134.034 539.482 134.034C539.186 134.034 538.945 134.274 538.945 134.571C538.945 134.867 539.186 135.107 539.482 135.107Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.261 135.107C513.558 135.107 513.798 134.867 513.798 134.571C513.798 134.274 513.558 134.034 513.261 134.034C512.965 134.034 512.725 134.274 512.725 134.571C512.725 134.867 512.965 135.107 513.261 135.107Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.615 135.107C493.911 135.107 494.152 134.867 494.152 134.571C494.152 134.274 493.911 134.034 493.615 134.034C493.318 134.034 493.078 134.274 493.078 134.571C493.078 134.867 493.318 135.107 493.615 135.107Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.255 126.365H462.4V142.723H591.255V126.365Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.801 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.047 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.812 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.062 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.748 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.994 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.732 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.982 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.916 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.668 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.652 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.93 187.988V81.0723",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.318 63.6152V66.3237H497.426V63.6152",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.178 66.3232V81.0722H554.54V66.3232",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.318 205.258V202.791H497.426V205.258",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.178 202.791V188.042H554.54V202.791",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.261 72.1963H588.57V126.365",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.261 196.919H588.57V142.75",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.344 70.534C501.744 70.534 502.068 70.2099 502.068 69.81C502.068 69.4101 501.744 69.0859 501.344 69.0859C500.944 69.0859 500.619 69.4101 500.619 69.81C500.619 70.2099 500.944 70.534 501.344 70.534Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.344 75.1199C501.744 75.1199 502.068 74.7958 502.068 74.3959C502.068 73.996 501.744 73.6719 501.344 73.6719C500.944 73.6719 500.619 73.996 500.619 74.3959C500.619 74.7958 500.944 75.1199 501.344 75.1199Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.424 70.534C505.824 70.534 506.149 70.2099 506.149 69.81C506.149 69.4101 505.824 69.0859 505.424 69.0859C505.024 69.0859 504.699 69.4101 504.699 69.81C504.699 70.2099 505.024 70.534 505.424 70.534Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.424 75.1199C505.824 75.1199 506.149 74.7958 506.149 74.3959C506.149 73.996 505.824 73.6719 505.424 73.6719C505.024 73.6719 504.699 73.996 504.699 74.3959C504.699 74.7958 505.024 75.1199 505.424 75.1199Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.424 79.7049C505.824 79.7049 506.149 79.3808 506.149 78.9809C506.149 78.581 505.824 78.2568 505.424 78.2568C505.024 78.2568 504.699 78.581 504.699 78.9809C504.699 79.3808 505.024 79.7049 505.424 79.7049Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.344 79.7049C501.744 79.7049 502.068 79.3808 502.068 78.9809C502.068 78.581 501.744 78.2568 501.344 78.2568C500.944 78.2568 500.619 78.581 500.619 78.9809C500.619 79.3808 500.944 79.7049 501.344 79.7049Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.426 70.534C524.826 70.534 525.15 70.2099 525.15 69.81C525.15 69.4101 524.826 69.0859 524.426 69.0859C524.026 69.0859 523.701 69.4101 523.701 69.81C523.701 70.2099 524.026 70.534 524.426 70.534Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.426 75.1199C524.826 75.1199 525.15 74.7958 525.15 74.3959C525.15 73.996 524.826 73.6719 524.426 73.6719C524.026 73.6719 523.701 73.996 523.701 74.3959C523.701 74.7958 524.026 75.1199 524.426 75.1199Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.506 70.534C528.906 70.534 529.231 70.2099 529.231 69.81C529.231 69.4101 528.906 69.0859 528.506 69.0859C528.106 69.0859 527.781 69.4101 527.781 69.81C527.781 70.2099 528.106 70.534 528.506 70.534Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.506 75.1199C528.906 75.1199 529.231 74.7958 529.231 74.3959C529.231 73.996 528.906 73.6719 528.506 73.6719C528.106 73.6719 527.781 73.996 527.781 74.3959C527.781 74.7958 528.106 75.1199 528.506 75.1199Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.506 79.7049C528.906 79.7049 529.231 79.3808 529.231 78.9809C529.231 78.581 528.906 78.2568 528.506 78.2568C528.106 78.2568 527.781 78.581 527.781 78.9809C527.781 79.3808 528.106 79.7049 528.506 79.7049Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.426 79.7049C524.826 79.7049 525.15 79.3808 525.15 78.9809C525.15 78.581 524.826 78.2568 524.426 78.2568C524.026 78.2568 523.701 78.581 523.701 78.9809C523.701 79.3808 524.026 79.7049 524.426 79.7049Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.051 70.534C547.451 70.534 547.776 70.2099 547.776 69.81C547.776 69.4101 547.451 69.0859 547.051 69.0859C546.651 69.0859 546.326 69.4101 546.326 69.81C546.326 70.2099 546.651 70.534 547.051 70.534Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.051 75.1199C547.451 75.1199 547.776 74.7958 547.776 74.3959C547.776 73.996 547.451 73.6719 547.051 73.6719C546.651 73.6719 546.326 73.996 546.326 74.3959C546.326 74.7958 546.651 75.1199 547.051 75.1199Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.131 70.534C551.531 70.534 551.856 70.2099 551.856 69.81C551.856 69.4101 551.531 69.0859 551.131 69.0859C550.731 69.0859 550.406 69.4101 550.406 69.81C550.406 70.2099 550.731 70.534 551.131 70.534Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.131 75.1199C551.531 75.1199 551.856 74.7958 551.856 74.3959C551.856 73.996 551.531 73.6719 551.131 73.6719C550.731 73.6719 550.406 73.996 550.406 74.3959C550.406 74.7958 550.731 75.1199 551.131 75.1199Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.131 79.7049C551.531 79.7049 551.856 79.3808 551.856 78.9809C551.856 78.581 551.531 78.2568 551.131 78.2568C550.731 78.2568 550.406 78.581 550.406 78.9809C550.406 79.3808 550.731 79.7049 551.131 79.7049Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.051 79.7049C547.451 79.7049 547.776 79.3808 547.776 78.9809C547.776 78.581 547.451 78.2568 547.051 78.2568C546.651 78.2568 546.326 78.581 546.326 78.9809C546.326 79.3808 546.651 79.7049 547.051 79.7049Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.344 200.029C501.744 200.029 502.068 199.705 502.068 199.305C502.068 198.905 501.744 198.581 501.344 198.581C500.944 198.581 500.619 198.905 500.619 199.305C500.619 199.705 500.944 200.029 501.344 200.029Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.344 195.444C501.744 195.444 502.068 195.12 502.068 194.72C502.068 194.32 501.744 193.996 501.344 193.996C500.944 193.996 500.619 194.32 500.619 194.72C500.619 195.12 500.944 195.444 501.344 195.444Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.424 200.029C505.824 200.029 506.149 199.705 506.149 199.305C506.149 198.905 505.824 198.581 505.424 198.581C505.024 198.581 504.699 198.905 504.699 199.305C504.699 199.705 505.024 200.029 505.424 200.029Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.424 195.444C505.824 195.444 506.149 195.12 506.149 194.72C506.149 194.32 505.824 193.996 505.424 193.996C505.024 193.996 504.699 194.32 504.699 194.72C504.699 195.12 505.024 195.444 505.424 195.444Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.424 190.858C505.824 190.858 506.149 190.534 506.149 190.134C506.149 189.734 505.824 189.41 505.424 189.41C505.024 189.41 504.699 189.734 504.699 190.134C504.699 190.534 505.024 190.858 505.424 190.858Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.344 190.858C501.744 190.858 502.068 190.534 502.068 190.134C502.068 189.734 501.744 189.41 501.344 189.41C500.944 189.41 500.619 189.734 500.619 190.134C500.619 190.534 500.944 190.858 501.344 190.858Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.426 200.029C524.826 200.029 525.15 199.705 525.15 199.305C525.15 198.905 524.826 198.581 524.426 198.581C524.026 198.581 523.701 198.905 523.701 199.305C523.701 199.705 524.026 200.029 524.426 200.029Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.426 195.444C524.826 195.444 525.15 195.12 525.15 194.72C525.15 194.32 524.826 193.996 524.426 193.996C524.026 193.996 523.701 194.32 523.701 194.72C523.701 195.12 524.026 195.444 524.426 195.444Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.506 200.029C528.906 200.029 529.231 199.705 529.231 199.305C529.231 198.905 528.906 198.581 528.506 198.581C528.106 198.581 527.781 198.905 527.781 199.305C527.781 199.705 528.106 200.029 528.506 200.029Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.506 195.444C528.906 195.444 529.231 195.12 529.231 194.72C529.231 194.32 528.906 193.996 528.506 193.996C528.106 193.996 527.781 194.32 527.781 194.72C527.781 195.12 528.106 195.444 528.506 195.444Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.506 190.858C528.906 190.858 529.231 190.534 529.231 190.134C529.231 189.734 528.906 189.41 528.506 189.41C528.106 189.41 527.781 189.734 527.781 190.134C527.781 190.534 528.106 190.858 528.506 190.858Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.426 190.858C524.826 190.858 525.15 190.534 525.15 190.134C525.15 189.734 524.826 189.41 524.426 189.41C524.026 189.41 523.701 189.734 523.701 190.134C523.701 190.534 524.026 190.858 524.426 190.858Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.051 200.029C547.451 200.029 547.776 199.705 547.776 199.305C547.776 198.905 547.451 198.581 547.051 198.581C546.651 198.581 546.326 198.905 546.326 199.305C546.326 199.705 546.651 200.029 547.051 200.029Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.051 195.444C547.451 195.444 547.776 195.12 547.776 194.72C547.776 194.32 547.451 193.996 547.051 193.996C546.651 193.996 546.326 194.32 546.326 194.72C546.326 195.12 546.651 195.444 547.051 195.444Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.131 200.029C551.531 200.029 551.856 199.705 551.856 199.305C551.856 198.905 551.531 198.581 551.131 198.581C550.731 198.581 550.406 198.905 550.406 199.305C550.406 199.705 550.731 200.029 551.131 200.029Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.131 195.444C551.531 195.444 551.856 195.12 551.856 194.72C551.856 194.32 551.531 193.996 551.131 193.996C550.731 193.996 550.406 194.32 550.406 194.72C550.406 195.12 550.731 195.444 551.131 195.444Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.131 190.858C551.531 190.858 551.856 190.534 551.856 190.134C551.856 189.734 551.531 189.41 551.131 189.41C550.731 189.41 550.406 189.734 550.406 190.134C550.406 190.534 550.731 190.858 551.131 190.858Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.051 190.858C547.451 190.858 547.776 190.534 547.776 190.134C547.776 189.734 547.451 189.41 547.051 189.41C546.651 189.41 546.326 189.734 546.326 190.134C546.326 190.534 546.651 190.858 547.051 190.858Z",
    stroke: "#A7A9AC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.161 120.145L539.133 120.173L539.161 120.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.002 140.846H576.976L576.922 140.819H576.895H576.868H576.841H576.815H576.761L576.707 140.873H576.68L576.653 140.927L576.6 140.98L576.278 141.463L575.607 142.428L574.936 143.394L573.621 145.324L572.923 146.343L572.574 146.853L572.037 147.631L571.635 148.194L571.232 148.757L570.695 149.481L570.427 149.856L570.158 150.205L569.783 150.688L569.407 151.17L569.004 151.626L568.602 152.082L568.199 152.538L567.85 152.913L567.501 153.289L567.018 153.798L566.508 154.308L565.515 155.327L565.005 155.836L564.764 156.105L564.469 156.426L564.173 156.748L563.905 157.043L563.637 157.338L563.368 157.66L563.127 157.982L563.073 158.062L562.858 158.384L562.724 158.572L562.644 158.679L562.59 158.786L562.509 158.947L562.456 159.108L562.402 159.269V159.457L562.348 159.644V159.832V159.966V160.1V160.261V160.422L562.375 160.61V160.797L562.482 161.253L562.536 161.602V161.79L562.59 162.058V162.192V162.326V162.433V162.54V162.701L562.536 162.862V162.97C562.268 162.916 562.053 162.889 561.811 162.889C561.221 162.889 560.711 163.104 560.228 163.399L560.282 163.291L559.208 162.594L558.725 162.272L555.907 160.395C555.907 160.395 555.853 160.422 555.773 160.476L541.736 151.197L541.79 151.063L541.843 150.956V150.849L541.87 150.768V150.688V150.607V150.554L541.816 150.5V150.446L541.226 149.83L539.24 148.516C539.24 148.516 539.025 148.328 538.81 148.569C538.81 148.569 538.757 148.623 538.73 148.65L537.334 147.684V147.657C537.683 147.121 537.871 146.478 537.871 145.834V138.325C537.871 138.111 537.791 137.923 537.656 137.789L537.12 137.253C536.985 137.119 536.905 136.904 536.905 136.716V135.322C537.307 136.663 538.515 137.655 539.991 137.655C541.467 137.655 542.675 136.636 543.078 135.295H549.063V136.743H549.197L549.143 151.439L548.634 152.055V154.522L549.143 155.059H551.076L551.586 154.522V152.055L551.076 151.439L551.13 136.743H551.21V131.89H551.103V117.543L551.613 116.926V114.459L551.103 113.923H549.17L548.66 114.459V116.926L549.17 117.543V131.89H549.063V133.338H543.051C542.622 132.05 541.414 131.085 539.991 131.085C538.569 131.085 537.307 132.077 536.905 133.418V131.89C536.905 131.675 536.985 131.487 537.12 131.353L537.656 130.817C537.791 130.683 537.871 130.468 537.871 130.281V122.772C537.871 122.128 537.683 121.512 537.334 120.975V120.949L538.73 119.983C538.73 119.983 538.784 120.037 538.81 120.064C539.025 120.305 539.24 120.117 539.24 120.117L541.226 118.803L541.79 118.186V118.133L541.843 118.079V118.026L541.87 117.945V117.865V117.784V117.677L541.79 117.57L541.736 117.436L555.773 108.157C555.773 108.157 555.88 108.264 555.907 108.238L558.725 106.36L559.208 106.039C559.208 106.039 560.309 105.315 560.282 105.341L560.228 105.234C560.711 105.529 561.221 105.744 561.811 105.744C562.053 105.744 562.295 105.744 562.509 105.663V105.771L562.563 105.931V106.092V106.2V106.307V106.441V106.575L562.536 106.843V107.031L562.456 107.379L562.375 107.835V108.023L562.321 108.211V108.372V108.533V108.667V108.801V108.988L562.348 109.176V109.364L562.429 109.525L562.482 109.686L562.563 109.847L562.617 109.954L562.697 110.061L562.831 110.249L563.046 110.571L563.1 110.651L563.341 110.973L563.61 111.295L563.878 111.59L564.146 111.885L564.442 112.206L564.737 112.528L564.979 112.796L565.488 113.306L566.482 114.325L566.991 114.834L567.475 115.344L567.823 115.719L568.172 116.095L568.575 116.551L568.978 117.007L569.38 117.462L569.756 117.945L570.132 118.428L570.4 118.776L570.668 119.152L571.205 119.876L571.608 120.439L572.01 121.002L572.547 121.78L572.896 122.289L573.594 123.308L574.909 125.239L575.58 126.204L576.251 127.17L576.573 127.653L576.627 127.706H576.653L576.68 127.76H576.734L576.788 127.813H576.815H576.841H576.868H576.895H576.949V127.787H576.976L577.888 127.197C578.049 127.089 578.076 126.902 577.969 126.741L577.378 125.856L576.815 124.971L575.66 123.174L573.325 119.474L572.145 117.57L571.366 116.309L570.615 115.049L569.648 113.44L568.682 111.831L567.904 110.544L567.501 109.9L566.911 108.935L566.616 108.452L566.24 107.862L565.945 107.406L565.703 107.058L565.327 106.521L564.925 105.958L564.603 105.529L564.415 105.288L564.146 104.912L564.066 104.778C564.978 103.893 565.274 102.579 564.817 101.399C564.2 99.7637 562.375 98.9324 560.738 99.5492V99.4151L560.684 99.2542V99.1469V99.0396V98.8251V98.6642V98.5033L560.738 98.2084L560.792 97.9134L560.845 97.6184L560.899 97.3502V97.0553L560.953 96.8944V96.7603V96.6262V96.4921V96.358V96.1971L560.899 96.0362V95.8753L560.818 95.7144L560.738 95.5535L560.657 95.3926L560.577 95.2318L560.47 95.0709L560.362 94.9099L560.147 94.5882L560.013 94.4004L559.852 94.2127L559.53 93.8373L559.235 93.4887L558.94 93.1401L558.591 92.7647L558.242 92.3892L557.812 91.9602L556.98 91.1021L556.444 90.5657L555.773 89.8953L555.451 89.5467L555.129 89.1981L554.619 88.635L554.136 88.0718L553.652 87.4819L553.169 86.8919L552.874 86.5165L552.579 86.1411L552.257 85.712L551.935 85.2829L551.532 84.7198L551.13 84.1567L550.593 83.4058L550.244 82.8963L549.546 81.8773L548.231 79.9733L547.56 79.0079L546.916 78.0426L546.594 77.5599L546.54 77.5062H546.513L546.486 77.4526H546.46L546.433 77.4258H546.379H546.352H546.325H546.299H546.272L546.218 77.4794L545.252 78.0962L545.198 78.1498V78.2035V78.2839V78.3643V78.3912V78.4716L545.225 78.5521L545.762 79.3834L546.299 80.2415L547.372 81.9309L548.446 83.6203L549.519 85.3366L550.593 87.0528L551.291 88.1791L551.962 89.3054L552.955 90.9948L553.76 92.3356L554.565 93.6764L554.968 94.3468L555.558 95.3658L556.095 96.2776L556.39 96.7335L556.685 97.1893L557.007 97.6988L557.168 97.9402L557.437 98.3156L557.705 98.691L558 99.0933L558.296 99.4955L558.591 99.8978L558.752 100.112L559.101 100.622V100.702C558.725 101.239 558.51 101.882 558.483 102.526C558.483 102.687 558.564 102.848 558.564 102.982L558.51 102.901L557.437 103.598L554.136 105.771C554.136 105.771 554.136 105.851 554.162 105.931L540.126 115.21L540.018 115.103L539.938 115.022L539.857 114.968H539.803L539.75 114.915H539.669H539.616H539.562H539.508L538.73 115.183L536.744 116.497C536.556 116.685 536.61 116.819 536.61 116.819V116.926C536.61 116.926 536.69 117.06 536.744 117.167L535.321 118.106L534.624 117.06V112.394L534.57 112.34H533.147V112.153L533.121 112.072C532.745 111.241 532.154 110.356 531.483 109.793C531.134 109.525 530.732 109.31 530.329 109.123H525.606C525.203 109.31 524.8 109.525 524.452 109.793C523.754 110.383 523.136 111.295 522.788 112.153V112.34H521.472L521.419 112.394V116.872L520.587 118.079L519.164 117.141C519.164 117.141 519.245 116.98 519.272 116.926V116.819C519.272 116.819 519.352 116.685 519.164 116.497L517.178 115.183L516.4 114.915H516.346H516.292H516.239H516.158H516.105L516.051 114.968L515.97 115.022L515.89 115.103L515.783 115.21L501.746 105.931C501.746 105.931 501.799 105.797 501.773 105.797L498.471 103.625L497.398 102.928L497.344 103.008C497.344 102.848 497.425 102.713 497.425 102.553C497.425 101.882 497.21 101.239 496.807 100.729V100.649L497.156 100.139L497.317 99.9246L497.613 99.5223L497.908 99.1201L498.203 98.7179L498.471 98.3424L498.74 97.967L498.901 97.7257L499.223 97.2161L499.518 96.7603L499.813 96.3044L500.35 95.3926L500.941 94.3736L501.343 93.7032L502.148 92.3624L502.953 91.0216L503.947 89.3322L504.618 88.2059L505.315 87.0796L506.389 85.3634L507.462 83.6471L508.536 81.9577L509.61 80.2683L510.146 79.4102L510.683 78.5789V78.5252L510.737 78.4984V78.418V78.3107V78.2303V78.1766L510.683 78.123L509.717 77.5062H509.663L509.636 77.4526H509.61H509.583H509.556H509.502H509.475L509.449 77.4794H509.422L509.395 77.533L509.341 77.5867L509.019 78.0694L508.375 79.0348L507.704 80.0001L506.389 81.9041L505.691 82.9231L505.342 83.4326L504.805 84.1835L504.403 84.7466L504 85.3098L503.678 85.7388L503.356 86.1679L503.061 86.5433L502.766 86.9187L502.283 87.5087L501.799 88.0986L501.316 88.6618L500.806 89.2249L500.484 89.5735L500.162 89.9221L499.491 90.5925L498.954 91.1289L498.122 91.987L497.693 92.416L497.344 92.7915L496.995 93.1669L496.7 93.5155L496.405 93.8641L496.083 94.2395L495.922 94.4273L495.787 94.615L495.573 94.9368L495.465 95.0977L495.358 95.2586L495.278 95.4195L495.197 95.5804L495.116 95.7413L495.063 95.9022V96.063L495.009 96.2239V96.3848V96.5189V96.653V96.7871V96.9212V97.0821V97.377L495.09 97.6452L495.143 97.9402L495.197 98.2352L495.251 98.5301V98.691L495.278 98.8519V99.0665V99.1737V99.281V99.4419V99.576C493.614 98.9592 491.788 99.7905 491.171 101.426C490.715 102.606 491.01 103.92 491.923 104.805L491.842 104.939L491.574 105.315L491.386 105.556L491.064 105.985L490.661 106.548L490.285 107.085L490.044 107.433L489.749 107.889L489.373 108.479L489.078 108.962L488.487 109.927L488.085 110.571L487.306 111.858L486.34 113.467L485.374 115.076L484.622 116.336L483.844 117.596L482.663 119.5L480.328 123.201L479.174 124.998L478.61 125.883L478.02 126.768C477.913 126.929 477.966 127.116 478.101 127.223L479.013 127.813H479.04L479.094 127.84H479.12H479.147H479.174H479.201H479.255L479.308 127.787H479.335L479.362 127.733L479.416 127.679L479.738 127.197L480.409 126.231L481.08 125.266L482.395 123.335L483.093 122.316L483.442 121.807L483.978 121.029L484.381 120.466L484.783 119.903L485.32 119.179L485.589 118.803L485.857 118.455L486.233 117.972L486.608 117.489L487.011 117.033L487.414 116.577L487.816 116.122L488.165 115.746L488.514 115.371L488.997 114.861L489.507 114.352L490.5 113.333L491.01 112.823L491.252 112.555L491.547 112.233L491.842 111.911L492.111 111.616L492.379 111.321L492.647 111L492.889 110.678L492.943 110.597L493.157 110.276L493.291 110.088L493.372 109.981L493.426 109.873L493.506 109.713L493.56 109.552L493.613 109.391V109.203L493.667 109.015V108.828V108.693V108.559V108.399V108.238L493.64 108.05V107.862L493.533 107.406L493.479 107.058V106.87L493.426 106.602V106.468V106.334V106.226V106.119V105.958L493.479 105.797V105.69C493.748 105.744 493.962 105.771 494.204 105.771C494.794 105.771 495.304 105.556 495.787 105.261L495.734 105.368L496.807 106.065L497.29 106.387L500.109 108.264C500.109 108.264 500.162 108.238 500.243 108.184L514.28 117.462L514.226 117.596L514.172 117.704V117.811L514.145 117.891V117.972V118.052V118.106L514.199 118.16V118.213L514.789 118.83L516.776 120.144C516.776 120.144 516.99 120.332 517.205 120.09C517.205 120.09 517.259 120.037 517.286 120.01L518.681 120.975C518.332 121.538 518.144 122.182 518.144 122.826V130.334C518.144 130.549 518.225 130.736 518.359 130.87L518.896 131.407C519.03 131.541 519.111 131.755 519.111 131.943V133.257H516.937V132.614H515.219V133.391H506.55V131.943H506.443V117.596L506.952 116.98V114.513L506.443 113.976H504.51L504 114.513V116.98L504.51 117.596V131.943H504.403V136.797H504.483L504.537 151.492L504.027 152.109V154.576L504.537 155.112H506.469L506.979 154.576V152.109L506.469 151.492L506.416 136.797H506.55V135.349H515.219V136.126H516.937V135.483H519.111V136.797C519.111 136.958 519.057 137.119 518.95 137.253C518.95 137.28 518.869 137.36 518.869 137.36L518.466 137.762L518.359 137.896C518.225 138.03 518.144 138.245 518.144 138.433V145.941C518.144 146.585 518.332 147.228 518.681 147.765V147.792L517.286 148.757C517.286 148.757 517.232 148.703 517.205 148.676C516.99 148.435 516.776 148.623 516.776 148.623L514.789 149.937L514.226 150.554V150.607L514.172 150.661V150.714L514.145 150.795V150.875V150.956V151.063L514.226 151.17L514.28 151.304L500.243 160.583C500.243 160.583 500.135 160.476 500.109 160.502L497.29 162.38L496.807 162.701C496.807 162.701 495.707 163.425 495.734 163.399L495.787 163.506C495.304 163.211 494.794 162.996 494.204 162.996C493.962 162.996 493.721 162.996 493.506 163.077V162.97L493.452 162.809V162.648V162.54V162.433V162.299V162.165L493.479 161.897V161.709L493.56 161.361L493.64 160.905V160.717L493.694 160.529V160.368V160.207V160.073V159.939V159.752L493.667 159.564V159.376L493.587 159.215L493.533 159.054L493.452 158.893L493.399 158.786L493.318 158.679L493.184 158.491L492.969 158.169L492.916 158.089L492.674 157.767L492.406 157.445L492.137 157.15L491.869 156.855L491.574 156.534L491.278 156.212L491.037 155.944L490.527 155.434L489.534 154.415L489.024 153.906L488.541 153.396L488.192 153.021L487.843 152.645L487.44 152.189L487.038 151.734L486.635 151.278L486.26 150.795L485.884 150.312L485.615 149.964L485.347 149.588L484.81 148.864L484.408 148.301L484.005 147.738L483.468 146.96L483.119 146.451L482.422 145.432L481.107 143.501L480.436 142.536L479.765 141.57L479.442 141.087L479.389 141.034H479.362L479.335 140.98H479.281L479.228 140.927H479.201H479.174H479.147H479.12H479.067V140.953H479.04L478.127 141.543C477.966 141.651 477.939 141.838 478.047 141.999L478.637 142.884L479.201 143.769L480.355 145.566L482.69 149.266L483.871 151.17L484.649 152.431L485.401 153.691L486.367 155.3L487.333 156.909L488.111 158.196L488.514 158.84L489.105 159.805L489.4 160.288L489.776 160.878L490.071 161.334L490.312 161.682L490.688 162.219L491.091 162.782L491.413 163.211L491.601 163.452L491.869 163.828L491.949 163.962C491.037 164.847 490.742 166.161 491.198 167.341C491.815 168.976 493.64 169.808 495.278 169.191V169.325L495.331 169.486V169.593V169.7V169.915V170.076V170.237L495.278 170.532L495.224 170.827L495.17 171.122L495.116 171.39V171.685L495.063 171.846V171.98V172.114V172.248V172.382V172.543L495.116 172.704V172.865L495.197 173.026L495.278 173.186L495.358 173.347L495.439 173.508L495.546 173.669L495.653 173.83L495.868 174.152L496.002 174.34L496.163 174.527L496.485 174.903L496.781 175.251L497.076 175.6L497.425 175.975L497.774 176.351L498.203 176.78L499.035 177.638L499.572 178.174L500.243 178.845L500.565 179.193L500.887 179.542L501.397 180.105L501.88 180.668L502.363 181.258L502.846 181.848L503.141 182.224L503.437 182.599L503.759 183.028L504.081 183.457L504.483 184.02L504.886 184.583L505.423 185.334L505.772 185.844L506.469 186.863L507.784 188.767L508.455 189.732L509.1 190.697L509.422 191.18L509.475 191.234H509.502L509.529 191.287H509.556L509.583 191.314H509.636H509.663H509.69H509.717H509.744L509.797 191.261L510.764 190.644L510.817 190.59V190.537V190.456V190.376V190.349V190.268L510.79 190.188L510.254 189.357L509.717 188.499L508.643 186.809L507.57 185.12L506.496 183.403L505.423 181.687L504.725 180.561L504.054 179.435L503.061 177.745L502.256 176.404L501.45 175.064L501.048 174.393L500.457 173.374L499.921 172.462L499.625 172.007L499.33 171.551L499.008 171.041L498.847 170.8L498.579 170.424L498.31 170.049L498.015 169.647L497.72 169.244L497.425 168.842L497.264 168.628L496.915 168.118V168.038C497.29 167.501 497.505 166.858 497.532 166.214C497.532 166.053 497.451 165.892 497.451 165.758L497.505 165.839L498.579 165.142L501.88 162.97C501.88 162.97 501.88 162.889 501.853 162.809L515.89 153.53L515.997 153.637L516.078 153.718L516.158 153.772H516.212L516.266 153.825H516.346H516.4H516.454H516.507L517.286 153.557L519.272 152.243C519.459 152.055 519.406 151.921 519.406 151.921V151.814C519.406 151.814 519.325 151.68 519.272 151.573L520.694 150.634L521.982 152.565L522.17 152.672C524.129 152.887 526.089 152.994 528.048 152.994C530.007 152.994 531.966 152.887 533.926 152.672C534.006 152.672 534.087 152.618 534.114 152.565L535.402 150.634L536.824 151.573C536.824 151.573 536.744 151.734 536.717 151.787V151.894C536.717 151.894 536.636 152.028 536.824 152.216L538.81 153.53L539.589 153.798H539.642H539.696H539.75H539.83H539.884L539.938 153.745L540.018 153.691L540.099 153.611L540.206 153.503L554.243 162.782C554.243 162.782 554.189 162.916 554.216 162.916L557.517 165.088L558.591 165.785L558.645 165.705C558.645 165.866 558.564 166 558.564 166.161C558.564 166.831 558.779 167.475 559.181 167.984V168.065L558.832 168.574L558.671 168.789L558.376 169.191L558.081 169.593L557.786 169.995L557.517 170.371L557.249 170.746L557.088 170.988L556.766 171.497L556.471 171.953L556.175 172.409L555.639 173.321L555.048 174.34L554.645 175.01L553.84 176.351L553.035 177.692L552.042 179.381L551.371 180.507L550.673 181.634L549.6 183.35L548.526 185.066L547.453 186.755L546.379 188.445L545.842 189.303L545.306 190.134V190.188L545.252 190.215V190.295V190.402V190.483V190.537L545.306 190.59L546.272 191.207H546.325L546.352 191.261H546.379H546.406H546.433H546.486H546.513L546.54 191.234H546.567L546.594 191.18L546.647 191.127L546.97 190.644L547.614 189.678L548.285 188.713L549.6 186.809L550.298 185.79L550.646 185.281L551.183 184.53L551.586 183.967L551.988 183.403L552.31 182.974L552.633 182.545L552.928 182.17L553.223 181.794L553.706 181.205L554.189 180.615L554.672 180.051L555.182 179.488L555.504 179.14L555.826 178.791L556.497 178.121L557.034 177.584L557.866 176.726L558.296 176.297L558.645 175.922L558.993 175.546L559.289 175.198L559.584 174.849L559.906 174.474L560.067 174.286L560.201 174.098L560.416 173.776L560.523 173.616L560.631 173.455L560.711 173.294L560.792 173.133L560.872 172.972L560.926 172.811V172.65L560.979 172.489V172.328V172.194V172.06V171.926V171.792V171.631V171.336L560.899 171.068L560.845 170.773L560.792 170.478L560.738 170.183V170.022L560.711 169.861V169.647V169.539V169.432V169.271V169.137C562.375 169.754 564.2 168.923 564.817 167.287C565.274 166.107 564.978 164.793 564.066 163.908L564.146 163.774L564.415 163.399L564.603 163.157L564.925 162.728L565.327 162.165L565.703 161.629L565.945 161.28L566.24 160.824L566.616 160.234L566.911 159.752L567.501 158.786L567.904 158.143L568.682 156.855L569.648 155.246L570.615 153.637L571.366 152.377L572.145 151.117L573.325 149.213L575.66 145.512L576.815 143.715L577.378 142.831L577.969 141.946C578.076 141.785 578.022 141.597 577.888 141.49L576.976 140.9L577.002 140.846ZM562.375 105.744V105.771V105.717V105.744ZM493.587 105.771V105.744L493.56 105.771H493.587ZM493.587 162.996V162.97V163.023V162.996ZM562.375 162.996L562.402 162.97V162.996H562.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.587 118.187L519.164 117.248",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.312 120.037L518.708 120.976",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.804 120.17L514.817 118.856V118.83L514.254 118.24L514.227 118.186L514.173 118.132V118.079L514.146 117.998V117.918V117.864L514.173 117.757L514.227 117.65L514.281 117.516",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.73 115.344L515.838 115.237L515.918 115.156L515.999 115.102H516.053L516.106 115.049H516.187H516.24H516.294H516.348L517.126 115.317L519.112 116.631C519.3 116.819 519.246 116.953 519.246 116.953V117.06C519.246 117.06 519.139 117.221 519.085 117.355C519.032 117.462 518.978 117.543 518.951 117.596C518.871 117.73 518.763 117.891 518.683 118.079C518.602 118.186 518.549 118.294 518.468 118.401C518.361 118.589 518.226 118.749 518.119 118.937C518.039 119.018 517.985 119.152 517.904 119.259C517.797 119.42 517.69 119.581 517.582 119.688C517.529 119.742 517.475 119.822 517.394 119.903C517.314 120.01 517.233 120.09 517.18 120.144C516.965 120.385 516.75 120.198 516.75 120.198",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.787 105.449L496.861 106.146L497.344 106.468L500.162 108.345C500.162 108.345 500.618 107.863 501.074 107.219C501.531 106.575 501.826 105.985 501.772 105.932L498.471 103.76L497.397 103.062",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.719 106.065L515.81 115.397C515.81 115.397 515.407 116.202 515.193 116.551C514.978 116.899 514.387 117.57 514.387 117.57L500.297 108.238",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.809 100.81C497.184 101.346 497.399 101.989 497.426 102.633C497.426 104.376 496.03 105.797 494.286 105.824C494.044 105.824 493.803 105.824 493.588 105.744",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.145 99.5758C493.508 98.959 491.682 99.7903 491.065 101.426C490.609 102.606 490.904 103.92 491.817 104.805",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.646 101.239L496.7 101.158L496.727 101.051L496.78 100.944L496.807 100.837V100.729V100.622V100.515L496.78 100.408L496.727 100.3L496.7 100.193L496.646 100.113L496.566 100.005L496.512 99.9249L496.405 99.8712L496.324 99.7908H496.297L496.19 99.7372L496.082 99.6835L495.975 99.6567L495.868 99.6299H495.734H495.626L495.492 99.6567L495.385 99.7103L495.277 99.764L495.17 99.8176L495.063 99.898L494.982 99.9785L494.928 100.032L494.902 100.086L492.137 104.296L492.083 104.376L492.03 104.484L492.003 104.591L491.976 104.698L491.949 104.805V104.913L491.976 105.02L492.003 105.127L492.03 105.234L492.083 105.342L492.137 105.422L492.191 105.529L492.271 105.61L492.352 105.664L492.432 105.744H492.459L492.567 105.798L492.674 105.851L492.781 105.878L492.915 105.905H493.023H493.157L493.264 105.878L493.399 105.824L493.506 105.798L493.613 105.717L493.694 105.637L493.774 105.556L493.828 105.503L493.882 105.449L496.646 101.239Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.587 105.744L493.533 105.905V106.066L493.48 106.227V106.334V106.441V106.575V106.709V106.978L493.533 107.165L493.587 107.514L493.668 107.97V108.157L493.721 108.345V108.506V108.667V108.801V108.935V109.123L493.694 109.311V109.498L493.614 109.659L493.56 109.82L493.48 109.981L493.426 110.088L493.346 110.195L493.211 110.383L492.997 110.705L492.943 110.785L492.701 111.107L492.433 111.429L492.165 111.724L491.896 112.019L491.601 112.341L491.306 112.663L491.064 112.931L490.554 113.44L489.561 114.459L489.051 114.969L488.568 115.478L488.219 115.854L487.87 116.229L487.468 116.685L487.065 117.141L486.663 117.597L486.287 118.079L485.911 118.562L485.643 118.911L485.374 119.286L484.838 120.01L484.435 120.573L484.032 121.137L483.496 121.914L483.147 122.424L482.449 123.443L481.134 125.373L480.463 126.339L479.792 127.304L479.47 127.787L479.416 127.841H479.389L479.362 127.894H479.309L479.255 127.948H479.228H479.201H479.175H479.148H479.094V127.921M479.094 127.921H479.067M479.094 127.921L478.155 127.304L479.067 127.921M479.067 127.921L478.155 127.331C477.994 127.224 477.967 127.036 478.074 126.875L478.665 125.99L479.228 125.105L480.382 123.309L482.717 119.608L483.898 117.704L484.677 116.444L485.455 115.183L486.421 113.574L487.387 111.965L488.166 110.678L488.568 110.035L489.159 109.069L489.454 108.587L489.83 107.997L490.125 107.541L490.366 107.192L490.742 106.656L491.145 106.093L491.467 105.664L491.655 105.422L491.923 105.047L492.192 104.645",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.037 99.9247L495.063 99.8443L495.09 99.7638L495.117 99.6834L495.144 99.6029L495.171 99.442L495.198 99.2811V99.1739V99.0398L495.171 98.8253V98.6644L495.144 98.5035L495.09 98.2353L495.063 97.9403L495.01 97.6454L494.956 97.3772L494.929 97.0822L494.902 96.9213V96.7872V96.6532V96.5191V96.385V96.2241L494.929 96.0632L494.983 95.9023L495.037 95.7682L495.09 95.5805L495.171 95.4196L495.278 95.2855L495.359 95.1246L495.466 94.9906L495.681 94.6688L495.842 94.481L496.003 94.2933L496.298 93.9179L496.593 93.5693L496.915 93.2207L497.264 92.8453L497.613 92.4698L498.043 92.0676L498.875 91.2095L499.411 90.6731L500.082 89.9759L500.404 89.6273L500.726 89.2787L501.236 88.7156L501.719 88.1524L502.203 87.5625L502.686 86.9725L502.981 86.6239L503.249 86.2485L503.571 85.8194L503.893 85.3903L504.296 84.8272L504.699 84.2641L505.235 83.5132L505.584 83.0037L506.282 81.9847L507.624 80.0539L508.268 79.1154L508.939 78.15L509.261 77.6673L509.288 77.6136L509.315 77.5868L509.369 77.56H509.395L509.422 77.5332H509.476H509.53H509.556H509.61H509.637L509.691 77.56L510.657 78.2036L510.711 78.2572L510.737 78.2841L510.764 78.3109L510.791 78.3377V78.3913L510.818 78.4449V78.4986L510.791 78.5254V78.5522V78.6059L510.764 78.6595L510.201 79.4908L509.664 80.3489L508.563 82.0383L507.49 83.7277L506.416 85.444L505.37 87.1602L504.672 88.2865L504.001 89.4128L502.981 91.0754L502.176 92.4162L501.397 93.7838L500.995 94.4542L500.404 95.4464L499.841 96.3582L499.545 96.8409L499.25 97.2968L498.928 97.8063L498.767 98.0476L498.499 98.4498L498.23 98.7985L497.935 99.2275L497.613 99.6298L497.318 100.032L497.157 100.247L496.808 100.756",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 517.768,
    cy: 119.447,
    rx: 0.375747,
    ry: 0.375427,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 517.233,
    cy: 120.09,
    rx: 0.375747,
    ry: 0.375427,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.35 118.187L536.772 117.248",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.651 120.037L537.229 120.976",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.133 120.17L541.119 118.856L541.146 118.83L541.683 118.24L541.736 118.186L541.763 118.132L541.79 118.079V117.998V117.918V117.864L541.763 117.757L541.709 117.65L541.656 117.516",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.207 115.344L540.099 115.237L540.019 115.156L539.938 115.102H539.885L539.831 115.049H539.75H539.697H539.643H539.589L538.811 115.317L536.825 116.631C536.637 116.819 536.691 116.953 536.691 116.953V117.06C536.691 117.06 536.798 117.221 536.852 117.355C536.905 117.462 536.959 117.543 536.986 117.596C537.066 117.73 537.174 117.891 537.254 118.079C537.335 118.186 537.389 118.294 537.469 118.401C537.576 118.589 537.711 118.749 537.818 118.937C537.898 119.018 537.952 119.152 538.033 119.259C538.14 119.42 538.247 119.581 538.355 119.688C538.408 119.742 538.462 119.822 538.543 119.903C538.623 120.01 538.704 120.09 538.757 120.144C538.972 120.385 539.187 120.198 539.187 120.198",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.15 105.449L559.076 106.146L558.593 106.468L555.775 108.345C555.775 108.345 555.319 107.863 554.862 107.219C554.406 106.575 554.111 105.985 554.164 105.932L557.466 103.76L558.539 103.062",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.245 106.065L540.154 115.397C540.154 115.397 540.557 116.202 540.772 116.551C540.986 116.899 541.577 117.57 541.577 117.57L555.667 108.238",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.156 100.81C558.781 101.346 558.566 101.989 558.539 102.633C558.539 104.376 559.935 105.797 561.679 105.824C561.921 105.824 562.162 105.824 562.377 105.744",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.793 99.5758C562.43 98.959 564.255 99.7903 564.873 101.426C565.329 102.606 565.034 103.92 564.121 104.805",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.317 101.239L559.263 101.158L559.209 101.051L559.183 100.944L559.156 100.837L559.129 100.729V100.622L559.156 100.515L559.183 100.408L559.209 100.3L559.263 100.193L559.317 100.113L559.37 100.005L559.451 99.9249L559.531 99.8712L559.612 99.7908H559.639L559.746 99.7372L559.854 99.6835L559.961 99.6567L560.095 99.6299H560.202H560.337L560.444 99.6567L560.551 99.7103L560.686 99.764L560.766 99.8176L560.873 99.898L560.954 99.9785L561.008 100.032L561.061 100.086L563.826 104.296L563.879 104.376L563.906 104.484L563.96 104.591V104.698L563.987 104.805V104.913L563.96 105.02V105.127L563.906 105.234L563.879 105.342L563.826 105.422L563.745 105.529L563.665 105.61L563.584 105.664L563.504 105.744H563.477L563.369 105.798L563.262 105.851L563.155 105.878L563.021 105.905H562.913H562.779L562.672 105.878L562.564 105.824L562.457 105.798L562.35 105.717L562.242 105.637L562.162 105.556L562.108 105.503L562.054 105.449L559.317 101.239Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.376 105.744L562.43 105.905V106.066L562.484 106.227V106.334V106.441V106.575V106.709V106.978L562.43 107.165L562.376 107.514L562.296 107.97V108.157L562.242 108.345V108.506V108.667V108.801V108.935V109.123L562.269 109.311V109.498L562.35 109.659L562.403 109.82L562.484 109.981L562.537 110.088L562.618 110.195L562.752 110.383L562.967 110.705L563.021 110.785L563.262 111.107L563.53 111.429L563.799 111.724L564.067 112.019L564.362 112.341L564.658 112.663L564.899 112.931L565.409 113.44L566.402 114.459L566.912 114.969L567.395 115.478L567.744 115.854L568.093 116.229L568.496 116.685L568.898 117.141L569.301 117.597L569.677 118.079L570.052 118.562L570.321 118.911L570.589 119.286L571.126 120.01L571.528 120.573L571.931 121.137L572.468 121.914L572.817 122.424L573.515 123.443L574.83 125.373L575.501 126.339L576.172 127.304L576.494 127.787L576.547 127.841H576.574L576.601 127.894H576.655L576.708 127.948H576.735H576.762H576.789H576.816H576.869V127.921M576.869 127.921H576.896M576.869 127.921L577.809 127.304L576.896 127.921M576.896 127.921L577.809 127.331C577.97 127.224 577.997 127.036 577.889 126.875L577.299 125.99L576.735 125.105L575.581 123.309L573.246 119.608L572.065 117.704L571.287 116.444L570.509 115.183L569.542 113.574L568.576 111.965L567.798 110.678L567.395 110.035L566.805 109.069L566.51 108.587L566.134 107.997L565.839 107.541L565.597 107.192L565.221 106.656L564.819 106.093L564.497 105.664L564.309 105.422L564.04 105.047L563.772 104.645",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.901 99.9247L560.874 99.8443L560.847 99.7638L560.821 99.6834L560.794 99.6029L560.767 99.442V99.2811V99.1739V99.0398V98.8253V98.6644L560.794 98.5035L560.847 98.2353L560.901 97.9403L560.928 97.6454L560.982 97.3772L561.008 97.0822L561.035 96.9213V96.7872L561.062 96.6532V96.5191L561.035 96.385V96.2241L561.008 96.0632L560.955 95.9023L560.928 95.7682L560.847 95.5805L560.767 95.4196L560.686 95.2855L560.579 95.1246L560.472 94.9906L560.257 94.6688L560.096 94.481L559.962 94.2933L559.64 93.9179L559.344 93.5693L559.049 93.2207L558.673 92.8453L558.324 92.4698L557.895 92.0676L557.063 91.2095L556.526 90.6731L555.882 89.9759L555.533 89.6273L555.211 89.2787L554.701 88.7156L554.218 88.1524L553.735 87.5625L553.252 86.9725L552.984 86.6239L552.688 86.2485L552.366 85.8194L552.044 85.3903L551.642 84.8272L551.239 84.2641L550.702 83.5132L550.353 83.0037L549.655 81.9847L548.34 80.0539L547.669 79.1154L547.025 78.15L546.703 77.6673L546.65 77.6136L546.623 77.5868L546.596 77.56H546.569L546.515 77.5332H546.462H546.408H546.381H546.354H546.301L546.247 77.56L545.281 78.2036L545.227 78.2572L545.2 78.2841L545.173 78.3109V78.3377L545.146 78.3913V78.4449V78.4986V78.5254V78.5522L545.173 78.6059L545.2 78.6595L545.737 79.4908L546.301 80.3489L547.374 82.0383L548.448 83.7277L549.521 85.444L550.595 87.1602L551.266 88.2865L551.964 89.4128L552.957 91.0754L553.762 92.4162L554.54 93.7838L554.943 94.4542L555.56 95.4464L556.097 96.3582L556.392 96.8409L556.687 97.2968L557.009 97.8063L557.17 98.0476L557.439 98.4498L557.707 98.7985L558.002 99.2275L558.324 99.6298L558.62 100.032L558.781 100.247L559.13 100.756",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 538.167,
    cy: 119.447,
    rx: 0.375747,
    ry: 0.375427,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 538.704,
    cy: 120.09,
    rx: 0.375747,
    ry: 0.375427,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.587 150.555L519.164 151.493",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.312 148.704L518.708 147.766",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.804 148.57L514.817 149.884L514.254 150.501L514.227 150.555L514.173 150.608V150.662L514.146 150.742V150.796V150.877L514.173 150.984L514.227 151.091L514.281 151.225",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.73 153.397L515.838 153.504L515.918 153.585L515.999 153.638H516.053L516.106 153.692H516.187H516.24H516.294H516.348L517.126 153.424L519.112 152.11C519.3 151.922 519.246 151.788 519.246 151.788V151.681C519.246 151.681 519.139 151.52 519.085 151.386C519.032 151.278 518.978 151.198 518.951 151.144C518.871 151.01 518.763 150.849 518.683 150.662C518.602 150.554 518.549 150.447 518.468 150.34C518.361 150.152 518.226 149.991 518.119 149.804C518.039 149.723 517.985 149.589 517.904 149.482C517.797 149.321 517.69 149.16 517.582 149.053C517.529 148.999 517.475 148.919 517.394 148.838C517.314 148.731 517.233 148.65 517.18 148.597C516.965 148.355 516.75 148.543 516.75 148.543",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.787 163.292L496.861 162.594L497.344 162.273L500.162 160.396C500.162 160.396 500.618 160.878 501.074 161.522C501.531 162.165 501.826 162.755 501.772 162.809L498.471 164.981L497.397 165.678",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.719 162.675L515.81 153.343C515.81 153.343 515.407 152.539 515.193 152.19C514.978 151.841 514.387 151.171 514.387 151.171L500.297 160.503",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.809 167.931C497.184 167.394 497.399 166.751 497.426 166.107C497.426 164.364 496.03 162.943 494.286 162.916C494.044 162.916 493.803 162.916 493.588 162.996",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.145 169.137C493.508 169.754 491.682 168.923 491.065 167.287C490.609 166.107 490.904 164.793 491.817 163.908",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.646 167.475L496.7 167.582L496.727 167.69L496.78 167.797L496.807 167.904V168.011V168.119V168.226L496.78 168.333L496.727 168.441L496.7 168.548L496.646 168.628L496.566 168.709L496.512 168.789L496.405 168.87L496.324 168.923L496.297 168.95L496.19 169.004L496.082 169.057L495.975 169.084L495.868 169.111H495.734L495.626 169.084L495.492 169.057L495.385 169.03L495.277 168.977L495.17 168.923L495.063 168.843L494.982 168.762L494.928 168.709L494.902 168.628L492.137 164.445L492.083 164.338L492.03 164.257L492.003 164.15L491.976 164.043L491.949 163.935V163.828L491.976 163.721L492.003 163.614L492.03 163.506L492.083 163.399L492.137 163.292L492.191 163.211L492.271 163.131L492.352 163.05L492.432 162.997H492.459L492.567 162.916L492.674 162.89L492.781 162.863L492.915 162.836H493.023H493.157L493.264 162.863L493.399 162.89L493.506 162.943L493.613 163.024L493.694 163.077L493.774 163.185L493.828 163.238L493.882 163.292L496.646 167.475Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.587 162.997L493.533 162.836V162.675L493.48 162.514V162.407V162.3V162.165V162.031V161.763L493.533 161.576L493.587 161.227L493.668 160.771V160.583L493.721 160.396V160.235V160.074V159.94V159.806V159.618L493.694 159.43V159.243L493.614 159.082L493.56 158.921L493.48 158.76L493.426 158.653L493.346 158.545L493.211 158.358L492.997 158.036L492.943 157.955L492.701 157.634L492.433 157.312L492.165 157.017L491.896 156.722L491.601 156.4L491.306 156.078L491.064 155.81L490.554 155.301L489.561 154.282L489.051 153.772L488.568 153.263L488.219 152.887L487.87 152.512L487.468 152.056L487.065 151.6L486.663 151.144L486.287 150.661L485.911 150.179L485.643 149.83L485.374 149.455L484.838 148.731L484.435 148.167L484.032 147.604L483.496 146.827L483.147 146.317L482.449 145.298L481.134 143.367L480.463 142.402L479.792 141.437L479.47 140.954L479.416 140.9H479.389L479.362 140.847H479.309L479.255 140.793H479.228H479.201H479.175H479.148H479.094V140.82M479.094 140.82H479.067M479.094 140.82L478.155 141.437L479.067 140.82M479.067 140.82L478.155 141.41C477.994 141.517 477.967 141.705 478.074 141.866L478.665 142.751L479.228 143.635L480.382 145.432L482.717 149.133L483.898 151.037L484.677 152.297L485.455 153.557L486.421 155.166L487.387 156.775L488.166 158.063L488.568 158.706L489.159 159.672L489.454 160.154L489.83 160.744L490.125 161.2L490.366 161.549L490.742 162.085L491.145 162.648L491.467 163.077L491.655 163.319L491.923 163.694L492.192 164.096",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.037 168.816L495.063 168.896L495.09 168.95L495.117 169.03L495.144 169.111L495.171 169.298L495.198 169.459V169.567V169.674L495.171 169.915V170.076L495.144 170.237L495.09 170.505L495.063 170.8L495.01 171.095L494.956 171.336L494.929 171.631L494.902 171.819V171.953V172.087V172.221V172.329V172.516L494.929 172.65L494.983 172.811L495.037 172.972L495.09 173.133L495.171 173.294L495.278 173.455L495.359 173.616L495.466 173.75L495.681 174.072L495.842 174.259L496.003 174.447L496.298 174.823L496.593 175.171L496.915 175.493L497.264 175.868L497.613 176.244L498.043 176.673L498.875 177.531L499.411 178.067L500.082 178.738L500.404 179.086L500.726 179.462L501.236 180.025L501.719 180.588L502.203 181.151L502.686 181.741L502.981 182.117L503.249 182.492L503.571 182.921L503.893 183.35L504.296 183.913L504.699 184.476L505.235 185.227L505.584 185.737L506.282 186.756L507.624 188.66L508.268 189.625L508.939 190.59L509.261 191.073L509.288 191.127L509.315 191.154H509.369L509.395 191.18L509.422 191.207H509.476H509.53H509.556H509.61L509.637 191.18L509.691 191.154L510.657 190.537L510.711 190.483L510.737 190.456L510.764 190.43L510.791 190.403V190.349L510.818 190.295V190.242L510.791 190.215V190.161V190.135L510.764 190.081L510.201 189.223L509.664 188.392L508.563 186.702L507.49 184.986L506.416 183.296L505.37 181.58L504.672 180.454L504.001 179.328L502.981 177.638L502.176 176.297L501.397 174.957L500.995 174.286L500.404 173.267L499.841 172.382L499.545 171.9L499.25 171.444L498.928 170.934L498.767 170.693L498.499 170.291L498.23 169.915L497.935 169.513L497.613 169.111L497.318 168.708L497.157 168.494L496.808 167.984",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 517.768,
    cy: 149.293,
    rx: 0.375747,
    ry: 0.375427,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.232 148.623V148.651",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.35 150.555L536.772 151.493",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.651 148.704L537.229 147.766",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.133 148.57L541.119 149.884H541.146L541.683 150.501L541.736 150.555L541.763 150.608L541.79 150.662V150.742V150.796V150.877L541.763 150.984L541.709 151.091L541.656 151.225",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.207 153.397L540.099 153.504L540.019 153.585L539.938 153.638H539.885L539.831 153.692H539.75H539.697H539.643H539.589L538.811 153.424L536.825 152.11C536.637 151.922 536.691 151.788 536.691 151.788V151.681C536.691 151.681 536.798 151.52 536.852 151.386C536.905 151.278 536.959 151.198 536.986 151.144C537.066 151.01 537.174 150.849 537.254 150.662C537.335 150.554 537.389 150.447 537.469 150.34C537.576 150.152 537.711 149.991 537.818 149.804C537.898 149.723 537.952 149.589 538.033 149.482C538.14 149.321 538.247 149.16 538.355 149.053C538.408 148.999 538.462 148.919 538.543 148.838C538.623 148.731 538.704 148.65 538.757 148.597C538.972 148.355 539.187 148.543 539.187 148.543",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.15 163.292L559.076 162.594L558.593 162.273L555.775 160.396C555.775 160.396 555.319 160.878 554.862 161.522C554.406 162.165 554.111 162.755 554.164 162.809L557.466 164.981L558.539 165.678",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.245 162.675L540.154 153.343C540.154 153.343 540.557 152.539 540.772 152.19C540.986 151.841 541.577 151.171 541.577 151.171L555.667 160.503",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.156 167.931C558.781 167.394 558.566 166.751 558.539 166.107C558.539 164.364 559.935 162.943 561.679 162.916C561.921 162.916 562.162 162.916 562.377 162.996",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.793 169.137C562.43 169.754 564.255 168.923 564.873 167.287C565.329 166.107 565.034 164.793 564.121 163.908",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.317 167.475L559.263 167.582L559.209 167.69L559.183 167.797L559.156 167.904L559.129 168.011V168.119L559.156 168.226L559.183 168.333L559.209 168.441L559.263 168.548L559.317 168.628L559.37 168.709L559.451 168.789L559.531 168.87L559.612 168.923L559.639 168.95L559.746 169.004L559.854 169.057L559.961 169.084L560.095 169.111H560.202L560.337 169.084L560.444 169.057L560.551 169.03L560.686 168.977L560.766 168.923L560.873 168.843L560.954 168.762L561.008 168.709L561.061 168.628L563.826 164.445L563.879 164.338L563.906 164.257L563.96 164.15V164.043L563.987 163.935V163.828L563.96 163.721V163.614L563.906 163.506L563.879 163.399L563.826 163.292L563.745 163.211L563.665 163.131L563.584 163.05L563.504 162.997H563.477L563.369 162.916L563.262 162.89L563.155 162.863L563.021 162.836H562.913H562.779L562.672 162.863L562.564 162.89L562.457 162.943L562.35 163.024L562.242 163.077L562.162 163.185L562.108 163.238L562.054 163.292L559.317 167.475Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.376 162.997L562.43 162.836V162.675L562.484 162.514V162.407V162.3V162.165V162.031V161.763L562.43 161.576L562.376 161.227L562.296 160.771V160.583L562.242 160.396V160.235V160.074V159.94V159.806V159.618L562.269 159.43V159.243L562.35 159.082L562.403 158.921L562.484 158.76L562.537 158.653L562.618 158.545L562.752 158.358L562.967 158.036L563.021 157.955L563.262 157.634L563.53 157.312L563.799 157.017L564.067 156.722L564.362 156.4L564.658 156.078L564.899 155.81L565.409 155.301L566.402 154.282L566.912 153.772L567.395 153.263L567.744 152.887L568.093 152.512L568.496 152.056L568.898 151.6L569.301 151.144L569.677 150.661L570.052 150.179L570.321 149.83L570.589 149.455L571.126 148.731L571.528 148.167L571.931 147.604L572.468 146.827L572.817 146.317L573.515 145.298L574.83 143.367L575.501 142.402L576.172 141.437L576.494 140.954L576.547 140.9H576.574L576.601 140.847H576.655L576.708 140.793H576.735H576.762H576.789H576.816H576.869V140.82M576.869 140.82H576.896M576.869 140.82L577.809 141.437L576.896 140.82M576.896 140.82L577.809 141.41C577.97 141.517 577.997 141.705 577.889 141.866L577.299 142.751L576.735 143.635L575.581 145.432L573.246 149.133L572.065 151.037L571.287 152.297L570.509 153.557L569.542 155.166L568.576 156.775L567.798 158.063L567.395 158.706L566.805 159.672L566.51 160.154L566.134 160.744L565.839 161.2L565.597 161.549L565.221 162.085L564.819 162.648L564.497 163.077L564.309 163.319L564.04 163.694L563.772 164.096",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.901 168.816L560.874 168.896L560.847 168.95L560.821 169.03L560.794 169.111L560.767 169.298V169.459V169.567V169.674V169.915V170.076L560.794 170.237L560.847 170.505L560.901 170.8L560.928 171.095L560.982 171.336L561.008 171.631L561.035 171.819V171.953L561.062 172.087V172.221L561.035 172.329V172.516L561.008 172.65L560.955 172.811L560.928 172.972L560.847 173.133L560.767 173.294L560.686 173.455L560.579 173.616L560.472 173.75L560.257 174.072L560.096 174.259L559.962 174.447L559.64 174.823L559.344 175.171L559.049 175.493L558.673 175.868L558.324 176.244L557.895 176.673L557.063 177.531L556.526 178.067L555.882 178.738L555.533 179.086L555.211 179.462L554.701 180.025L554.218 180.588L553.735 181.151L553.252 181.741L552.984 182.117L552.688 182.492L552.366 182.921L552.044 183.35L551.642 183.913L551.239 184.476L550.702 185.227L550.353 185.737L549.655 186.756L548.34 188.66L547.669 189.625L547.025 190.59L546.703 191.073L546.65 191.127L546.623 191.154H546.596L546.569 191.18L546.515 191.207H546.462H546.408H546.381H546.354L546.301 191.18L546.247 191.154L545.281 190.537L545.227 190.483L545.2 190.456L545.173 190.43V190.403L545.146 190.349V190.295V190.242V190.215V190.161L545.173 190.135L545.2 190.081L545.737 189.223L546.301 188.392L547.374 186.702L548.448 184.986L549.521 183.296L550.595 181.58L551.266 180.454L551.964 179.328L552.957 177.638L553.762 176.297L554.54 174.957L554.943 174.286L555.56 173.267L556.097 172.382L556.392 171.9L556.687 171.444L557.009 170.934L557.17 170.693L557.439 170.291L557.707 169.915L558.002 169.513L558.324 169.111L558.62 168.708L558.781 168.494L559.13 167.984",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 538.167,
    cy: 149.293,
    rx: 0.375747,
    ry: 0.375427,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.705 148.623V148.651",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.936 133.284V132.613H515.219V136.099H516.936V135.456H519.11V133.284H516.936Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.938 133.283V135.455",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.416 136.77L506.47 151.492",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.484 136.77L504.511 151.492",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.549 135.321V136.769H504.402V131.942H506.549V133.39",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.469 117.596V131.942",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.51 117.596V131.942",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.953 114.512L506.47 113.976H504.51L504.027 114.512V116.979L504.51 117.596H506.47L506.953 116.979V114.512Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.027 154.575L504.51 155.111H506.47L506.953 154.575V152.108L506.47 151.491H504.51L504.027 152.108V154.575Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.22 135.321H506.444C505.934 135.321 505.531 134.892 505.531 134.356C505.531 133.82 505.934 133.391 506.444 133.391H515.22",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.911 137.708C541.719 137.708 543.185 136.243 543.185 134.437C543.185 132.63 541.719 131.165 539.911 131.165C538.103 131.165 536.637 132.63 536.637 134.437C536.637 136.243 538.103 137.708 539.911 137.708Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.116 136.77L549.062 151.492",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.048 136.77L551.021 151.492",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.955 135.321V136.769H551.129V131.942H548.955V133.39",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.062 117.596V131.942",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.021 117.596V131.942",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.553 114.512L549.063 113.976H551.022L551.505 114.512V116.979L551.022 117.596H549.063L548.553 116.979V114.512Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.505 154.575L551.022 155.111H549.063L548.553 154.575V152.108L549.063 151.491H551.022L551.505 152.108V154.575Z",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.158 135.321H549.063C549.573 135.321 549.975 134.892 549.975 134.356C549.975 133.82 549.573 133.391 549.063 133.391H543.185",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 516.936,
    cy: 133.284,
    rx: 0.375747,
    ry: 0.375427,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.526 136.635C521.043 136.287 520.506 136.072 519.916 135.965H519.486V134.383H536.449V135.16",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.408 136.636L534.167 136.77L533.952 136.931L533.71 137.065L533.522 137.172L533.335 137.279L532.986 137.44L532.61 137.628L532.207 137.762L531.832 137.923L531.429 138.03L531.026 138.137L530.624 138.245L530.221 138.325L529.792 138.406L529.389 138.459L528.96 138.486L528.53 138.513L528.128 138.54H527.698L527.269 138.513L526.84 138.486L526.437 138.432L526.008 138.379L525.578 138.298L525.176 138.218L524.746 138.111L524.531 138.057L524.317 137.977L524.048 137.896L523.753 137.789L523.485 137.682L523.136 137.547L522.814 137.387L522.465 137.199L522.143 137.038L521.847 136.823L521.525 136.636",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.448 135.161V135.912L536.019 135.966C535.428 136.073 534.891 136.287 534.408 136.636",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.825 133.31V131.97C536.825 131.755 536.905 131.567 537.039 131.433L537.576 130.897C537.71 130.763 537.791 130.548 537.791 130.361V122.852C537.791 122.208 537.603 121.592 537.254 121.055L535.348 118.24L534.114 116.416L533.926 116.309C529.981 115.799 525.982 115.799 522.009 116.309C521.929 116.309 521.848 116.363 521.822 116.416L520.587 118.24L518.681 121.055C518.332 121.592 518.145 122.208 518.145 122.852V130.361C518.145 130.575 518.225 130.763 518.359 130.897L518.896 131.433C519.03 131.567 519.111 131.782 519.111 131.97V136.796C519.111 136.957 519.057 137.118 518.95 137.252C518.95 137.279 518.869 137.36 518.869 137.36L518.467 137.762L518.359 137.896C518.225 138.03 518.145 138.245 518.145 138.432V145.941C518.145 146.584 518.332 147.228 518.681 147.764L520.587 150.58L521.875 152.511L522.063 152.618C524.022 152.833 525.982 152.94 527.941 152.94C529.9 152.94 531.859 152.833 533.819 152.618C533.899 152.618 533.98 152.564 534.006 152.511L535.295 150.58L537.2 147.764C537.549 147.228 537.737 146.584 537.737 145.941V138.432C537.737 138.218 537.657 138.03 537.522 137.896L536.986 137.36C536.851 137.226 536.771 137.011 536.771 136.823V135.563",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.002 134.383V116.121",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.824 134.383V116.121",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.174 112.421H534.596L534.65 112.475V116.229V117.141",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.418 116.98V112.475L521.472 112.421H522.76",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.174 112.796V112.179C532.772 111.348 532.181 110.463 531.51 109.9C531.161 109.632 530.759 109.417 530.356 109.229H525.633C525.23 109.417 524.827 109.632 524.478 109.9C523.781 110.49 523.163 111.402 522.814 112.26V112.796",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.518 116.175V113.949C522.518 113.627 522.571 113.332 522.679 113.037C522.947 112.26 523.564 111.643 524.343 111.375C524.638 111.268 524.933 111.214 525.255 111.214H530.703C531.026 111.214 531.321 111.268 531.616 111.375C532.394 111.643 532.985 112.26 533.28 113.037C533.387 113.332 533.441 113.654 533.441 113.949V116.175",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.134 115.961V114.62C531.134 114.03 530.651 113.521 530.034 113.521H525.874C525.283 113.521 524.773 114.003 524.773 114.62V115.961",
    stroke: "#676767",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.311 267.204H595.092",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.732 271.414L273.104 267.177L283.732 262.94V271.414Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.389 262.967L602.017 267.204L591.389 271.441V262.967Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.074 254H405.074V282H477.074V254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.033 49.2422V216.549",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.793 54.6319L669.034 44.0127L673.274 54.6319H664.793Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.274 212.848L669.034 223.467L664.793 212.848H673.274Z",
    fill: "#2360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.074 166V100H653.074V166H683.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.779 276.239C414.654 276.239 413.651 276.045 412.77 275.659C411.895 275.273 411.199 274.736 410.682 274.048C410.171 273.355 409.892 272.551 409.847 271.636H411.995C412.04 272.199 412.233 272.685 412.574 273.094C412.915 273.497 413.361 273.81 413.912 274.031C414.463 274.253 415.074 274.364 415.745 274.364C416.495 274.364 417.159 274.233 417.739 273.972C418.319 273.71 418.773 273.347 419.103 272.881C419.432 272.415 419.597 271.875 419.597 271.261C419.597 270.619 419.438 270.054 419.12 269.565C418.801 269.071 418.336 268.685 417.722 268.406C417.108 268.128 416.358 267.989 415.472 267.989H414.074V266.114H415.472C416.165 266.114 416.773 265.989 417.296 265.739C417.824 265.489 418.236 265.136 418.532 264.682C418.833 264.227 418.983 263.693 418.983 263.08C418.983 262.489 418.853 261.974 418.591 261.537C418.33 261.099 417.961 260.759 417.483 260.514C417.012 260.27 416.455 260.148 415.813 260.148C415.211 260.148 414.642 260.259 414.108 260.48C413.58 260.696 413.148 261.011 412.813 261.426C412.478 261.835 412.296 262.33 412.267 262.909H410.222C410.256 261.994 410.532 261.193 411.049 260.506C411.566 259.812 412.242 259.273 413.077 258.886C413.918 258.5 414.841 258.307 415.847 258.307C416.926 258.307 417.853 258.526 418.625 258.963C419.398 259.395 419.992 259.966 420.407 260.676C420.821 261.386 421.029 262.153 421.029 262.977C421.029 263.96 420.77 264.798 420.253 265.491C419.742 266.185 419.046 266.665 418.165 266.932V267.068C419.267 267.25 420.128 267.719 420.748 268.474C421.367 269.224 421.676 270.153 421.676 271.261C421.676 272.21 421.418 273.062 420.901 273.818C420.39 274.568 419.691 275.159 418.804 275.591C417.918 276.023 416.909 276.239 415.779 276.239ZM427.657 273.614L427.521 274.534C427.424 275.182 427.277 275.875 427.078 276.614C426.885 277.352 426.683 278.048 426.473 278.702C426.262 279.355 426.089 279.875 425.953 280.261H424.419C424.493 279.898 424.589 279.418 424.708 278.821C424.828 278.224 424.947 277.557 425.066 276.818C425.191 276.085 425.294 275.335 425.373 274.568L425.475 273.614H427.657ZM431.35 276V274.466L437.111 268.159C437.787 267.42 438.344 266.778 438.782 266.233C439.219 265.682 439.543 265.165 439.753 264.682C439.969 264.193 440.077 263.682 440.077 263.148C440.077 262.534 439.929 262.003 439.634 261.554C439.344 261.105 438.946 260.759 438.441 260.514C437.935 260.27 437.367 260.148 436.736 260.148C436.066 260.148 435.48 260.287 434.98 260.565C434.486 260.838 434.103 261.222 433.83 261.716C433.563 262.21 433.429 262.79 433.429 263.455H431.418C431.418 262.432 431.654 261.534 432.125 260.761C432.597 259.989 433.239 259.386 434.051 258.955C434.87 258.523 435.787 258.307 436.804 258.307C437.827 258.307 438.733 258.523 439.523 258.955C440.313 259.386 440.932 259.969 441.381 260.702C441.83 261.435 442.054 262.25 442.054 263.148C442.054 263.79 441.938 264.418 441.705 265.031C441.478 265.639 441.08 266.318 440.512 267.068C439.949 267.812 439.168 268.722 438.168 269.795L434.248 273.989V274.125H442.361V276H431.35ZM451.574 276.239C450.29 276.239 449.196 275.889 448.293 275.19C447.39 274.486 446.699 273.466 446.222 272.131C445.745 270.79 445.506 269.17 445.506 267.273C445.506 265.386 445.745 263.776 446.222 262.44C446.705 261.099 447.398 260.077 448.301 259.372C449.211 258.662 450.301 258.307 451.574 258.307C452.847 258.307 453.935 258.662 454.838 259.372C455.748 260.077 456.441 261.099 456.918 262.44C457.401 263.776 457.642 265.386 457.642 267.273C457.642 269.17 457.404 270.79 456.926 272.131C456.449 273.466 455.759 274.486 454.855 275.19C453.952 275.889 452.858 276.239 451.574 276.239ZM451.574 274.364C452.847 274.364 453.836 273.75 454.54 272.523C455.245 271.295 455.597 269.545 455.597 267.273C455.597 265.761 455.435 264.474 455.111 263.412C454.793 262.349 454.333 261.54 453.73 260.983C453.134 260.426 452.415 260.148 451.574 260.148C450.313 260.148 449.327 260.77 448.617 262.014C447.907 263.253 447.551 265.006 447.551 267.273C447.551 268.784 447.711 270.068 448.029 271.125C448.347 272.182 448.804 272.986 449.401 273.537C450.003 274.088 450.728 274.364 451.574 274.364ZM466.574 276.239C465.29 276.239 464.196 275.889 463.293 275.19C462.39 274.486 461.699 273.466 461.222 272.131C460.745 270.79 460.506 269.17 460.506 267.273C460.506 265.386 460.745 263.776 461.222 262.44C461.705 261.099 462.398 260.077 463.301 259.372C464.211 258.662 465.301 258.307 466.574 258.307C467.847 258.307 468.935 258.662 469.838 259.372C470.748 260.077 471.441 261.099 471.918 262.44C472.401 263.776 472.642 265.386 472.642 267.273C472.642 269.17 472.404 270.79 471.926 272.131C471.449 273.466 470.759 274.486 469.855 275.19C468.952 275.889 467.858 276.239 466.574 276.239ZM466.574 274.364C467.847 274.364 468.836 273.75 469.54 272.523C470.245 271.295 470.597 269.545 470.597 267.273C470.597 265.761 470.435 264.474 470.111 263.412C469.793 262.349 469.333 261.54 468.73 260.983C468.134 260.426 467.415 260.148 466.574 260.148C465.313 260.148 464.327 260.77 463.617 262.014C462.907 263.253 462.551 265.006 462.551 267.273C462.551 268.784 462.711 270.068 463.029 271.125C463.347 272.182 463.804 272.986 464.401 273.537C465.003 274.088 465.728 274.364 466.574 274.364Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.037 40.7412V279.111",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.352 40.7412V279.111",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.52 42.082H683.499",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.52 226.471H683.499",
    stroke: "#2360AD",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.529 109.943H659.074V107.83H674.313V107.727L671.483 103.466H673.631L676.529 107.83V109.943ZM661.461 116.966L660.54 116.83C659.892 116.733 659.199 116.585 658.461 116.386C657.722 116.193 657.026 115.991 656.373 115.781C655.719 115.571 655.199 115.398 654.813 115.261V113.727C655.176 113.801 655.657 113.898 656.253 114.017C656.85 114.136 657.517 114.256 658.256 114.375C658.989 114.5 659.739 114.602 660.506 114.682L661.461 114.784V116.966ZM676.767 126.051C676.762 126.767 676.625 127.483 676.358 128.199C676.091 128.915 675.648 129.568 675.029 130.159C674.415 130.75 673.577 131.224 672.515 131.582C671.452 131.94 670.12 132.119 668.517 132.119C666.966 132.119 665.588 131.972 664.384 131.676C663.185 131.386 662.174 130.966 661.35 130.415C660.526 129.869 659.901 129.205 659.475 128.42C659.049 127.642 658.836 126.761 658.836 125.778C658.836 124.801 659.029 123.929 659.415 123.162C659.807 122.401 660.35 121.776 661.043 121.287C661.742 120.804 662.551 120.494 663.472 120.358V122.438C662.671 122.625 662.009 122.997 661.486 123.554C660.969 124.116 660.711 124.858 660.711 125.778C660.711 127.125 661.299 128.188 662.475 128.966C663.651 129.75 665.313 130.142 667.461 130.142V130.006C666.983 129.688 666.571 129.31 666.225 128.872C665.878 128.435 665.611 127.949 665.424 127.415C665.236 126.881 665.142 126.313 665.142 125.71C665.142 124.71 665.39 123.793 665.884 122.957C666.384 122.128 667.069 121.463 667.938 120.963C668.813 120.469 669.813 120.222 670.938 120.222C672.006 120.222 672.983 120.46 673.87 120.938C674.762 121.42 675.472 122.097 676 122.966C676.529 123.841 676.784 124.869 676.767 126.051ZM674.892 126.051C674.892 125.335 674.713 124.69 674.355 124.116C674.003 123.548 673.526 123.097 672.924 122.761C672.327 122.432 671.665 122.267 670.938 122.267C670.211 122.267 669.549 122.426 668.952 122.744C668.361 123.068 667.89 123.509 667.537 124.065C667.191 124.628 667.017 125.267 667.017 125.983C667.017 126.523 667.123 127.026 667.333 127.491C667.549 127.957 667.841 128.364 668.211 128.71C668.586 129.063 669.009 129.338 669.48 129.537C669.958 129.736 670.455 129.835 670.972 129.835C671.654 129.835 672.293 129.67 672.89 129.341C673.486 129.017 673.969 128.568 674.338 127.994C674.708 127.426 674.892 126.778 674.892 126.051ZM658.836 141.164C658.836 139.88 659.185 138.786 659.884 137.883C660.588 136.979 661.608 136.289 662.944 135.812C664.284 135.335 665.904 135.096 667.801 135.096C669.688 135.096 671.299 135.335 672.634 135.812C673.975 136.295 674.998 136.988 675.702 137.891C676.412 138.8 676.767 139.891 676.767 141.164C676.767 142.437 676.412 143.525 675.702 144.428C674.998 145.337 673.975 146.031 672.634 146.508C671.299 146.991 669.688 147.232 667.801 147.232C665.904 147.232 664.284 146.994 662.944 146.516C661.608 146.039 660.588 145.349 659.884 144.445C659.185 143.542 658.836 142.448 658.836 141.164ZM660.711 141.164C660.711 142.437 661.324 143.425 662.551 144.13C663.779 144.835 665.529 145.187 667.801 145.187C669.313 145.187 670.6 145.025 671.662 144.701C672.725 144.383 673.534 143.923 674.091 143.32C674.648 142.724 674.926 142.005 674.926 141.164C674.926 139.903 674.304 138.917 673.06 138.207C671.821 137.496 670.069 137.141 667.801 137.141C666.29 137.141 665.006 137.3 663.949 137.619C662.892 137.937 662.088 138.394 661.537 138.991C660.986 139.593 660.711 140.317 660.711 141.164ZM658.836 156.164C658.836 154.88 659.185 153.786 659.884 152.883C660.588 151.979 661.608 151.289 662.944 150.812C664.284 150.335 665.904 150.096 667.801 150.096C669.688 150.096 671.299 150.335 672.634 150.812C673.975 151.295 674.998 151.988 675.702 152.891C676.412 153.8 676.767 154.891 676.767 156.164C676.767 157.437 676.412 158.525 675.702 159.428C674.998 160.337 673.975 161.031 672.634 161.508C671.299 161.991 669.688 162.232 667.801 162.232C665.904 162.232 664.284 161.994 662.944 161.516C661.608 161.039 660.588 160.349 659.884 159.445C659.185 158.542 658.836 157.448 658.836 156.164ZM660.711 156.164C660.711 157.437 661.324 158.425 662.551 159.13C663.779 159.835 665.529 160.187 667.801 160.187C669.313 160.187 670.6 160.025 671.662 159.701C672.725 159.383 673.534 158.923 674.091 158.32C674.648 157.724 674.926 157.005 674.926 156.164C674.926 154.903 674.304 153.917 673.06 153.207C671.821 152.496 670.069 152.141 667.801 152.141C666.29 152.141 665.006 152.3 663.949 152.619C662.892 152.937 662.088 153.394 661.537 153.991C660.986 154.593 660.711 155.317 660.711 156.164Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6840_18154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 683,
    height: 295.22,
    fill: "white",
    transform: "translate(0.5 0.785156)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneStationSpec1);
export default __webpack_public_path__ + "static/media/droneStationSpec1.eef8ef9e05ffdece425b880f06757687.svg";
export { ForwardRef as ReactComponent };